export const I18N_KEYS = {
  WORKSHOP_PAGE: {
    TITLE: 'WORKSHOP_PAGE_TITLE',
    SIGN_IN: 'WORKSHOP_PAGE_SIGN_IN',
    SIGN_IN_INTRO: 'WORKSHOP_PAGE_SIGN_IN_INTRO',
    INTRO: 'WORKSHOP_PAGE_INTRO',
    JOINING_AS: 'WORKSHOP_PAGE_JOINING_AS',
    CODE_LABEL: 'WORKSHOP_PAGE_CODE_LABEL',
    SUBMIT: 'WORKSHOP_PAGE_SUBMIT',
    PENDING: 'WORKSHOP_PAGE_PENDING',
    SUCCESS: 'WORKSHOP_PAGE_SUCCESS',
    ALREADY_GRANTED: 'WORKSHOP_PAGE_ALREADY_GRANTED',
    START_CREATING: 'WORKSHOP_PAGE_START_CREATING',
    INVALID_CODE: 'WORKSHOP_PAGE_INVALID_CODE',
    SESSION_EXPIRED: 'WORKSHOP_PAGE_SESSION_EXPIRED',
    CLAIM_FAILED: 'WORKSHOP_PAGE_CLAIM_FAILED',
  },
  ACTIONS_BAR: {
    NAVIGATE_ARIA: 'ACTIONS_BAR_NAVIGATE_ARIA',
    PAN_ARIA: 'ACTIONS_BAR_PAN_ARIA',
    STICKY_NOTE_ARIA: 'ACTIONS_BAR_STICKY_NOTE_ARIA',
    COMMENTS_ARIA: 'ACTIONS_BAR_COMMENTS_ARIA',
    SHAPES_MENU_ARIA: 'ACTIONS_BAR_SHAPES_MENU_ARIA',
    TEXT_ARIA: 'ACTIONS_BAR_TEXT_ARIA',
    VECTOR_ARIA: 'ACTIONS_BAR_VECTOR_ARIA',
    PEN_INTRO_TITLE: 'ACTIONS_BAR_PEN_INTRO_TITLE',
    PEN_INTRO_CONTENT: 'ACTIONS_BAR_PEN_INTRO_CONTENT',
    PEN_INTRO_CTA: 'ACTIONS_BAR_PEN_INTRO_CTA',
    INSERT_IMAGE_ARIA: 'ACTIONS_BAR_INSERT_IMAGE_ARIA',
    INSERT_IMAGE_ONLY_ARIA: 'ACTIONS_BAR_INSERT_IMAGE_ONLY_ARIA',
    TOOLS_ARIA: 'ACTIONS_BAR_TOOLS_ARIA',
    ZOOM_MENU_ARIA: 'ACTIONS_BAR_ZOOM_MENU_ARIA',
  },
  AGENT_CHAT: {
    COMPOSER: {
      INPUT_ARIA: 'AGENT_CHAT_COMPOSER_INPUT_ARIA',
      PLACEHOLDER_NEW: 'AGENT_CHAT_COMPOSER_PLACEHOLDER_NEW',
      PLACEHOLDER_REPLY: 'AGENT_CHAT_COMPOSER_PLACEHOLDER_REPLY',
      SEND_ARIA: 'AGENT_CHAT_COMPOSER_SEND_ARIA',
      STOP_ARIA: 'AGENT_CHAT_COMPOSER_STOP_ARIA',
      ATTACH_ARIA: 'AGENT_CHAT_COMPOSER_ATTACH_ARIA',
      SELECTION_COUNT: 'AGENT_CHAT_COMPOSER_SELECTION_COUNT',
      SELECTION_FALLBACK: 'AGENT_CHAT_COMPOSER_SELECTION_FALLBACK',
      SELECTION_DISMISS_ARIA: 'AGENT_CHAT_COMPOSER_SELECTION_DISMISS_ARIA',
    },
    ATTACHMENTS: {
      ROW_ARIA: 'AGENT_CHAT_ATTACHMENTS_ROW_ARIA',
      REMOVE_ARIA: 'AGENT_CHAT_ATTACHMENTS_REMOVE_ARIA',
      DROP_TITLE: 'AGENT_CHAT_ATTACHMENTS_DROP_TITLE',
      DROP_DESCRIPTION: 'AGENT_CHAT_ATTACHMENTS_DROP_DESCRIPTION',
      TOO_MANY: 'AGENT_CHAT_ATTACHMENTS_TOO_MANY',
      DOCUMENT_TOO_LARGE: 'AGENT_CHAT_ATTACHMENTS_DOCUMENT_TOO_LARGE',
      UNSUPPORTED: 'AGENT_CHAT_ATTACHMENTS_UNSUPPORTED',
      TYPE_VIDEO: 'AGENT_CHAT_ATTACHMENTS_TYPE_VIDEO',
      TYPE_AUDIO: 'AGENT_CHAT_ATTACHMENTS_TYPE_AUDIO',
      TYPE_3D: 'AGENT_CHAT_ATTACHMENTS_TYPE_3D',
      TYPE_FILE: 'AGENT_CHAT_ATTACHMENTS_TYPE_FILE',
      SCROLL_BACK_ARIA: 'AGENT_CHAT_ATTACHMENTS_SCROLL_BACK_ARIA',
      SCROLL_FORWARD_ARIA: 'AGENT_CHAT_ATTACHMENTS_SCROLL_FORWARD_ARIA',
    },
    CONVERSATION: {
      PANEL_ARIA: 'AGENT_CHAT_CONVERSATION_PANEL_ARIA',
      UNTITLED: 'AGENT_CHAT_CONVERSATION_UNTITLED',
      BACK_ARIA: 'AGENT_CHAT_CONVERSATION_BACK_ARIA',
      BETA: 'AGENT_CHAT_CONVERSATION_BETA',
      NEW_ARIA: 'AGENT_CHAT_CONVERSATION_NEW_ARIA',
      WELCOME: 'AGENT_CHAT_CONVERSATION_WELCOME',
      LOADING: 'AGENT_CHAT_CONVERSATION_LOADING',
      LOG_ARIA: 'AGENT_CHAT_CONVERSATION_LOG_ARIA',
      INTERRUPTED: 'AGENT_CHAT_CONVERSATION_INTERRUPTED',
      THINKING: 'AGENT_CHAT_CONVERSATION_THINKING',
      RESUME_ERROR: 'AGENT_CHAT_CONVERSATION_RESUME_ERROR',
      REPLY_ERROR: 'AGENT_CHAT_CONVERSATION_REPLY_ERROR',
      COPY_PROMPT_ARIA: 'AGENT_CHAT_CONVERSATION_COPY_PROMPT_ARIA',
      ELEMENT_CHIP_DESCRIPTION: 'AGENT_CHAT_CONVERSATION_ELEMENT_CHIP_DESCRIPTION',
      PROMPT_COPIED_ARIA: 'AGENT_CHAT_CONVERSATION_PROMPT_COPIED_ARIA',
      DRAG_PROMPT_TO_CANVAS: 'AGENT_CHAT_CONVERSATION_DRAG_PROMPT_TO_CANVAS',
    },
    RUN_CARD: {
      CREDITS: 'AGENT_CHAT_RUN_CARD_CREDITS',
      RUN: 'AGENT_CHAT_RUN_CARD_RUN',
      STARTED: 'AGENT_CHAT_RUN_CARD_STARTED',
      CANCELED: 'AGENT_CHAT_RUN_CARD_CANCELED',
      SHOW_NODES_ARIA: 'AGENT_CHAT_RUN_CARD_SHOW_NODES_ARIA',
    },
    QUESTION_CARD: {
      OWN_RESPONSE: 'AGENT_CHAT_QUESTION_CARD_OWN_RESPONSE',
    },
    TOOL_CALL: {
      READING_FILE: 'AGENT_CHAT_TOOL_CALL_READING_FILE',
      SEARCHING_FILES: 'AGENT_CHAT_TOOL_CALL_SEARCHING_FILES',
      EDITING_FILE: 'AGENT_CHAT_TOOL_CALL_EDITING_FILE',
      RUNNING_COMMAND: 'AGENT_CHAT_TOOL_CALL_RUNNING_COMMAND',
      LOADING_SKILL: 'AGENT_CHAT_TOOL_CALL_LOADING_SKILL',
      FINDING_MODEL: 'AGENT_CHAT_TOOL_CALL_FINDING_MODEL',
      BROWSING_TOOLS: 'AGENT_CHAT_TOOL_CALL_BROWSING_TOOLS',
      CHECKING_TOOL_INPUTS: 'AGENT_CHAT_TOOL_CALL_CHECKING_TOOL_INPUTS',
      RUNNING_MODEL: 'AGENT_CHAT_TOOL_CALL_RUNNING_MODEL',
      RUNNING_TOOL: 'AGENT_CHAT_TOOL_CALL_RUNNING_TOOL',
      CHECKING_RESULTS: 'AGENT_CHAT_TOOL_CALL_CHECKING_RESULTS',
      CANCELLING_RUN: 'AGENT_CHAT_TOOL_CALL_CANCELLING_RUN',
      UPLOADING_ASSET: 'AGENT_CHAT_TOOL_CALL_UPLOADING_ASSET',
      READING_WORKFLOW: 'AGENT_CHAT_TOOL_CALL_READING_WORKFLOW',
      BUILDING_WORKFLOW: 'AGENT_CHAT_TOOL_CALL_BUILDING_WORKFLOW',
      BROWSING_NODES: 'AGENT_CHAT_TOOL_CALL_BROWSING_NODES',
      CHECKING_PRICE: 'AGENT_CHAT_TOOL_CALL_CHECKING_PRICE',
      WORKING: 'AGENT_CHAT_TOOL_CALL_WORKING',
      WORKED_FOR: 'AGENT_CHAT_TOOL_CALL_WORKED_FOR',
      WORKED: 'AGENT_CHAT_TOOL_CALL_WORKED',
    },
    HISTORY: {
      PANEL_ARIA: 'AGENT_CHAT_HISTORY_PANEL_ARIA',
      TITLE: 'AGENT_CHAT_HISTORY_TITLE',
      NEW_ARIA: 'AGENT_CHAT_HISTORY_NEW_ARIA',
      SEARCH: 'AGENT_CHAT_HISTORY_SEARCH',
      LOAD_ERROR: 'AGENT_CHAT_HISTORY_LOAD_ERROR',
      LOADING: 'AGENT_CHAT_HISTORY_LOADING',
      EMPTY: 'AGENT_CHAT_HISTORY_EMPTY',
      NO_RESULTS: 'AGENT_CHAT_HISTORY_NO_RESULTS',
      NO_RESULTS_ON_PAGE: 'AGENT_CHAT_HISTORY_NO_RESULTS_ON_PAGE',
      ROW_MENU_ARIA: 'AGENT_CHAT_HISTORY_ROW_MENU_ARIA',
      RENAME: 'AGENT_CHAT_HISTORY_RENAME',
      RENAME_ARIA: 'AGENT_CHAT_HISTORY_RENAME_ARIA',
      DELETE: 'AGENT_CHAT_HISTORY_DELETE',
      GROUP_ALL: 'AGENT_CHAT_HISTORY_GROUP_ALL',
      GROUP_TODAY: 'AGENT_CHAT_HISTORY_GROUP_TODAY',
      GROUP_THIS_WEEK: 'AGENT_CHAT_HISTORY_GROUP_THIS_WEEK',
      GROUP_EARLIER: 'AGENT_CHAT_HISTORY_GROUP_EARLIER',
      AGE_NOW: 'AGENT_CHAT_HISTORY_AGE_NOW',
      AGE_MINUTES: 'AGENT_CHAT_HISTORY_AGE_MINUTES',
      AGE_HOURS: 'AGENT_CHAT_HISTORY_AGE_HOURS',
      AGE_DAYS: 'AGENT_CHAT_HISTORY_AGE_DAYS',
      AGE_WEEKS: 'AGENT_CHAT_HISTORY_AGE_WEEKS',
      NO_MESSAGES: 'AGENT_CHAT_HISTORY_NO_MESSAGES',
      MESSAGE_COUNT: 'AGENT_CHAT_HISTORY_MESSAGE_COUNT',
    },
    RECENT_CHATS: {
      TITLE: 'AGENT_CHAT_RECENT_CHATS_TITLE',
      ALL_ARIA: 'AGENT_CHAT_RECENT_CHATS_ALL_ARIA',
      NEW_ARIA: 'AGENT_CHAT_RECENT_CHATS_NEW_ARIA',
      LOADING: 'AGENT_CHAT_RECENT_CHATS_LOADING',
      EMPTY: 'AGENT_CHAT_RECENT_CHATS_EMPTY',
    },
    SUGGESTIONS: {
      ARIA: 'AGENT_CHAT_SUGGESTIONS_ARIA',
      CREATE: 'AGENT_CHAT_SUGGESTIONS_CREATE',
      CREATE_SOCIAL: 'AGENT_CHAT_SUGGESTIONS_CREATE_SOCIAL',
      CREATE_SOCIAL_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CREATE_SOCIAL_PROMPT',
      CREATE_VIDEO: 'AGENT_CHAT_SUGGESTIONS_CREATE_VIDEO',
      CREATE_VIDEO_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CREATE_VIDEO_PROMPT',
      CREATE_VARIATIONS: 'AGENT_CHAT_SUGGESTIONS_CREATE_VARIATIONS',
      CREATE_VARIATIONS_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CREATE_VARIATIONS_PROMPT',
      PROMPTS: 'AGENT_CHAT_SUGGESTIONS_PROMPTS',
      PROMPTS_CLARITY: 'AGENT_CHAT_SUGGESTIONS_PROMPTS_CLARITY',
      PROMPTS_CLARITY_PROMPT: 'AGENT_CHAT_SUGGESTIONS_PROMPTS_CLARITY_PROMPT',
      PROMPTS_STYLE: 'AGENT_CHAT_SUGGESTIONS_PROMPTS_STYLE',
      PROMPTS_STYLE_PROMPT: 'AGENT_CHAT_SUGGESTIONS_PROMPTS_STYLE_PROMPT',
      PROMPTS_DETAILS: 'AGENT_CHAT_SUGGESTIONS_PROMPTS_DETAILS',
      PROMPTS_DETAILS_PROMPT: 'AGENT_CHAT_SUGGESTIONS_PROMPTS_DETAILS_PROMPT',
      CLEANUP: 'AGENT_CHAT_SUGGESTIONS_CLEANUP',
      CLEANUP_NOTES: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_NOTES',
      CLEANUP_NOTES_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_NOTES_PROMPT',
      CLEANUP_SECTIONS: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_SECTIONS',
      CLEANUP_SECTIONS_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_SECTIONS_PROMPT',
      CLEANUP_OUTPUTS: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_OUTPUTS',
      CLEANUP_OUTPUTS_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_OUTPUTS_PROMPT',
      CLEANUP_UNUSED: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_UNUSED',
      CLEANUP_UNUSED_PROMPT: 'AGENT_CHAT_SUGGESTIONS_CLEANUP_UNUSED_PROMPT',
      LEARN: 'AGENT_CHAT_SUGGESTIONS_LEARN',
      LEARN_EXPLAIN: 'AGENT_CHAT_SUGGESTIONS_LEARN_EXPLAIN',
      LEARN_EXPLAIN_PROMPT: 'AGENT_CHAT_SUGGESTIONS_LEARN_EXPLAIN_PROMPT',
      LEARN_CONNECT: 'AGENT_CHAT_SUGGESTIONS_LEARN_CONNECT',
      LEARN_CONNECT_PROMPT: 'AGENT_CHAT_SUGGESTIONS_LEARN_CONNECT_PROMPT',
      LEARN_MODELS: 'AGENT_CHAT_SUGGESTIONS_LEARN_MODELS',
      LEARN_MODELS_PROMPT: 'AGENT_CHAT_SUGGESTIONS_LEARN_MODELS_PROMPT',
    },
  },
  COMMON_COMPONENTS: {
    MEDIA_BUFFERING: 'COMMON_COMPONENTS_MEDIA_BUFFERING',
    COLOR_PICKER: {
      COLOR_AREA_ARIA: 'COMMON_COMPONENTS_COLOR_PICKER_COLOR_AREA_ARIA',
      EYEDROPPER_ARIA: 'COMMON_COMPONENTS_COLOR_PICKER_EYEDROPPER_ARIA',
      HUE_ARIA: 'COMMON_COMPONENTS_COLOR_PICKER_HUE_ARIA',
      OPACITY_ARIA: 'COMMON_COMPONENTS_COLOR_PICKER_OPACITY_ARIA',
    },
    COPYRIGHT: 'COMMON_COMPONENTS_COPYRIGHT',
    COUNTER: {
      DECREMENT_ARIA: 'COMMON_COMPONENTS_COUNTER_DECREMENT_ARIA',
      INCREMENT_ARIA: 'COMMON_COMPONENTS_COUNTER_INCREMENT_ARIA',
    },
    PROGRESS: {
      DEFAULT_ARIA: 'COMMON_COMPONENTS_PROGRESS_DEFAULT_ARIA',
      UPLOAD_ARIA: 'COMMON_COMPONENTS_PROGRESS_UPLOAD_ARIA',
    },
    VOICE_DICTATION: {
      START: 'COMMON_COMPONENTS_VOICE_DICTATION_START',
      STOP: 'COMMON_COMPONENTS_VOICE_DICTATION_STOP',
      CANCEL: 'COMMON_COMPONENTS_VOICE_DICTATION_CANCEL',
      TRANSCRIBING: 'COMMON_COMPONENTS_VOICE_DICTATION_TRANSCRIBING',
      LISTENING: 'COMMON_COMPONENTS_VOICE_DICTATION_LISTENING',
      RECORDING: 'COMMON_COMPONENTS_VOICE_DICTATION_RECORDING',
      MIC_BLOCKED: 'COMMON_COMPONENTS_VOICE_DICTATION_MIC_BLOCKED',
      MIC_UNAVAILABLE: 'COMMON_COMPONENTS_VOICE_DICTATION_MIC_UNAVAILABLE',
      FAILED: 'COMMON_COMPONENTS_VOICE_DICTATION_FAILED',
      NO_SPEECH: 'COMMON_COMPONENTS_VOICE_DICTATION_NO_SPEECH',
      TOO_SHORT: 'COMMON_COMPONENTS_VOICE_DICTATION_TOO_SHORT',
      PLAN_REQUIRED: 'COMMON_COMPONENTS_VOICE_DICTATION_PLAN_REQUIRED',
      RATE_LIMITED: 'COMMON_COMPONENTS_VOICE_DICTATION_RATE_LIMITED',
    },
    FILE_UPLOADER: {
      CTA: 'COMMON_COMPONENTS_FILE_UPLOADER_CTA',
      UPLOAD_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_UPLOAD_FILE',
      NO_PREVIEW: 'COMMON_COMPONENTS_FILE_UPLOADER_NO_PREVIEW',
      OR: 'COMMON_COMPONENTS_FILE_UPLOADER_OR',
      PASTE_LINK: 'COMMON_COMPONENTS_FILE_UPLOADER_PASTE_LINK',
      REMOVE_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_REMOVE_FILE',
      REPLACE_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_REPLACE_FILE',
      REPLACE: 'COMMON_COMPONENTS_FILE_UPLOADER_REPLACE',
      ADD_FILE: 'COMMON_COMPONENTS_FILE_UPLOADER_ADD_FILE',
      UPLOAD_FROM_LINK: 'COMMON_COMPONENTS_FILE_UPLOADER_UPLOAD_FROM_LINK',
      UNSUPPORTED_VIDEO_FORMAT: 'COMMON_COMPONENTS_FILE_UPLOADER_UNSUPPORTED_VIDEO_FORMAT',
      VIDEO_FORMAT_UNSUPPORTED_IN_BROWSER: 'COMMON_COMPONENTS_FILE_UPLOADER_VIDEO_FORMAT_UNSUPPORTED_IN_BROWSER',
      UPLOAD_ERROR: 'COMMON_COMPONENTS_FILE_UPLOADER_UPLOAD_ERROR',
      UPLOAD_ERROR_HELP: 'COMMON_COMPONENTS_FILE_UPLOADER_UPLOAD_ERROR_HELP',
    },
    NODE_IMAGE_LIST: {
      NO_PREVIEW: 'COMMON_COMPONENTS_NODE_IMAGE_LIST_NO_PREVIEW',
      RESULT: 'COMMON_COMPONENTS_NODE_IMAGE_LIST_RESULT',
    },
    THREE_DEE_VIEWER: {
      ERROR: 'COMMON_COMPONENTS_THREE_DEE_VIEWER_ERROR',
    },
    BASE_SELECT: {
      NO_OPTIONS_TEXT: 'COMMON_COMPONENTS_BASE_SELECT_NO_OPTIONS_TEXT',
    },
    EXPENSIVE_RUN_MODAL: {
      TITLE: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_TITLE',
      SUBTITLE: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_SUBTITLE',
      CHECKBOX_LABEL: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_CHECKBOX_LABEL',
      CTA_CONFIRM: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'COMMON_COMPONENTS_EXPENSIVE_RUN_MODAL_CTA_CANCEL',
    },
    PRICE_INFO: {
      TITLE: 'COMMON_COMPONENTS_PRICE_INFO_TITLE',
      CREDITS: 'COMMON_COMPONENTS_PRICE_INFO_CREDITS',
      CREDITS_PER_SECOND: 'COMMON_COMPONENTS_PRICE_INFO_CREDITS_PER_SECOND',
      FREE_IN_BETA: 'COMMON_COMPONENTS_PRICE_INFO_FREE_IN_BETA',
      BETA_TOOLTIP_STATIC: 'COMMON_COMPONENTS_PRICE_INFO_BETA_TOOLTIP_STATIC',
      BETA_TOOLTIP_DYNAMIC: 'COMMON_COMPONENTS_PRICE_INFO_BETA_TOOLTIP_DYNAMIC',
      PROMO_TOOLTIP: 'COMMON_COMPONENTS_PRICE_INFO_PROMO_TOOLTIP',
      PROMO_TOOLTIP_UNTIL: 'COMMON_COMPONENTS_PRICE_INFO_PROMO_TOOLTIP_UNTIL',
      PROMO_BADGE: 'COMMON_COMPONENTS_PRICE_INFO_PROMO_BADGE',
      PROMO_BADGE_UNTIL: 'COMMON_COMPONENTS_PRICE_INFO_PROMO_BADGE_UNTIL',
    },
  },
  COMPOSITOR: {
    IMAGE_FILL: {
      CONVERT_TO_SHAPE: 'COMPOSITOR_IMAGE_FILL_CONVERT_TO_SHAPE',
      PERSPECTIVE: 'COMPOSITOR_IMAGE_FILL_PERSPECTIVE',
    },
    AI_ACTIONS: {
      INPAINT: 'COMPOSITOR_AI_ACTIONS_INPAINT',
      INPAINT_PROMPT_PLACEHOLDER: 'COMPOSITOR_AI_ACTIONS_INPAINT_PROMPT_PLACEHOLDER',
      BRUSH_SIZE: 'COMPOSITOR_AI_ACTIONS_BRUSH_SIZE',
      MASK_AREA: 'COMPOSITOR_AI_ACTIONS_MASK_AREA',
      MASK_AREA_AND_ADD_PROMPT: 'COMPOSITOR_AI_ACTIONS_MASK_AREA_AND_ADD_PROMPT',
      ADD_PROMPT: 'COMPOSITOR_AI_ACTIONS_ADD_PROMPT',
      SUBMIT: 'COMPOSITOR_AI_ACTIONS_SUBMIT',
      CLEAR_MASK: 'COMPOSITOR_AI_ACTIONS_CLEAR_MASK',
      OUTPAINT: 'COMPOSITOR_AI_ACTIONS_OUTPAINT',
      OUTPAINT_PROMPT_PLACEHOLDER: 'COMPOSITOR_AI_ACTIONS_OUTPAINT_PROMPT_PLACEHOLDER',
      FIT_TO_IMAGE: 'COMPOSITOR_AI_ACTIONS_FIT_TO_IMAGE',
      EXTEND_IMAGE: 'COMPOSITOR_AI_ACTIONS_EXTEND_IMAGE',
      DECOMPOSE_LAYER: 'COMPOSITOR_AI_ACTIONS_DECOMPOSE_LAYER',
      TOOLBAR_ARIA: 'COMPOSITOR_AI_ACTIONS_TOOLBAR_ARIA',
      NUMBER_OF_LAYERS: 'COMPOSITOR_AI_ACTIONS_NUMBER_OF_LAYERS',
      RUN: 'COMPOSITOR_AI_ACTIONS_RUN',
      RUNNING: 'COMPOSITOR_AI_ACTIONS_RUNNING',
      SUCCESS: 'COMPOSITOR_AI_ACTIONS_SUCCESS',
      SUCCEEDED: 'COMPOSITOR_AI_ACTIONS_SUCCEEDED',
      GO_TO_LAYER: 'COMPOSITOR_AI_ACTIONS_GO_TO_LAYER',
      ERROR: 'COMPOSITOR_AI_ACTIONS_ERROR',
      INVALID_COUNT: 'COMPOSITOR_AI_ACTIONS_INVALID_COUNT',
      ERRORS: {
        WORKFLOW_REQUIRED: 'COMPOSITOR_AI_ACTIONS_WORKFLOW_REQUIRED',
        SOURCE_UNAVAILABLE: 'COMPOSITOR_AI_ACTIONS_SOURCE_UNAVAILABLE',
        SOURCE_NOT_UPLOADED: 'COMPOSITOR_AI_ACTIONS_SOURCE_NOT_UPLOADED',
        SOURCE_CHANGED: 'COMPOSITOR_AI_ACTIONS_SOURCE_CHANGED',
        ALREADY_RUNNING: 'COMPOSITOR_AI_ACTIONS_ALREADY_RUNNING',
        EMPTY_RESULT: 'COMPOSITOR_AI_ACTIONS_EMPTY_RESULT',
        INVALID_RESULT: 'COMPOSITOR_AI_ACTIONS_INVALID_RESULT',
        APPLY_FAILED: 'COMPOSITOR_AI_ACTIONS_APPLY_FAILED',
        CANCELLATION_FAILED: 'COMPOSITOR_AI_ACTIONS_CANCELLATION_FAILED',
      },
      MODEL_ERRORS: {
        FAILED: 'COMPOSITOR_AI_ACTIONS_MODEL_FAILED',
        CANCELED: 'COMPOSITOR_AI_ACTIONS_MODEL_CANCELED',
        TIMEOUT: 'COMPOSITOR_AI_ACTIONS_MODEL_TIMEOUT',
        MISSING_PREDICTION: 'COMPOSITOR_AI_ACTIONS_MODEL_MISSING_PREDICTION',
        PROVIDER: 'COMPOSITOR_AI_ACTIONS_MODEL_PROVIDER_ERROR',
        PREDICTION: 'COMPOSITOR_AI_ACTIONS_MODEL_PREDICTION_ERROR',
      },
    },
    MISSING_URL_TOOLTIP: 'COMPOSITOR_MISSING_URL_TOOLTIP',
    ADD_CONTENT: {
      UPLOADING_FILE: 'COMPOSITOR_ADD_CONTENT_UPLOADING_FILE',
      UPLOADING_IMAGE: 'COMPOSITOR_ADD_CONTENT_UPLOADING_IMAGE',
      UPLOADING_IMAGES: 'COMPOSITOR_ADD_CONTENT_UPLOADING_IMAGES',
      UPLOADING_VIDEOS: 'COMPOSITOR_ADD_CONTENT_UPLOADING_VIDEOS',
      UPLOADING_AUDIO_FILES: 'COMPOSITOR_ADD_CONTENT_UPLOADING_AUDIO_FILES',
      UPLOADING_FILES: 'COMPOSITOR_ADD_CONTENT_UPLOADING_FILES',
      UPLOAD_IN_PROGRESS: 'COMPOSITOR_ADD_CONTENT_UPLOAD_IN_PROGRESS',
    },
    MISSING_WORKSPACE_FONTS_MODAL: {
      TITLE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_TITLE',
      DESCRIPTION: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_DESCRIPTION',
      CONTINUE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_CONTINUE',
      COLUMN_MISSING: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_COLUMN_MISSING',
      COLUMN_REPLACEMENT: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_COLUMN_REPLACEMENT',
      SELECT_FONT: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_SELECT_FONT',
      MIXED_REPLACEMENT_FONT: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_MIXED_REPLACEMENT_FONT',
      SELECT_STYLE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_SELECT_STYLE',
      REPLACE: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_REPLACE',
      MANAGE_WORKSPACE_FONTS: 'COMPOSITOR_MISSING_WORKSPACE_FONTS_MODAL_MANAGE_WORKSPACE_FONTS',
    },
    LAYER_PANEL: {
      TITLE: 'COMPOSITOR_LAYER_PANEL_TITLE',
    },
    PANEL_SWITCH: {
      LAYERS_ARIA: 'COMPOSITOR_PANEL_SWITCH_LAYERS_ARIA',
      ASSETS_ARIA: 'COMPOSITOR_PANEL_SWITCH_ASSETS_ARIA',
    },
    ASSETS_PANEL: {
      TITLE: 'COMPOSITOR_ASSETS_PANEL_TITLE',
      SECTION_IMAGE: 'COMPOSITOR_ASSETS_PANEL_SECTION_IMAGE',
      SECTION_VIDEO: 'COMPOSITOR_ASSETS_PANEL_SECTION_VIDEO',
      SECTION_AUDIO: 'COMPOSITOR_ASSETS_PANEL_SECTION_AUDIO',
      FILTER_TYPE_ALL: 'COMPOSITOR_ASSETS_PANEL_FILTER_TYPE_ALL',
      FILTER_TYPE_IMAGE: 'COMPOSITOR_ASSETS_PANEL_FILTER_TYPE_IMAGE',
      FILTER_TYPE_VIDEO: 'COMPOSITOR_ASSETS_PANEL_FILTER_TYPE_VIDEO',
      FILTER_TYPE_AUDIO: 'COMPOSITOR_ASSETS_PANEL_FILTER_TYPE_AUDIO',
      EMPTY_TITLE: 'COMPOSITOR_ASSETS_PANEL_EMPTY_TITLE',
      EMPTY_DESCRIPTION: 'COMPOSITOR_ASSETS_PANEL_EMPTY_DESCRIPTION',
      EMPTY_CONNECTED_TITLE: 'COMPOSITOR_ASSETS_PANEL_EMPTY_CONNECTED_TITLE',
      EMPTY_CONNECTED_DESCRIPTION: 'COMPOSITOR_ASSETS_PANEL_EMPTY_CONNECTED_DESCRIPTION',
      EMPTY_UPLOADED_TITLE: 'COMPOSITOR_ASSETS_PANEL_EMPTY_UPLOADED_TITLE',
      EMPTY_UPLOADED_DESCRIPTION: 'COMPOSITOR_ASSETS_PANEL_EMPTY_UPLOADED_DESCRIPTION',
      EMPTY_TYPE_IMAGE_TITLE: 'COMPOSITOR_ASSETS_PANEL_EMPTY_TYPE_IMAGE_TITLE',
      EMPTY_TYPE_VIDEO_TITLE: 'COMPOSITOR_ASSETS_PANEL_EMPTY_TYPE_VIDEO_TITLE',
      EMPTY_TYPE_AUDIO_TITLE: 'COMPOSITOR_ASSETS_PANEL_EMPTY_TYPE_AUDIO_TITLE',
      EMPTY_TYPE_DESCRIPTION: 'COMPOSITOR_ASSETS_PANEL_EMPTY_TYPE_DESCRIPTION',
      FILTER_SOURCE: 'COMPOSITOR_ASSETS_PANEL_FILTER_SOURCE',
      FILTER_SOURCE_CONNECTED: 'COMPOSITOR_ASSETS_PANEL_FILTER_SOURCE_CONNECTED',
      FILTER_SOURCE_UPLOADED: 'COMPOSITOR_ASSETS_PANEL_FILTER_SOURCE_UPLOADED',
      FILTER_SOURCE_ALL: 'COMPOSITOR_ASSETS_PANEL_FILTER_SOURCE_ALL',
      CONNECTED_TOOLTIP: 'COMPOSITOR_ASSETS_PANEL_CONNECTED_TOOLTIP',
      USED_BY_LAYERS_TOOLTIP: 'COMPOSITOR_ASSETS_PANEL_USED_BY_LAYERS_TOOLTIP',
      DELETE: 'COMPOSITOR_ASSETS_PANEL_DELETE',
      UNTITLED_IMAGE: 'COMPOSITOR_ASSETS_PANEL_UNTITLED_IMAGE',
      UNTITLED_VIDEO: 'COMPOSITOR_ASSETS_PANEL_UNTITLED_VIDEO',
      UNTITLED_AUDIO: 'COMPOSITOR_ASSETS_PANEL_UNTITLED_AUDIO',
      DELETE_DIALOG_TITLE: 'COMPOSITOR_ASSETS_PANEL_DELETE_DIALOG_TITLE',
      DELETE_DIALOG_MESSAGE: 'COMPOSITOR_ASSETS_PANEL_DELETE_DIALOG_MESSAGE',
      DELETE_DIALOG_CONFIRM: 'COMPOSITOR_ASSETS_PANEL_DELETE_DIALOG_CONFIRM',
      DELETE_DIALOG_DONT_SHOW: 'COMPOSITOR_ASSETS_PANEL_DELETE_DIALOG_DONT_SHOW',
      SHOW_ON_CANVAS: 'COMPOSITOR_ASSETS_PANEL_SHOW_ON_CANVAS',
    },
    CONTEXT_MENU: {
      GROUP: 'COMPOSITOR_CONTEXT_MENU_GROUP',
      UNGROUP: 'COMPOSITOR_CONTEXT_MENU_UNGROUP',
      DELETE: 'COMPOSITOR_CONTEXT_MENU_DELETE',
      DUPLICATE: 'COMPOSITOR_CONTEXT_MENU_DUPLICATE',
      COPY: 'COMPOSITOR_CONTEXT_MENU_COPY',
      ADD_FADE: 'COMPOSITOR_CONTEXT_MENU_ADD_FADE',
    },
    LAYER_PANEL_ROW: {
      CANVAS_LAYER_NAME: 'COMPOSITOR_LAYER_PANEL_ROW_CANVAS_LAYER_NAME',
    },
    LAYER_PROPERTY_PANEL: {
      BLEND_MODE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE',
      MODE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_MODE',
      IMAGE_MODE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_IMAGE_MODE',
      IMAGE_MODES: {
        STRETCH: 'COMPOSITOR_LAYER_PROPERTY_PANEL_IMAGE_MODE_STRETCH',
        FIT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_IMAGE_MODE_FIT',
        FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_IMAGE_MODE_FILL',
      },
      FLIP: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FLIP',
      OPEN_COLOR_PICKER_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_OPEN_COLOR_PICKER_ARIA',
      ALIGNMENT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGNMENT',
      DISTRIBUTION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_DISTRIBUTION',
      HORIZONTAL_TEXT_ALIGNMENT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_HORIZONTAL_TEXT_ALIGNMENT',
      VERTICAL_TEXT_ALIGNMENT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_VERTICAL_TEXT_ALIGNMENT',
      CANVAS_LAYER_NAME: 'COMPOSITOR_LAYER_PROPERTY_PANEL_CANVAS_LAYER_NAME',
      MULTI_SELECTION_HEADER: 'COMPOSITOR_LAYER_PROPERTY_PANEL_MULTI_SELECTION_HEADER',
      DIMENSIONS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_DIMENSIONS',
      WIDTH_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_WIDTH_ARIA',
      HEIGHT_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_HEIGHT_ARIA',
      POSITION_X_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_POSITION_X_ARIA',
      POSITION_Y_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_POSITION_Y_ARIA',
      CANVAS_WIDTH_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_CANVAS_WIDTH_ARIA',
      CANVAS_HEIGHT_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_CANVAS_HEIGHT_ARIA',
      BACKGROUND_COLOR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BACKGROUND_COLOR',
      ADD_BACKGROUND: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ADD_BACKGROUND',
      REMOVE_BACKGROUND: 'COMPOSITOR_LAYER_PROPERTY_PANEL_REMOVE_BACKGROUND',
      FADE: {
        TITLE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_TITLE',
        IN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_IN',
        OUT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_OUT',
        REMOVE_IN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_REMOVE_IN',
        REMOVE_OUT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_REMOVE_OUT',
        HIDE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_HIDE',
        SHOW: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_SHOW',
        PICTURE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_PICTURE',
        AUDIO: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_AUDIO',
        DURATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_DURATION',
        EASING: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_EASING',
        SECONDS_SHORT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_SECONDS_SHORT',
        DURATION_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_DURATION_ARIA',
        DURATION_IN_SECONDS_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_DURATION_IN_SECONDS_ARIA',
        DURATION_IN_FRAMES_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_DURATION_IN_FRAMES_ARIA',
        DURATION_UNIT_SECONDS_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_DURATION_UNIT_SECONDS_ARIA',
        DURATION_UNIT_FRAMES_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_DURATION_UNIT_FRAMES_ARIA',
        EASING_ARIA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_EASING_ARIA',
        LINEAR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_LINEAR',
        EASE_IN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_EASE_IN',
        EASE_OUT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_EASE_OUT',
        EASE_IN_OUT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FADE_EASE_IN_OUT',
      },
      EFFECTS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECTS',
      ADD_EFFECT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ADD_EFFECT',
      REMOVE_EFFECT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_REMOVE_EFFECT',
      SHOW_EFFECT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_SHOW_EFFECT',
      HIDE_EFFECT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_HIDE_EFFECT',
      EFFECT_TYPES: {
        BLUR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_TYPES_BLUR',
        COLOR_CORRECTION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_TYPES_COLOR_CORRECTION',
        INVERT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_TYPES_INVERT',
        LEVELS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_TYPES_LEVELS',
      },
      EFFECT_OPTIONS: {
        CLOSE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_CLOSE',
        BLUR_TYPE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_BLUR_TYPE',
        BLUR_SIZE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_BLUR_SIZE',
        CHANNEL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_CHANNEL',
        EXPOSURE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_EXPOSURE',
        CONTRAST: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_CONTRAST',
        SATURATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_SATURATION',
        TEMPERATURE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_TEMPERATURE',
        TINT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_TINT',
        HIGHLIGHTS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_HIGHLIGHTS',
        SHADOWS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_SHADOWS',
        INPUT_MIN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_INPUT_MIN',
        INPUT_MAX: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_INPUT_MAX',
        GAMMA: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_GAMMA',
        OUTPUT_MIN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_OUTPUT_MIN',
        OUTPUT_MAX: 'COMPOSITOR_LAYER_PROPERTY_PANEL_EFFECT_OPTIONS_OUTPUT_MAX',
      },
      ADD_FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ADD_FILL',
      REMOVE_FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_REMOVE_FILL',
      SHOW_FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_SHOW_FILL',
      HIDE_FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_HIDE_FILL',
      STROKE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE',
      ADD_STROKE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ADD_STROKE',
      REMOVE_STROKE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_REMOVE_STROKE',
      SHOW_STROKE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_SHOW_STROKE',
      HIDE_STROKE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_HIDE_STROKE',
      STROKE_WEIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_WEIGHT',
      STROKE_POSITION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_POSITION',
      STROKE_POSITIONS: {
        INSIDE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_POSITIONS_INSIDE',
        CENTER: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_POSITIONS_CENTER',
        OUTSIDE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_POSITIONS_OUTSIDE',
      },
      STROKE_JOIN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_JOIN',
      STROKE_JOINS: {
        MITER: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_JOINS_MITER',
        ROUND: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_JOINS_ROUND',
        BEVEL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_JOINS_BEVEL',
      },
      STROKE_CAP: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_CAP',
      STROKE_CAPS: {
        BUTT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_CAPS_BUTT',
        SQUARE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_CAPS_SQUARE',
        ROUND: 'COMPOSITOR_LAYER_PROPERTY_PANEL_STROKE_CAPS_ROUND',
      },
      TIMELINE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_TIMELINE',
      TIMELINE_INFO: 'COMPOSITOR_LAYER_PROPERTY_PANEL_TIMELINE_INFO',
      DURATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_DURATION',
      FIT_TO_CONTENT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FIT_TO_CONTENT',
      FPS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FPS',
      FILL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FILL',
      FONT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT',
      FONT_LETTER_SPACING: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_LETTER_SPACING',
      FONT_LINE_HEIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_LINE_HEIGHT',
      FONT_SIZE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SIZE',
      FONT_STYLE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_STYLE',
      OPACITY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_OPACITY',
      VOLUME: 'COMPOSITOR_LAYER_PROPERTY_PANEL_VOLUME',
      POSITION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_POSITION',
      APPEARANCE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_APPEARANCE',
      ROTATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ROTATION',
      FONT_WEIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHT',
      FONT_ALIGN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_ALIGN',
      BLEND_MODES: {
        NORMAL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_NORMAL',
        MULTIPLY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_MULTIPLY',
        SCREEN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_SCREEN',
        OVERLAY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_OVERLAY',
        DARKEN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_DARKEN',
        LIGHTEN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_LIGHTEN',
        COLOR_DODGE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_COLOR_DODGE',
        COLOR_BURN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_COLOR_BURN',
        HARD_LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_HARD_LIGHT',
        SOFT_LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_SOFT_LIGHT',
        DIFFERENCE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_DIFFERENCE',
        EXCLUSION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_EXCLUSION',
        HUE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_HUE',
        SATURATION: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_SATURATION',
        COLOR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_COLOR',
        LUMINOSITY: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_LUMINOSITY',
        ADD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_ADD',
        DIVIDE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_BLEND_MODE_DIVIDE',
      },
      FONT_SELECT_INPUT: {
        HELPER_TEXT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_HELPER_TEXT',
        HELPER_TEXT_DASHBOARD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_HELPER_TEXT_DASHBOARD',
        HELPER_TEXT_UPGRADE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_HELPER_TEXT_UPGRADE',
        HELPER_TEXT_ASK_ADMIN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_HELPER_TEXT_ASK_ADMIN',
        NO_OPTIONS_TEXT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_NO_OPTIONS_TEXT',
        MENU_TITLE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_MENU_TITLE',
        SEARCH_PLACEHOLDER: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_SEARCH_PLACEHOLDER',
        MANAGE_WORKSPACE_FONTS: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_SELECT_INPUT_MANAGE_WORKSPACE_FONTS',
      },
      FONT_STYLES: {
        NORMAL: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_STYLES_NORMAL',
        ITALIC: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_STYLES_ITALIC',
      },
      FONT_WEIGHTS: {
        HAIRLINE: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_HAIRLINE',
        THIN: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_THIN',
        EXTRA_LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_EXTRA_LIGHT',
        LIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_LIGHT',
        REGULAR: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_REGULAR',
        MEDIUM: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_MEDIUM',
        SEMI_BOLD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_SEMI_BOLD',
        BOLD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_BOLD',
        EXTRA_BOLD: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_EXTRA_BOLD',
        BLACK: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_BLACK',
        EXTRA_BLACK: 'COMPOSITOR_LAYER_PROPERTY_PANEL_FONT_WEIGHTS_EXTRA_BLACK',
      },
      ALIGN_OPTIONS: {
        TOP: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_TOP',
        CENTER: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_CENTER',
        BOTTOM: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_BOTTOM',
        LEFT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_LEFT',
        RIGHT: 'COMPOSITOR_LAYER_PROPERTY_PANEL_ALIGN_OPTIONS_RIGHT',
      },
    },
  },
  ERROR_PAGE: {
    TITLE: 'ERROR_PAGE_TITLE',
    DESCRIPTION: 'ERROR_PAGE_DESCRIPTION',
    RETRY_ACTION: 'ERROR_PAGE_RETRY_ACTION',
  },
  NO_ACCESS_PAGE: {
    TITLE: 'NO_ACCESS_PAGE_TITLE',
    DESCRIPTION: 'NO_ACCESS_PAGE_DESCRIPTION',
    ACTION: 'NO_ACCESS_PAGE_ACTION',
  },
  FLOW_WARNINGS: {
    FAILED_DESERIALIZE_3D_MODEL: 'FLOW_WARNINGS_FAILED_DESERIALIZE_3D_MODEL',
    FAILED_DESERIALIZE_FONT: 'FLOW_WARNINGS_FAILED_DESERIALIZE_FONT',
    FAILED_DESERIALIZE_IMAGE: 'FLOW_WARNINGS_FAILED_DESERIALIZE_IMAGE',
    FAILED_DESERIALIZE_VIDEO: 'FLOW_WARNINGS_FAILED_DESERIALIZE_VIDEO',
    FAILED_DOWNLOAD_IMAGE: 'FLOW_WARNINGS_FAILED_DOWNLOAD_IMAGE',
    FAILED_DOWNLOAD_VIDEO: 'FLOW_WARNINGS_FAILED_DOWNLOAD_VIDEO',
    FAILED_DOWNLOAD_AUDIO: 'FLOW_WARNINGS_FAILED_DOWNLOAD_AUDIO',
    FAILED_DOWNLOAD_FONT: 'FLOW_WARNINGS_FAILED_DOWNLOAD_FONT',
    FAILED_DOWNLOAD_3D_MODEL: 'FLOW_WARNINGS_FAILED_DOWNLOAD_3D_MODEL',
    FAILED_LOAD_WORKSPACE_CUSTOM_FONTS: 'FLOW_WARNINGS_FAILED_LOAD_WORKSPACE_CUSTOM_FONTS',
  },
  WEBGL_NOT_SUPPORTED_PAGE: {
    TITLE: 'WEBGL_NOT_SUPPORTED_PAGE_TITLE',
    DESCRIPTION: 'WEBGL_NOT_SUPPORTED_PAGE_DESCRIPTION',
  },
  GPU_DRIVER_ERROR_PAGE: {
    TITLE: 'GPU_DRIVER_ERROR_PAGE_TITLE',
    DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_DESCRIPTION',
    STEP_REFRESH_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_REFRESH_TITLE',
    STEP_REFRESH_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_REFRESH_DESCRIPTION',
    STEP_HARDWARE_ACCELERATION_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_HARDWARE_ACCELERATION_TITLE',
    STEP_HARDWARE_ACCELERATION_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_HARDWARE_ACCELERATION_DESCRIPTION',
    STEP_RESTART_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_RESTART_TITLE',
    STEP_RESTART_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_RESTART_DESCRIPTION',
    STEP_CONTACT_SUPPORT_TITLE: 'GPU_DRIVER_ERROR_PAGE_STEP_CONTACT_SUPPORT_TITLE',
    STEP_CONTACT_SUPPORT_DESCRIPTION: 'GPU_DRIVER_ERROR_PAGE_STEP_CONTACT_SUPPORT_DESCRIPTION',
  },
  FIGMA_COMPOSITOR: {
    LOAD_IMAGE_ERROR: 'FIGMA_COMPOSITOR_LOAD_IMAGE_ERROR',
    ALREADY_CONNECTED_ERROR: 'FIGMA_COMPOSITOR_ALREADY_CONNECTED_ERROR',
    OPEN_IN_FIGMA: 'FIGMA_COMPOSITOR_OPEN_IN_FIGMA',
    REFRESH: 'REFRESH',
    LAYERS: 'COMPOSITOR_LAYERS',
  },
  FIGMA_EMBED: {
    // Tooltip on the anonymous presence avatar shown to logged-out viewers of an
    // "Anyone with the link" Weave file. Weave has no multiplayer, so the avatar
    // just names the viewer "Anonymous"; clicking it prompts sign-up.
    ANONYMOUS_VIEWER_TOOLTIP: 'FIGMA_EMBED_ANONYMOUS_VIEWER_TOOLTIP',
    ANONYMOUS_VIEWER_SIGN_UP: 'FIGMA_EMBED_ANONYMOUS_VIEWER_SIGN_UP',
    // "Beta" badge shown next to the file name and in the onboarding tour while
    // Figma Weave is in beta. Embed mode only.
    BETA_BADGE: 'FIGMA_EMBED_BETA_BADGE',
  },
  FLOW_NAVBAR: {
    SHARED_DESIGN_APP_BUTTON: 'FLOW_NAVBAR_SHARED_DESIGN_APP_BUTTON',
    GET_MORE_CREDITS: 'FLOW_NAVBAR_GET_MORE_CREDITS',
    GET_MORE_CREDITS_V2: 'FLOW_NAVBAR_GET_MORE_CREDITS_V2',
    LOW_CREDITS_LABEL: 'FLOW_NAVBAR_LOW_CREDITS_LABEL',
  },
  GENERAL: {
    CANCEL: 'GENERAL_CANCEL',
    CLEAR: 'GENERAL_CLEAR',
    CLOSE: 'GENERAL_CLOSE',
    CONFIRM: 'GENERAL_CONFIRM',
    COPIED: 'GENERAL_COPIED',
    COPY_LINK: 'GENERAL_COPY_LINK',
    COPY: 'GENERAL_COPY',
    CREDIT: 'GENERAL_CREDIT',
    CREDITS: 'GENERAL_CREDITS',
    CREDITS_DISPLAY: 'GENERAL_CREDITS_DISPLAY',
    CREDITS_DISPLAY_PER_SECOND: 'GENERAL_CREDITS_DISPLAY_PER_SECOND',
    DONE: 'GENERAL_DONE',
    DOWNLOAD: 'GENERAL_DOWNLOAD',
    DOWNLOADING: 'GENERAL_DOWNLOADING',
    ERROR: 'GENERAL_ERROR',
    FILE: 'GENERAL_FILE',
    FILES: 'GENERAL_FILES',
    FROM: 'GENERAL_FROM',
    IMAGE: 'GENERAL_IMAGE',
    INPUT: 'GENERAL_INPUT',
    INVALID_URL: 'ERROR_INVALID_URL',
    MONTH: 'GENERAL_MONTH',
    NAME: 'GENERAL_NAME',
    OUTPUT: 'GENERAL_OUTPUT',
    RENAME: 'GENERAL_RENAME',
    SAVE: 'GENERAL_SAVE',
    SAVING: 'GENERAL_SAVING',
    SEARCH: 'GENERAL_SEARCH',
    SELECT_AN_OPTION: 'GENERAL_SELECT_AN_OPTION',
    TO: 'GENERAL_TO',
    UNKNOWN: 'GENERAL_UNKNOWN',
    UNKNOWN_ERROR: 'GENERAL_UNKNOWN_ERROR',
    REQUIRED_FIELDS: 'GENERAL_REQUIRED_FIELDS',
    UNVERIFIED_MODEL_ERROR: 'GENERAL_UNVERIFIED_MODEL_ERROR',
    UPLOAD_ERROR: 'GENERAL_UPLOAD_ERROR',
    UPLOAD: 'GENERAL_UPLOAD',
    UPLOAD_INVALID_IMAGE: 'GENERAL_UPLOAD_INVALID_IMAGE',
    THUMBNAIL: 'GENERAL_THUMBNAIL',
    SELECT_IMAGE: 'GENERAL_SELECT_IMAGE',
    SELECT_FROM_WORKFLOW: 'GENERAL_SELECT_FROM_WORKFLOW',
    SCOPE_IN_GROUP: 'GENERAL_SCOPE_IN_GROUP',
    SCOPE_IN_WORKFLOW: 'GENERAL_SCOPE_IN_WORKFLOW',
    GROUP_GALLERY_EMPTY: 'GENERAL_GROUP_GALLERY_EMPTY',
    WORKFLOW_GALLERY_EMPTY: 'GENERAL_WORKFLOW_GALLERY_EMPTY',
    DESCRIPTION: 'GENERAL_DESCRIPTION',
    TOTAL: 'GENERAL_TOTAL',
    URL: 'GENERAL_URL',
    USER: 'GENERAL_USER',
    YEAR: 'GENERAL_YEAR',
    LORA_WEIGHT: 'GENERAL_LORA_WEIGHT',
    YOU: 'GENERAL_YOU',
    YOU_PARENS: 'GENERAL_YOU_PARENS',
    RELOAD_ALERT_TITLE: 'GENERAL_RELOAD_ALERT_TITLE',
    RELOAD_ALERT_CTA: 'GENERAL_RELOAD_ALERT_CTA',
    PAGE_TITLE: 'GENERAL_PAGE_TITLE',
    YES: 'GENERAL_YES',
    NO: 'GENERAL_NO',
    FILTER: 'GENERAL_FILTER',
    FILTERS: 'GENERAL_FILTERS',
    RUNNING: 'GENERAL_RUNNING',
    COMPLETED: 'GENERAL_COMPLETED',
    TYPE: 'GENERAL_TYPE',
    EMAIL: 'GENERAL_EMAIL',
    ROLE: 'GENERAL_ROLE',
    COLOR: 'GENERAL_COLOR',
    APPROVE: 'GENERAL_APPROVE',
    ACCEPT: 'GENERAL_ACCEPT',
    DELETE: 'GENERAL_DELETE',
    WIDTH: 'GENERAL_WIDTH',
    HEIGHT: 'GENERAL_HEIGHT',
    CHECKBOX: 'GENERAL_CHECKBOX',
    ROTATE_90_CLOCKWISE: 'GENERAL_ROTATE_90_CLOCKWISE',
    FLIP_HORIZONTAL: 'GENERAL_FLIP_HORIZONTAL',
    FLIP_VERTICAL: 'GENERAL_FLIP_VERTICAL',
    ARIA: {
      SCALE: 'GENERAL_ARIA_SCALE',
      MINUTES: 'GENERAL_ARIA_MINUTES',
      SECONDS: 'GENERAL_ARIA_SECONDS',
      FRAMES: 'GENERAL_ARIA_FRAMES',
      BREAK_MASKED_TARGET_CONNECTIONS: 'GENERAL_ARIA_BREAK_MASKED_TARGET_CONNECTIONS',
      COLLAPSE_PARAMETER: 'GENERAL_ARIA_COLLAPSE_PARAMETER',
      FILTER_BY_INPUT_TYPE: 'GENERAL_ARIA_FILTER_BY_INPUT_TYPE',
      FILTER_BY_OUTPUT_TYPE: 'GENERAL_ARIA_FILTER_BY_OUTPUT_TYPE',
      COPY_DEBUG_VALUE: 'GENERAL_ARIA_COPY_DEBUG_VALUE',
      COPY_JSON: 'GENERAL_ARIA_COPY_JSON',
      CREATE_LAYER_MASK: 'GENERAL_ARIA_CREATE_LAYER_MASK',
      EDIT_NAMED_ITEM: 'GENERAL_ARIA_EDIT_NAMED_ITEM',
      DELETE_NAMED_ITEM: 'GENERAL_ARIA_DELETE_NAMED_ITEM',
      EXPOSE_PARAMETER: 'GENERAL_ARIA_EXPOSE_PARAMETER',
      GO_TO_HOME: 'GENERAL_ARIA_GO_TO_HOME',
      HIDE_COMPARISON: 'GENERAL_ARIA_HIDE_COMPARISON',
      HIDE_LAYER: 'GENERAL_ARIA_HIDE_LAYER',
      LOCK_LAYER: 'GENERAL_ARIA_LOCK_LAYER',
      LOCKED_NODE: 'GENERAL_ARIA_LOCKED_NODE',
      MUTE: 'GENERAL_ARIA_MUTE',
      MUTE_LAYER: 'GENERAL_ARIA_MUTE_LAYER',
      NEXT_BATCH: 'GENERAL_ARIA_NEXT_BATCH',
      NEXT_FRAME: 'GENERAL_ARIA_NEXT_FRAME',
      NEXT_ITEM: 'GENERAL_ARIA_NEXT_ITEM',
      NEXT_MODEL_REQUEST: 'GENERAL_ARIA_NEXT_MODEL_REQUEST',
      OPEN_FIGMA_FILE_MENU: 'GENERAL_ARIA_OPEN_FIGMA_FILE_MENU',
      OPEN_FILE_MENU: 'GENERAL_ARIA_OPEN_FILE_MENU',
      OPEN_FILTERS_MENU: 'GENERAL_ARIA_OPEN_FILTERS_MENU',
      OPEN_HELP: 'GENERAL_ARIA_OPEN_HELP',
      OPEN_INPUT_SETTINGS: 'GENERAL_ARIA_OPEN_INPUT_SETTINGS',
      OPEN_ITEM_MENU: 'GENERAL_ARIA_OPEN_ITEM_MENU',
      OPEN_NAMED_ITEM: 'GENERAL_ARIA_OPEN_NAMED_ITEM',
      OPEN_NODE_MENU: 'GENERAL_ARIA_OPEN_NODE_MENU',
      OPEN_PUBLISHED_WORKFLOW_MENU: 'GENERAL_ARIA_OPEN_PUBLISHED_WORKFLOW_MENU',
      OPEN_WORKSPACE_FILE_MENU: 'GENERAL_ARIA_OPEN_WORKSPACE_FILE_MENU',
      PAUSE: 'GENERAL_ARIA_PAUSE',
      PLAY: 'GENERAL_ARIA_PLAY',
      PREVIOUS_BATCH: 'GENERAL_ARIA_PREVIOUS_BATCH',
      PREVIOUS_FRAME: 'GENERAL_ARIA_PREVIOUS_FRAME',
      PREVIOUS_ITEM: 'GENERAL_ARIA_PREVIOUS_ITEM',
      PREVIOUS_MODEL_REQUEST: 'GENERAL_ARIA_PREVIOUS_MODEL_REQUEST',
      REDO: 'GENERAL_ARIA_REDO',
      REMOVE_IMAGE: 'GENERAL_ARIA_REMOVE_IMAGE',
      REMOVE_ITEM: 'GENERAL_ARIA_REMOVE_ITEM',
      REMOVE_NAMED_ITEM: 'GENERAL_ARIA_REMOVE_NAMED_ITEM',
      REMOVE_NAMED_ITEM_KEYBOARD: 'GENERAL_ARIA_REMOVE_NAMED_ITEM_KEYBOARD',
      REVEAL_COMPARISON: 'GENERAL_ARIA_REVEAL_COMPARISON',
      SCROLL_LEFT: 'GENERAL_ARIA_SCROLL_LEFT',
      SCROLL_RIGHT: 'GENERAL_ARIA_SCROLL_RIGHT',
      SHOW_LAYER: 'GENERAL_ARIA_SHOW_LAYER',
      UNDO: 'GENERAL_ARIA_UNDO',
      UNLOCK_GROUP: 'GENERAL_ARIA_UNLOCK_GROUP',
      UNLOCK_LAYER: 'GENERAL_ARIA_UNLOCK_LAYER',
      UNMUTE: 'GENERAL_ARIA_UNMUTE',
      UNMUTE_LAYER: 'GENERAL_ARIA_UNMUTE_LAYER',
    },
    FILE_TYPES: {
      IMAGE: 'GENERAL_FILE_TYPES_IMAGE',
      VIDEO: 'GENERAL_FILE_TYPES_VIDEO',
      AUDIO: 'GENERAL_FILE_TYPES_AUDIO',
      THREE_D: 'GENERAL_FILE_TYPES_THREE_D',
    },
    HANDLE_TYPES: {
      IMAGE: 'GENERAL_HANDLE_TYPES_IMAGE',
      VIDEO: 'GENERAL_HANDLE_TYPES_VIDEO',
      AUDIO: 'GENERAL_HANDLE_TYPES_AUDIO',
      THREE_D: 'GENERAL_HANDLE_TYPES_THREE_D',
      TEXT: 'GENERAL_HANDLE_TYPES_TEXT',
      SEED: 'GENERAL_HANDLE_TYPES_SEED',
      MASK: 'GENERAL_HANDLE_TYPES_MASK',
      LORA: 'GENERAL_HANDLE_TYPES_LORA',
      NUMBER: 'GENERAL_HANDLE_TYPES_NUMBER',
      BOOLEAN: 'GENERAL_HANDLE_TYPES_BOOLEAN',
      ARRAY: 'GENERAL_HANDLE_TYPES_ARRAY',
      KLING_ELEMENT: 'GENERAL_HANDLE_TYPES_KLING_ELEMENT',
      KEYFRAME: 'GENERAL_HANDLE_TYPES_KEYFRAME',
      ANY: 'GENERAL_HANDLE_TYPES_ANY',
    },
  },
  MAIN_DASHBOARD: {
    BREADCRUMB_ARIA: 'MAIN_DASHBOARD_BREADCRUMB_ARIA',
    CONTEXT_MENU: {
      DUPLICATE: 'MAIN_DASHBOARD_CONTEXT_MENU_DUPLICATE',
      DUPLICATE_WORKFLOW: 'MAIN_DASHBOARD_CONTEXT_MENU_DUPLICATE_WORKFLOW',
      EDIT: 'MAIN_DASHBOARD_CONTEXT_MENU_EDIT',
      OPEN: 'MAIN_DASHBOARD_CONTEXT_MENU_OPEN',
      OPEN_NEW_TAB: 'MAIN_DASHBOARD_CONTEXT_MENU_OPEN_NEW_TAB',
      RENAME: 'MAIN_DASHBOARD_CONTEXT_MENU_RENAME',
      MOVE: 'MAIN_DASHBOARD_CONTEXT_MENU_MOVE',
      CHANGE_OWNER: 'MAIN_DASHBOARD_CONTEXT_MENU_CHANGE_OWNER',
      EXPORT_AUDIT_TRAIL: 'MAIN_DASHBOARD_CONTEXT_MENU_EXPORT_AUDIT_TRAIL',
      CREATE_FOLDER: 'MAIN_DASHBOARD_CONTEXT_MENU_CREATE_FOLDER',
      CREATE_FILE: 'MAIN_DASHBOARD_CONTEXT_MENU_CREATE_FILE',
      CREATE_WORKFLOW: 'MAIN_DASHBOARD_CONTEXT_MENU_CREATE_WORKFLOW',
      MOVE_TO_TRASH: 'MAIN_DASHBOARD_CONTEXT_MENU_MOVE_TO_TRASH',
    },
    CREATE_NEW_FILE: 'MAIN_DASHBOARD_CREATE_NEW_FILE',
    CREATE_NEW_WORKFLOW: 'MAIN_DASHBOARD_CREATE_NEW_WORKFLOW',
    CREATE_FOLDER_MODAL: {
      TITLE: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_TITLE',
      NAME_LABEL: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_NAME_LABEL',
      CANCEL: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_CANCEL',
      CREATE: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_CREATE',
      SUCCESS: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_SUCCESS',
      ERROR_PREFIX: 'MAIN_DASHBOARD_CREATE_FOLDER_MODAL_ERROR_PREFIX',
    },
    FOLDER_CARD: {
      FILE_COUNT_SINGULAR: 'MAIN_DASHBOARD_FOLDER_CARD_FILE_COUNT_SINGULAR',
      FILE_COUNT_PLURAL: 'MAIN_DASHBOARD_FOLDER_CARD_FILE_COUNT_PLURAL',
      WORKFLOW_COUNT_SINGULAR: 'MAIN_DASHBOARD_FOLDER_CARD_WORKFLOW_COUNT_SINGULAR',
      WORKFLOW_COUNT_PLURAL: 'MAIN_DASHBOARD_FOLDER_CARD_WORKFLOW_COUNT_PLURAL',
    },
    MOVE_MODAL: {
      TITLE: 'MAIN_DASHBOARD_MOVE_MODAL_TITLE',
      TITLE_FOLDER: 'MAIN_DASHBOARD_MOVE_MODAL_TITLE_FOLDER',
      CURRENT_LOCATION: 'MAIN_DASHBOARD_MOVE_MODAL_CURRENT_LOCATION',
      CANCEL: 'MAIN_DASHBOARD_MOVE_MODAL_CANCEL',
      MOVE: 'MAIN_DASHBOARD_MOVE_MODAL_MOVE',
      TITLE_WORKFLOW: 'MAIN_DASHBOARD_MOVE_MODAL_TITLE_WORKFLOW',
      TITLE_TOOL: 'MAIN_DASHBOARD_MOVE_MODAL_TITLE_TOOL',
      SUCCESS_FILE: 'MAIN_DASHBOARD_MOVE_MODAL_SUCCESS_FILE',
      SUCCESS_WORKFLOW: 'MAIN_DASHBOARD_MOVE_MODAL_SUCCESS_WORKFLOW',
      SUCCESS_TOOL: 'MAIN_DASHBOARD_MOVE_MODAL_SUCCESS_TOOL',
      SUCCESS_FOLDER: 'MAIN_DASHBOARD_MOVE_MODAL_SUCCESS_FOLDER',
      ERROR_PREFIX: 'MAIN_DASHBOARD_MOVE_MODAL_ERROR_PREFIX',
      NOT_OWNER_FOLDER: 'MAIN_DASHBOARD_MOVE_MODAL_NOT_OWNER_FOLDER',
      NOT_OWNER_FILE: 'MAIN_DASHBOARD_MOVE_MODAL_NOT_OWNER_FILE',
      CURRENT: 'MAIN_DASHBOARD_MOVE_MODAL_CURRENT',
      BACK_ARIA: 'MAIN_DASHBOARD_MOVE_MODAL_BACK_ARIA',
    },
    DELETE_DIALOG: {
      CONFIRM: 'MAIN_DASHBOARD_DELETE_DIALOG_CONFIRM',
      CONFIRMATION_DELETE_APP: 'MAIN_DASHBOARD_DELETE_DIALOG_CONFIRMATION_DELETE_APP',
      MSG_DELETE_APP: 'MAIN_DASHBOARD_DELETE_DIALOG_MSG_DELETE_APP',
      TITLE: 'MAIN_DASHBOARD_DELETE_DIALOG_TITLE',
      MSG: 'MAIN_DASHBOARD_DELETE_DIALOG_MSG',
      CONFIRM_DELETE: 'MAIN_DASHBOARD_DELETE_DIALOG_CONFIRM_DELETE',
    },
    DISMISS_SHARE_DIALOG: {
      TITLE: 'MAIN_DASHBOARD_DISMISS_SHARE_DIALOG_TITLE',
      MSG: 'MAIN_DASHBOARD_DISMISS_SHARE_DIALOG_MSG',
      CONFIRM: 'MAIN_DASHBOARD_DISMISS_SHARE_DIALOG_CONFIRM',
    },
    DELETE_TOOL_DIALOG: {
      MSG: 'MAIN_DASHBOARD_DELETE_TOOL_DIALOG_MSG',
    },
    DELETE_FOLDER_SUCCESS: 'MAIN_DASHBOARD_DELETE_FOLDER_SUCCESS',
    DELETE_FOLDER_ERROR: 'MAIN_DASHBOARD_DELETE_FOLDER_ERROR',
    DELETE_WORKFLOW_SUCCESS: 'MAIN_DASHBOARD_DELETE_WORKFLOW_SUCCESS',
    DELETE_WORKFLOW_ERROR: 'MAIN_DASHBOARD_DELETE_WORKFLOW_ERROR',
    DELETE_TOOL_SUCCESS: 'MAIN_DASHBOARD_DELETE_TOOL_SUCCESS',
    DELETE_TOOL_ERROR: 'MAIN_DASHBOARD_DELETE_TOOL_ERROR',
    RENAME_FOLDER_ERROR: 'MAIN_DASHBOARD_RENAME_FOLDER_ERROR',
    EDUCATION_GALLERY: {
      ARIA: 'MAIN_DASHBOARD_EDUCATION_GALLERY_ARIA',
      TUTORIALS: 'MAIN_DASHBOARD_TUTORIALS',
      WORKFLOWS: 'MAIN_DASHBOARD_WORKFLOWS',
      COMMUNITY: 'MAIN_DASHBOARD_COMMUNITY',
      TUTORIAL_NAMES: {
        INTRO: 'MAIN_DASHBOARD_TUTORIAL_INTRO',
        WEAVE_101: 'MAIN_DASHBOARD_TUTORIAL_WEAVE_101',
        FIRST_WORKFLOW: 'MAIN_DASHBOARD_TUTORIAL_FIRST_WORKFLOW',
        COMPOSITOR: 'MAIN_DASHBOARD_TUTORIAL_COMPOSITOR',
        THREE_D_MODELS: 'MAIN_DASHBOARD_TUTORIAL_3D_MODELS',
        WORKFLOW_TO_TOOL: 'MAIN_DASHBOARD_TUTORIAL_WORKFLOW_TO_TOOL',
        EXPORT_IMPORT: 'MAIN_DASHBOARD_TUTORIAL_EXPORT_IMPORT',
        GENERATIVE_MODELS: 'MAIN_DASHBOARD_TUTORIAL_GENERATIVE_MODELS',
        ITERATORS: 'MAIN_DASHBOARD_TUTORIAL_ITERATORS',
        IMPORT_LORA: 'MAIN_DASHBOARD_TUTORIAL_IMPORT_LORA',
        TEXT_PROMPTS: 'MAIN_DASHBOARD_TUTORIAL_TEXT_PROMPTS',
        EXTERNAL_MODELS: 'MAIN_DASHBOARD_TUTORIAL_EXTERNAL_MODELS',
        CONTROLNET: 'MAIN_DASHBOARD_TUTORIAL_CONTROLNET',
      },
    },
    ERROR_LOADING_WORKFLOWS: {
      TITLE: 'MAIN_DASHBOARD_ERROR_LOADING_RECIPES_TITLE',
      ACTION: 'MAIN_DASHBOARD_ERROR_LOADING_RECIPES_ACTION',
    },
    SEARCH_PLACEHOLDER: 'MAIN_DASHBOARD_SEARCH_PLACEHOLDER',
    SEARCH_NO_RESULTS: {
      TITLE: 'MAIN_DASHBOARD_SEARCH_NO_RESULTS_TITLE',
      DESCRIPTION: 'MAIN_DASHBOARD_SEARCH_NO_RESULTS_DESCRIPTION',
    },
    FOLDER_EMPTY: {
      TITLE: 'MAIN_DASHBOARD_FOLDER_EMPTY_TITLE',
      DESCRIPTION: 'MAIN_DASHBOARD_FOLDER_EMPTY_DESCRIPTION',
      DESCRIPTION_WORKFLOWS: 'MAIN_DASHBOARD_FOLDER_EMPTY_DESCRIPTION_WORKFLOWS',
    },
    SECTION_TITLE: {
      RECENT: 'MAIN_DASHBOARD_SECTION_TITLE_RECENT',
    },
    USERMENU: {
      CREDITS: 'MAIN_DASHBOARD_USERMENU_CREDITS',
      TEAM_CREDITS: 'MAIN_DASHBOARD_USERMENU_TEAM_CREDITS',
      CTA_CREDITS: 'MAIN_DASHBOARD_USERMENU_CTA_CREDITS',
      CTA_CREDITS_FREE: 'MAIN_DASHBOARD_USERMENU_CTA_CREDITS_FREE',
      CTA_PLAN: 'MAIN_DASHBOARD_USERMENU_CTA_PLAN',
      MENU_ITEM_SETTINGS: 'MAIN_DASHBOARD_USERMENU_MENU_ITEM_SETTINGS',
      PLAN: 'MAIN_DASHBOARD_USERMENU_PLAN',
      TEAM_HINT_CREDITS_EMPTY: 'MAIN_DASHBOARD_USERMENU_TEAM_HINT_CREDITS_EMPTY',
    },
    WORKSPACES_MENU: {
      TITLE: 'MAIN_DASHBOARD_WORKSPACES_MENU_TITLE',
    },
    CHANGE_OWNER_MODAL: {
      TITLE: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_TITLE',
      SUBTITLE: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SUBTITLE',
      SELECT_OWNER: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SELECT_OWNER',
      SELECT_OWNER_PLACEHOLDER: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SELECT_OWNER_PLACEHOLDER',
      CANCEL: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_CANCEL',
      CONFIRM: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_CONFIRM',
      SUCCESS_SNACKBAR: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_SUCCESS_SNACKBAR',
      WARNING: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_WARNING',
      ERROR_SNACKBAR: 'MAIN_DASHBOARD_CHANGE_OWNER_MODAL_ERROR_SNACKBAR',
    },
  },
  MOBILE_UNSUPPORTED_PAGE: {
    DISCORD_BUTTON: 'MOBILE_UNSUPPORTED_PAGE_DISCORD_BUTTON',
    FOOTER_TEXT: 'MOBILE_UNSUPPORTED_PAGE_FOOTER_TEXT',
    SUBTITLE: 'MOBILE_UNSUPPORTED_PAGE_SUBTITLE',
    TITLE: 'MOBILE_UNSUPPORTED_PAGE_TITLE',
    YOUTUBE_INTRO_BUTTON: 'MOBILE_UNSUPPORTED_PAGE_YOUTUBE_INTRO_BUTTON',
  },
  MOBILE_SIGNUP_HANDOFF_PAGE: {
    ACTIVATION_ERROR: 'MOBILE_SIGNUP_HANDOFF_PAGE_ACTIVATION_ERROR',
    COPY_ERROR: 'MOBILE_SIGNUP_HANDOFF_PAGE_COPY_ERROR',
    COPY_LINK_BUTTON: 'MOBILE_SIGNUP_HANDOFF_PAGE_COPY_LINK_BUTTON',
    COPY_SUCCESS: 'MOBILE_SIGNUP_HANDOFF_PAGE_COPY_SUCCESS',
    DISCORD_BUTTON: 'MOBILE_SIGNUP_HANDOFF_PAGE_DISCORD_BUTTON',
    POST_SIGNUP_SUBTITLE: 'MOBILE_SIGNUP_HANDOFF_PAGE_POST_SIGNUP_SUBTITLE',
    POST_SIGNUP_TITLE: 'MOBILE_SIGNUP_HANDOFF_PAGE_POST_SIGNUP_TITLE',
    SHARE_LINK_BUTTON: 'MOBILE_SIGNUP_HANDOFF_PAGE_SHARE_LINK_BUTTON',
    SHARE_SUCCESS: 'MOBILE_SIGNUP_HANDOFF_PAGE_SHARE_SUCCESS',
    SHARE_TITLE: 'MOBILE_SIGNUP_HANDOFF_PAGE_SHARE_TITLE',
  },
  NAVIGATION_DRAWER: {
    DASHBOARD_NAVIGATION_ARIA: 'NAVIGATION_DRAWER_DASHBOARD_NAVIGATION_ARIA',
    BUY_MORE: 'NAVIGATION_DRAWER_BUY_MORE',
    CREATE_NEW_FILE: 'NAVIGATION_DRAWER_CREATE_NEW_FILE',
    CREATE_NEW_WORKFLOW: 'NAVIGATION_DRAWER_CREATE_NEW_WORKFLOW',
    MY_FILES: 'NAVIGATION_DRAWER_MY_FILES',
    SHARED_WITH_ME: 'NAVIGATION_DRAWER_SHARED_WITH_ME',
    WORKSPACE_FILES: 'NAVIGATION_DRAWER_WORKSPACE_FILES',
    APPS: 'NAVIGATION_DRAWER_APPS',
    WORKFLOWS: 'NAVIGATION_DRAWER_WORKFLOWS',
    TOOLS: 'NAVIGATION_DRAWER_TOOLS',
    TOOLKIT: 'NAVIGATION_DRAWER_TOOLKIT',
    FAVORITES: 'NAVIGATION_DRAWER_FAVORITES',
    MODELS_SECTION: 'NAVIGATION_DRAWER_MODELS_SECTION',
    MODELS: 'NAVIGATION_DRAWER_MODELS',
    COMMUNITY: 'NAVIGATION_DRAWER_COMMUNITY',
    SUPPORT: 'NAVIGATION_DRAWER_SUPPORT',
    DISCORD_TITLE: 'NAVIGATION_DRAWER_DISCORD_TITLE',
    DISCORD_TEXT: 'NAVIGATION_DRAWER_DISCORD_TEXT',
    DISCORD_CTA: 'NAVIGATION_DRAWER_DISCORD_CTA',
    NEW_FILE: 'NAVIGATION_DRAWER_NEW_FILE',
    NEW_WORKFLOW: 'NAVIGATION_DRAWER_NEW_WORKFLOW',
    NEW_FOLDER: 'NAVIGATION_DRAWER_NEW_FOLDER',
    ARCHIVE: 'NAVIGATION_DRAWER_ARCHIVE',
    CREATE_MENU_ARIA: 'NAVIGATION_DRAWER_CREATE_MENU_ARIA',
    CREATE_MENU_ARIA_WORKFLOW: 'NAVIGATION_DRAWER_CREATE_MENU_ARIA_WORKFLOW',
    UNIVERSAL_UPGRADE_BADGE: {
      TITLE: 'NAVIGATION_DRAWER_UNIVERSAL_UPGRADE_BADGE_TITLE',
      DESCRIPTION: 'NAVIGATION_DRAWER_UNIVERSAL_UPGRADE_BADGE_DESCRIPTION',
      CTA: 'NAVIGATION_DRAWER_UNIVERSAL_UPGRADE_BADGE_CTA',
    },
    ENTERPRISE_UPGRADE_BADGE: {
      TITLE: 'NAVIGATION_DRAWER_ENTERPRISE_UPGRADE_BADGE_TITLE',
      DESCRIPTION: 'NAVIGATION_DRAWER_ENTERPRISE_UPGRADE_BADGE_DESCRIPTION',
      CTA: 'NAVIGATION_DRAWER_ENTERPRISE_UPGRADE_BADGE_CTA',
      VIEW_PLANS: 'NAVIGATION_DRAWER_ENTERPRISE_UPGRADE_BADGE_VIEW_PLANS',
      DISMISS: 'NAVIGATION_DRAWER_ENTERPRISE_UPGRADE_BADGE_DISMISS',
    },
  },
  NODE_IMAGE_LIST: {
    CAMERA_CONTROLS: {
      LOCK: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_LOCK',
      UNLOCK: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_UNLOCK',
      LOCK_ASPECT_RATIO: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_LOCK_ASPECT_RATIO',
      UNLOCK_ASPECT_RATIO: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_UNLOCK_ASPECT_RATIO',
      ORBIT_MODE: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_ORBIT_MODE',
      FLY_MODE: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_FLY_MODE',
      FLY_MODE_ARIA: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_FLY_MODE_ARIA',
      FLY_MODE_TOOLTIP_TITLE: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_FLY_MODE_TOOLTIP_TITLE',
      FLY_MODE_TOOLTIP_DESCRIPTION: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_FLY_MODE_TOOLTIP_DESCRIPTION',
      MODE: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_MODE',
      SHOW_GRID: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_SHOW_GRID',
      HIDE_GRID: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_HIDE_GRID',
      FIELD_OF_VIEW: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_FIELD_OF_VIEW',
      DIMENSIONS: 'NODE_IMAGE_LIST_CAMERA_CONTROLS_DIMENSIONS',
      RESET: 'NODE_IMAGE_LIST_CONTEXT_MENU_RESET',
    },
    CONTEXT_MENU: {
      DOWNLOAD: 'NODE_IMAGE_LIST_CONTEXT_DOWNLOAD',
      DOWNLOAD_ALL: 'NODE_IMAGE_LIST_CONTEXT_DOWNLOAD_ALL',
      DOWNLOAD_IMAGE: 'NODE_IMAGE_LIST_CONTEXT_DOWNLOAD_IMAGE',
      DOWNLOAD_MODEL: 'NODE_IMAGE_LIST_CONTEXT_DOWNLOAD_MODEL',
      CURRENT: 'NODE_IMAGE_LIST_CONTEXT_CURRENT',
      ALL: 'NODE_IMAGE_LIST_CONTEXT_ALL',
      SET_AS_COVER: 'NODE_IMAGE_LIST_CONTEXT_MENU_SET_AS_COVER',
      COPY_IMAGE: 'NODE_IMAGE_LIST_CONTEXT_MENU_COPY_IMAGE',
    },
    DELETE_ALL: 'NODE_IMAGE_LIST_DELETE_ALL',
    DELETE_ALL_OTHERS: 'NODE_IMAGE_LIST_DELETE_ALL_OTHERS',
    DELETE_CURRENT: 'NODE_IMAGE_LIST_DELETE_CURRENT',
  },
  NODE_HISTORY: {
    TITLE: 'NODE_HISTORY_TITLE',
    /** Static suffix after the truncatable node label in the drawer header (WEA-5756). */
    TITLE_SUFFIX: 'NODE_HISTORY_TITLE_SUFFIX',
    CLEAR: 'NODE_HISTORY_CLEAR',
    CLEAR_ARIA: 'NODE_HISTORY_CLEAR_ARIA',
    CLEAR_CONFIRM_TITLE: 'NODE_HISTORY_CLEAR_CONFIRM_TITLE',
    CLEAR_CONFIRM_MESSAGE: 'NODE_HISTORY_CLEAR_CONFIRM_MESSAGE',
    CLEAR_CONFIRM_DONT_SHOW: 'NODE_HISTORY_CLEAR_CONFIRM_DONT_SHOW',
    EMPTY_TITLE: 'NODE_HISTORY_EMPTY_TITLE',
    ERROR_TITLE: 'NODE_HISTORY_ERROR_TITLE',
    ERROR_SUBTITLE: 'NODE_HISTORY_ERROR_SUBTITLE',
    LOAD_MORE: 'NODE_HISTORY_LOAD_MORE',
    LOAD_MORE_RETRY: 'NODE_HISTORY_LOAD_MORE_RETRY',
    LOADING: 'NODE_HISTORY_LOADING',
    RESTORE: 'NODE_HISTORY_RESTORE',
    RESTORE_TEXT_ONLY: 'NODE_HISTORY_RESTORE_TEXT_ONLY',
    RESTORE_TEXT_AND_VARIABLES: 'NODE_HISTORY_RESTORE_TEXT_AND_VARIABLES',
    COPY: 'NODE_HISTORY_COPY',
    COPIED: 'NODE_HISTORY_COPIED',
    // Run-counter subtitle (Figma 54740-37833), composed from plural-aware parts.
    RUNS: 'NODE_HISTORY_RUNS',
    ITERATIONS: 'NODE_HISTORY_ITERATIONS',
    WITH_ITERATIONS: 'NODE_HISTORY_WITH_ITERATIONS',
    WITH_ITERATIONS_EACH: 'NODE_HISTORY_WITH_ITERATIONS_EACH',
    ITERATIONS_VARY: 'NODE_HISTORY_ITERATIONS_VARY',
  },
  PAYMENTS: {
    PRICING_TABLE: {
      INDIVIDUALS: 'PAYMENTS_PRICING_TABLE_INDIVIDUALS',
      TEAMS: 'PAYMENTS_PRICING_TABLE_TEAMS',
      FOR_TEAMS: 'PAYMENTS_PRICING_TABLE_FOR_TEAMS',
      AUDIENCE: 'PAYMENTS_PRICING_TABLE_AUDIENCE',
      BEST_VALUE: 'PAYMENTS_PRICING_TABLE_BEST_VALUE',
      MAX_LAUNCH_PROMOTION: 'PAYMENTS_PRICING_TABLE_MAX_LAUNCH_PROMOTION',
      ANNUAL_DISCOUNT_BANNER: 'PAYMENTS_PRICING_TABLE_ANNUAL_DISCOUNT_BANNER',
      TEAM_DESCRIPTION_MAX: 'PAYMENTS_PRICING_TABLE_TEAM_DESCRIPTION_MAX',
      CREDITS_INFO_VIDEO_MINUTES: 'PAYMENTS_PRICING_TABLE_CREDITS_INFO_VIDEO_MINUTES',
      FEATURE: {
        NO_VIDEO_MODELS: 'PAYMENTS_PRICING_TABLE_FEATURE_NO_VIDEO_MODELS',
        NO_WORKFLOW_HISTORY: 'PAYMENTS_PRICING_TABLE_FEATURE_NO_WORKFLOW_HISTORY',
        ALL_MODELS: 'PAYMENTS_PRICING_TABLE_FEATURE_ALL_MODELS',
        ADVANCED_ADMIN: 'PAYMENTS_PRICING_TABLE_FEATURE_ADVANCED_ADMIN',
        PROFESSIONAL_GRADE_EDITING_TOOLS: 'PAYMENTS_PRICING_TABLE_FEATURE_PROFESSIONAL_GRADE_EDITING_TOOLS',
        FIVE_WORKFLOWS: 'PAYMENTS_PRICING_TABLE_FEATURE_FIVE_WORKFLOWS',
        ALL_IMAGE_MODELS: 'PAYMENTS_PRICING_TABLE_FEATURE_ALL_IMAGE_MODELS',
        UNLIMITED_WORKFLOWS: 'PAYMENTS_PRICING_TABLE_FEATURE_UNLIMITED_WORKFLOWS',
        CREDIT_TOP_UP: 'PAYMENTS_PRICING_TABLE_FEATURE_CREDIT_TOP_UP',
        THREE_MONTH_CREDIT_ROLLOVER: 'PAYMENTS_PRICING_TABLE_FEATURE_THREE_MONTH_CREDIT_ROLLOVER',
        FOUR_MONTH_CREDIT_ROLLOVER: 'PAYMENTS_PRICING_TABLE_FEATURE_FOUR_MONTH_CREDIT_ROLLOVER',
        LOWEST_COST_PER_CREDIT: 'PAYMENTS_PRICING_TABLE_FEATURE_LOWEST_COST_PER_CREDIT',
        WORKSPACE_FILE_SHARING: 'PAYMENTS_PRICING_TABLE_FEATURE_WORKSPACE_FILE_SHARING',
        SHARED_CREDIT_POOL: 'PAYMENTS_PRICING_TABLE_FEATURE_SHARED_CREDIT_POOL',
        UNIFIED_BILLING: 'PAYMENTS_PRICING_TABLE_FEATURE_UNIFIED_BILLING',
        TEAM_MEMBERS_ADMINISTRATION: 'PAYMENTS_PRICING_TABLE_FEATURE_TEAM_MEMBERS_ADMINISTRATION',
        TEAM_CREDITS_MANAGEMENT: 'PAYMENTS_PRICING_TABLE_FEATURE_TEAM_CREDITS_MANAGEMENT',
        WORKFLOW_COLLABORATION: 'PAYMENTS_PRICING_TABLE_FEATURE_WORKFLOW_COLLABORATION',
      },
      TITLE: 'PAYMENTS_PRICING_TABLE_TITLE',
      SUBTITLE: {
        ALL_PACKAGES_INCLUDE: 'PAYMENTS_PRICING_TABLE_SUBTITLE_ALL_PACKAGES_INCLUDE',
        INCLUDED_FEATURE_01: 'PAYMENTS_PRICING_TABLE_SUBTITLE_INCLUDED_FEATURE_01',
        INCLUDED_FEATURE_02: 'PAYMENTS_PRICING_TABLE_SUBTITLE_INCLUDED_FEATURE_02',
        INCLUDED_FEATURE_03: 'PAYMENTS_PRICING_TABLE_SUBTITLE_INCLUDED_FEATURE_03',
      },
      TEMP_TITLE: 'PAYMENTS_PRICING_TABLE_TEMP_TITLE',
      TOGGLE_BUTTON: {
        ARIA: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_ARIA',
        MONTHLY: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_MONTHLY',
        YEARLY: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_YEARLY',
        YEARLY_FIXED_DISCOUNT: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_YEARLY_FIXED_DISCOUNT',
        YEARLY_SAVE_DISCOUNT: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_YEARLY_SAVE_DISCOUNT',
        YEARLY_UP_TO_DISCOUNT: 'PAYMENTS_PRICING_TABLE_TOGGLE_BUTTON_YEARLY_UP_TO_DISCOUNT',
      },
      FREE_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_FREE_PLAN_CTA',
      PAID_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_PAID_PLAN_CTA',
      PAID_ANNUAL_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_PAID_ANNUAL_PLAN_CTA',
      DOWNGRADE_DATE_PREFIX: 'PAYMENTS_PRICING_TABLE_DOWNGRADE_DATE_PREFIX',
      RESTORE_PLAN: 'PAYMENTS_PRICING_TABLE_RESTORE_PLAN',
      RESTORE_CONFIRMATION_TITLE: 'PAYMENTS_PRICING_TABLE_RESTORE_CONFIRMATION_TITLE',
      RESTORE_CONFIRMATION_MESSAGE: 'PAYMENTS_PRICING_TABLE_RESTORE_CONFIRMATION_MESSAGE',
      RESTORE_CONFIRMATION_CONFIRM_TEXT: 'PAYMENTS_PRICING_TABLE_RESTORE_CONFIRMATION_CONFIRM_TEXT',
      CURRENT_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_CURRENT_PLAN_CTA',
      PRICE_SUFFIX_MONTH: 'PAYMENTS_PRICING_TABLE_PRICE_SUFFIX_MONTH',
      PRICE_SUFFIX_USER_MONTH: 'PAYMENTS_PRICING_TABLE_PRICE_SUFFIX_USER_MONTH',
      UPGRADE_CTA: 'PAYMENTS_PRICING_TABLE_UPGRADE_CTA',
      CHANGE_PLAN_CTA: 'PAYMENTS_PRICING_TABLE_CHANGE_PLAN_CTA',
      MONTHLY_CREDITS: 'PAYMENTS_PRICING_TABLE_MONTHLY_CREDITS',
      MONTHLY_CREDITS_PER_USER: 'PAYMENTS_PRICING_TABLE_MONTHLY_CREDITS_PER_USER',
      CREDITS_INFO_IMAGES: 'PAYMENTS_PRICING_TABLE_CREDITS_INFO_IMAGES',
      CREDITS_INFO_IMAGES_VIDEOS: 'PAYMENTS_PRICING_TABLE_CREDITS_INFO_IMAGES_VIDEOS',
      FEATURES_TITLE: 'PAYMENTS_PRICING_TABLE_FEATURES_TITLE',
      FREE_PLAN: {
        NAME: 'PAYMENTS_PRICING_TABLE_FREE_PLAN_NAME',
        DESCRIPTION: 'PAYMENTS_PRICING_TABLE_FREE_PLAN_DESCRIPTION',
      },
      STARTER_PLAN: {
        NAME: 'PAYMENTS_PRICING_TABLE_STARTER_PLAN_NAME',
        DESCRIPTION: 'PAYMENTS_PRICING_TABLE_STARTER_PLAN_DESCRIPTION',
      },
      PRO_PLAN: {
        NAME: 'PAYMENTS_PRICING_TABLE_PRO_PLAN_NAME',
        DESCRIPTION: 'PAYMENTS_PRICING_TABLE_PRO_PLAN_DESCRIPTION',
      },
      MAX_PLAN: {
        NAME: 'PAYMENTS_PRICING_TABLE_MAX_PLAN_NAME',
        DESCRIPTION: 'PAYMENTS_PRICING_TABLE_MAX_PLAN_DESCRIPTION',
      },
      TEAM_PLAN: {
        NAME: 'PAYMENTS_PRICING_TABLE_TEAM_PLAN_NAME',
        DESCRIPTION: 'PAYMENTS_PRICING_TABLE_TEAM_PLAN_DESCRIPTION',
      },
      CREDITS_TABLE_TITLE: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_TITLE',
      CREDITS_TABLE: {
        ARIA_LABEL: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_ARIA_LABEL',
        CATEGORY: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_CATEGORY',
        MODEL: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_MODEL',
        IMAGE: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_IMAGE',
        VIDEO: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_VIDEO',
        THREE_D: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_THREE_D',
        AUDIO: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_AUDIO',
        MONTHLY_CREDITS: 'PAYMENTS_PRICING_TABLE_CREDITS_TABLE_MONTHLY_CREDITS',
      },
      PARTNERS_TITLE: 'PAYMENTS_PRICING_TABLE_PARTNERS_TITLE',
      FAQ_TITLE: 'PAYMENTS_PRICING_TABLE_FAQ_TITLE',
      COMING_SOON: 'PAYMENTS_PRICING_TABLE_COMING_SOON',
      MOST_POPULAR: 'PAYMENTS_PRICING_TABLE_MOST_POPULAR',
      RECOMMENDED: 'PAYMENTS_PRICING_TABLE_RECOMMENDED',
      BILLED_ANNUALLY: 'PAYMENTS_PRICING_TABLE_BILLED_ANNUALLY',
      GAIN_20_PERCENT: 'PAYMENTS_PRICING_TABLE_GAIN_20_PERCENT',
      DISCOUNT: {
        BANNER: 'PAYMENTS_PRICING_TABLE_DISCOUNT_BANNER',
        FIRST_MONTH: 'PAYMENTS_PRICING_TABLE_DISCOUNT_FIRST_MONTH',
        FIRST_YEAR: 'PAYMENTS_PRICING_TABLE_DISCOUNT_FIRST_YEAR',
        FOOTNOTE: 'PAYMENTS_PRICING_TABLE_DISCOUNT_FOOTNOTE',
      },
      FAQS: {
        FAQ_1: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_1_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_1_ANSWER',
        },
        FAQ_2: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_2_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_2_ANSWER',
          ANSWER_MAX: 'PAYMENTS_PRICING_TABLE_FAQ_2_ANSWER_MAX',
        },
        FAQ_3: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_3_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_3_ANSWER',
          ANSWER_MAX: 'PAYMENTS_PRICING_TABLE_FAQ_3_ANSWER_MAX',
        },
        FAQ_4: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_4_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_4_ANSWER',
        },
        FAQ_5: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_5_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_5_ANSWER',
        },
        FAQ_6: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_6_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_6_ANSWER',
        },
        FAQ_7: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_7_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_7_ANSWER',
        },
        FAQ_8: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_8_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_8_ANSWER',
        },
        FAQ_9: {
          QUESTION: 'PAYMENTS_PRICING_TABLE_FAQ_9_QUESTION',
          ANSWER: 'PAYMENTS_PRICING_TABLE_FAQ_9_ANSWER',
        },
      },
    },
    CREDITS_SUCCESS_MESSAGE: 'PAYMENTS_CREDITS_SUCCESS_MESSAGE',
    UPGRADE_SUCCESS_MESSAGE: 'PAYMENTS_UPGRADE_SUCCESS_MESSAGE',
    DOWNGRADE_SUCCESS_MESSAGE: 'PAYMENTS_DOWNGRADE_SUCCESS_MESSAGE',
    UPGRADE_MODAL: {
      TITLE: 'PAYMENTS_UPGRADE_MODAL_TITLE',
      PROCESSING: 'PAYMENTS_UPGRADE_MODAL_PROCESSING',
      PLAN_DESCRIPTION: 'PAYMENTS_UPGRADE_MODAL_PLAN_DESCRIPTION',
      BILLING_CYCLE_INFO: 'PAYMENTS_UPGRADE_MODAL_BILLING_CYCLE_INFO',
      PRICE_PER_MONTH: 'PAYMENTS_UPGRADE_MODAL_PRICE_PER_MONTH',
      PRICE_PER_YEAR: 'PAYMENTS_UPGRADE_MODAL_PRICE_PER_YEAR',
      PAYMENT_METHOD_LABEL: 'PAYMENTS_UPGRADE_MODAL_PAYMENT_METHOD_LABEL',
      CHANGE_PAYMENT_METHOD: 'PAYMENTS_UPGRADE_MODAL_CHANGE_PAYMENT_METHOD',
      ERROR_MESSAGE: 'PAYMENTS_UPGRADE_MODAL_ERROR_MESSAGE',
      ERROR_MESSAGE_LINK: 'PAYMENTS_UPGRADE_MODAL_ERROR_MESSAGE_LINK',
      CTA_CONFIRM: 'PAYMENTS_UPGRADE_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_UPGRADE_MODAL_CTA_CANCEL',
    },
    DOWNGRADE_MODAL: {
      TITLE: 'PAYMENTS_DOWNGRADE_MODAL_TITLE',
      INDIVIDUAL_PLAN_TITLE: 'PAYMENTS_DOWNGRADE_MODAL_INDIVIDUAL_PLAN_TITLE',
      INDIVIDUAL_PLAN_CHANGE_MESSAGE: 'PAYMENTS_DOWNGRADE_MODAL_INDIVIDUAL_PLAN_CHANGE_MESSAGE',
      MEMBER_ACCESS_WARNING: 'PAYMENTS_DOWNGRADE_MODAL_MEMBER_ACCESS_WARNING',
      PLAN_CHANGE_MESSAGE: 'PAYMENTS_DOWNGRADE_MODAL_PLAN_CHANGE_MESSAGE',
      MONTHLY_PLAN_CHANGE_MESSAGE: 'PAYMENTS_DOWNGRADE_MODAL_MONTHLY_PLAN_CHANGE_MESSAGE',
      CTA_CONFIRM: 'PAYMENTS_DOWNGRADE_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_DOWNGRADE_MODAL_CTA_CANCEL',
    },
    GET_MORE_CREDITS_MODAL: {
      TITLE: 'PAYMENTS_GET_MORE_CREDITS_MODAL_TITLE',
      CTA_CONFIRM: 'PAYMENTS_GET_MORE_CREDITS_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_GET_MORE_CREDITS_MODAL_CTA_CANCEL',
      EQUALS: 'PAYMENTS_GET_MORE_CREDITS_MODAL_EQUALS',
      MIN_PRICE_ERROR: 'PAYMENTS_GET_MORE_CREDITS_MODAL_MIN_PRICE_ERROR',
      AMOUNT_LABEL: 'PAYMENTS_GET_MORE_CREDITS_MODAL_AMOUNT_LABEL',
      CREDITS_AMOUNT: 'PAYMENTS_GET_MORE_CREDITS_MODAL_CREDITS_AMOUNT',
      GENERATIONS_ESTIMATE: 'PAYMENTS_GET_MORE_CREDITS_MODAL_GENERATIONS_ESTIMATE',
    },
    CREDITS_OR_PRICING_MODAL: {
      TITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_TITLE',
      SUBTITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_SUBTITLE',
      CTA_CREDITS: {
        TITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CREDITS_TITLE',
        SUBTITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CREDITS_SUBTITLE',
      },
      CTA_PRICING: {
        TITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_PRICING_TITLE',
        SUBTITLE: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_PRICING_SUBTITLE',
      },
      CTA_CONFIRM: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CONFIRM',
      CTA_CANCEL: 'PAYMENTS_CREDITS_OR_PRICING_MODAL_CTA_CANCEL',
    },
    TEAM_SIZE_MODAL: {
      TITLE: 'PAYMENTS_TEAM_SIZE_MODAL_TITLE',
      SUBTITLE: 'PAYMENTS_TEAM_SIZE_MODAL_SUBTITLE',
      CTA_CONFIRM: 'PAYMENTS_TEAM_SIZE_MODAL_CTA_CONFIRM',
      DISCOUNT_DISCLAIMER: 'PAYMENTS_TEAM_SIZE_MODAL_DISCOUNT_DISCLAIMER',
    },
    ENTERPRISE_PACKAGE: {
      MAX_LAYOUT_DESCRIPTION: 'PAYMENTS_ENTERPRISE_MAX_LAYOUT_DESCRIPTION',
      PLAN_NAME: 'PAYMENTS_ENTERPRISE_PACKAGE_PLAN_NAME',
      PRICE: 'PAYMENTS_ENTERPRISE_PACKAGE_PRICE',
      TITLE: 'PAYMENTS_ENTERPRISE_PACKAGE_TITLE',
      SUBTITLE: 'PAYMENTS_ENTERPRISE_PACKAGE_SUBTITLE',
      CTA: 'PAYMENTS_ENTERPRISE_PACKAGE_CTA',
      FEATURE_CUSTOM_CREDITS: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_CUSTOM_CREDITS',
      FEATURE_TEAM_TRAINING: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_TEAM_TRAINING',
      FEATURE_PREMIUM_SUPPORT: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_PREMIUM_SUPPORT',
      FEATURE_OWN_API_KEYS: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_OWN_API_KEYS',
      FEATURE_API_WORKFLOWS: 'PAYMENTS_ENTERPRISE_PACKAGE_FEATURE_API_WORKFLOWS',
    },
  },
  PRODUCT_TOURS: {
    FLOW: {
      GET_TO_KNOW_THE_INTERFACE_TOUR: {
        COMMUNITY_AND_MY_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_COMMUNITY_AND_MY_MODELS_CONTENT',
        COMMUNITY_AND_MY_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_COMMUNITY_AND_MY_MODELS_TITLE',
        IMAGE_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_IMAGE_MODELS_CONTENT',
        IMAGE_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_IMAGE_MODELS_TITLE',
        SIDE_MENU_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_SIDE_MENU_CONTENT',
        SIDE_MENU_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_SIDE_MENU_TITLE',
        THREE_D_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_THREE_D_MODELS_CONTENT',
        THREE_D_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_THREE_D_MODELS_TITLE',
        TOOLBOX_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_TOOLBOX_CONTENT',
        TOOLBOX_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_TOOLBOX_TITLE',
        VIDEO_MODELS_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_VIDEO_MODELS_CONTENT',
        VIDEO_MODELS_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_VIDEO_MODELS_TITLE',
        WELCOME_CONTENT: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_WELCOME_CONTENT',
        WELCOME_TITLE: 'PRODUCT_TOURS_GET_TO_KNOW_THE_INTERFACE_TOUR_WELCOME_TITLE',
      },
      NAVIGATION_TOUR: {
        ADD_NODES_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ADD_NODES_CONTENT',
        ADD_NODES_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ADD_NODES_TITLE',
        CHOOSE_PREFERENCE_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_CONTENT',
        CHOOSE_PREFERENCE_CTA_MOUSE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_CTA_MOUSE',
        CHOOSE_PREFERENCE_CTA_TRACKPAD: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_CTA_TRACKPAD',
        CHOOSE_PREFERENCE_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CHOOSE_PREFERENCE_TITLE',
        CONNECT_NODES_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CONNECT_NODES_CONTENT',
        CONNECT_NODES_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_CONNECT_NODES_TITLE',
        DROP_NODE_HERE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_DROP_NODE_HERE',
        FINISH_TOUR_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_CONTENT',
        FINISH_TOUR_CTA_CONTINUE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_CTA_CONTINUE',
        FINISH_TOUR_CTA_STOP: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_CTA_STOP',
        FINISH_TOUR_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_FINISH_TOUR_TITLE',
        PAN_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_PAN_CONTENT',
        PAN_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_PAN_TITLE',
        RUN_MODEL_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_RUN_MODEL_CONTENT',
        RUN_MODEL_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_RUN_MODEL_TITLE',
        SHOW_NODE_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_SHOW_NODE_CONTENT',
        SHOW_NODE_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_SHOW_NODE_TITLE',
        WELCOME_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_WELCOME_CONTENT',
        WELCOME_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_WELCOME_TITLE',
        ZOOM_CONTENT: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ZOOM_CONTENT',
        ZOOM_TITLE: 'PRODUCT_TOURS_FLOW_NAVIGATION_TOUR_ZOOM_TITLE',
      },
      SAVE_NODES_TOUR: {
        SAVE_CTA_TITLE: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_SAVE_CTA_TITLE',
        SAVE_CTA_CONTENT: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_SAVE_CTA_CONTENT',
        SAVE_CTA_CANCEL: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_SAVE_CTA_CANCEL',
        SAVE_CTA_NEXT: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_SAVE_CTA_NEXT',
        VIEW_SAVED_ITEMS_TITLE: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_VIEW_SAVED_ITEMS_TITLE',
        VIEW_SAVED_ITEMS_CONTENT: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_VIEW_SAVED_ITEMS_CONTENT',
        VIEW_SAVED_ITEMS_CTA_GOT_IT: 'PRODUCT_TOURS_FLOW_SAVE_NODES_TOUR_VIEW_SAVED_ITEMS_CTA_GOT_IT',
      },
      TOOL_BUILDER_TOUR: {
        CTA_GOT_IT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_CTA_GOT_IT',
        INTRO_CONTENT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_INTRO_CONTENT',
        INTRO_CTA_GET_STARTED: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_INTRO_CTA_GET_STARTED',
        INTRO_CTA_LEARN_MORE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_INTRO_CTA_LEARN_MORE',
        INTRO_TITLE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_INTRO_TITLE',
        OUTPUT_CONTENT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_OUTPUT_CONTENT',
        OUTPUT_TITLE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_OUTPUT_TITLE',
        INPUTS_CONTENT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_INPUTS_CONTENT',
        INPUTS_TITLE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_INPUTS_TITLE',
        DETAILS_CONTENT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_DETAILS_CONTENT',
        DETAILS_TITLE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_DETAILS_TITLE',
        PREVIEW_CONTENT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_PREVIEW_CONTENT',
        PREVIEW_CTA: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_PREVIEW_CTA',
        PREVIEW_TITLE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_PREVIEW_TITLE',
        TOGGLE_MOVED_CONTENT: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_TOGGLE_MOVED_CONTENT',
        TOGGLE_MOVED_CTA: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_TOGGLE_MOVED_CTA',
        TOGGLE_MOVED_TITLE: 'PRODUCT_TOURS_FLOW_TOOL_BUILDER_TOUR_TOGGLE_MOVED_TITLE',
      },
    },
    NEXT_STEP: 'PRODUCT_TOURS_NEXT_STEP',
    PREVIOUS_STEP: 'PRODUCT_TOURS_PREVIOUS_STEP',
    QUIT_TOUR_CONFIRMATION_CANCEL: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_CANCEL',
    QUIT_TOUR_CONFIRMATION_CTA: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_CTA',
    QUIT_TOUR_CONFIRMATION_MESSAGE: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_MESSAGE',
    QUIT_TOUR_CONFIRMATION_TITLE: 'PRODUCT_TOURS_QUIT_TOUR_CONFIRMATION_TITLE',
    START_OF_TOUR: {
      SKIP: 'PRODUCT_TOURS_START_OF_TOUR_SKIP',
      START_NOW: 'PRODUCT_TOURS_START_OF_TOUR_START_NOW',
    },
    TOUR_STEP_INDICATION: 'PRODUCT_TOURS_TOUR_STEP_INDICATION',
    WELCOME_TEMPLATE_GALLERY: {
      TITLE: 'PRODUCT_TOURS_WELCOME_TEMPLATE_GALLERY_TITLE',
      CONTENT: 'PRODUCT_TOURS_WELCOME_TEMPLATE_GALLERY_CONTENT',
      GET_STARTED: 'PRODUCT_TOURS_WELCOME_TEMPLATE_GALLERY_GET_STARTED',
    },
    NUX_EMPTY_CANVAS_TOUR: {
      WRITE_PROMPT: {
        TITLE: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_WRITE_PROMPT_TITLE',
        CONTENT: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_WRITE_PROMPT_CONTENT',
      },
      CONNECT_NODE: {
        TITLE: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_CONNECT_NODE_TITLE',
        CONTENT: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_CONNECT_NODE_CONTENT',
      },
      ADD_MODEL: {
        TITLE: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_ADD_MODEL_TITLE',
        CONTENT: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_ADD_MODEL_CONTENT',
      },
      RUN_MODEL: {
        TITLE: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_RUN_MODEL_TITLE',
        CONTENT: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_RUN_MODEL_CONTENT',
      },
      MAKE_IT_YOUR_OWN: {
        TITLE: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_MAKE_IT_YOUR_OWN_TITLE',
        CONTENT: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_MAKE_IT_YOUR_OWN_CONTENT',
        ENDING: 'PRODUCT_TOURS_FLOW_NUX_EMPTY_CANVAS_TOUR_MAKE_IT_YOUR_OWN_ENDING',
      },
    },
  },
  RECIPE_MAIN: {
    ERRORS: {
      SAVE_ERRORS: {
        GENERAL: {
          MESSAGE: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_GENERAL_MESSAGE',
          ACTION: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_GENERAL_ACTION',
        },
        CONFLICT: {
          MESSAGE: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_CONFLICT_MESSAGE',
          ACTION: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_CONFLICT_ACTION',
        },
        MULTI_TAB: {
          MESSAGE: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_MULTI_TAB_MESSAGE',
          ACTION: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_MULTI_TAB_ACTION',
        },
        CONNECTION: {
          MESSAGE: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_CONNECTION_MESSAGE',
          ACTION: 'RECIPE_MAIN_ERRORS_SAVE_ERRORS_CONNECTION_ACTION',
        },
      },
      DOWNLOAD_FAILED: 'RECIPE_MAIN_ERRORS_DOWNLOAD_FAILED',
      EXPORT_AUDIT_TRAIL_FAILED: 'RECIPE_MAIN_ERRORS_EXPORT_AUDIT_TRAIL_FAILED',
      DOWNLOAD_FAILED_MULTIPLE: 'RECIPE_MAIN_ERRORS_DOWNLOAD_FAILED_MULTIPLE',
      DOWNLOAD_SIZE_EXCEEDED: 'RECIPE_MAIN_ERRORS_DOWNLOAD_SIZE_EXCEEDED',
      CLEAR_CONTENT_FAILED: 'RECIPE_MAIN_ERRORS_CLEAR_CONTENT_FAILED',
      PASTE_NODES_FAILED: 'RECIPE_MAIN_ERRORS_PASTE_NODES_FAILED',
      INSERT_NODES_FAILED: 'RECIPE_MAIN_ERRORS_INSERT_NODES_FAILED',
      COMMENTS: {
        POST_FAILED: 'RECIPE_MAIN_ERRORS_COMMENTS_POST_FAILED',
        EDIT_FAILED: 'RECIPE_MAIN_ERRORS_COMMENTS_EDIT_FAILED',
        RESOLVE_FAILED: 'RECIPE_MAIN_ERRORS_COMMENTS_RESOLVE_FAILED',
        REOPEN_FAILED: 'RECIPE_MAIN_ERRORS_COMMENTS_REOPEN_FAILED',
        DELETE_FAILED: 'RECIPE_MAIN_ERRORS_COMMENTS_DELETE_FAILED',
      },
    },
    COMMENTS: {
      COMPOSER_INPUT_ARIA: 'RECIPE_MAIN_COMMENTS_COMPOSER_INPUT_ARIA',
      COMPOSER_PLACEHOLDER: 'RECIPE_MAIN_COMMENTS_COMPOSER_PLACEHOLDER',
      POST_ARIA: 'RECIPE_MAIN_COMMENTS_POST_ARIA',
      POSTING: 'RECIPE_MAIN_COMMENTS_POSTING',
      PIN_ARIA: 'RECIPE_MAIN_COMMENTS_PIN_ARIA',
      DELETED_USER: 'RECIPE_MAIN_COMMENTS_DELETED_USER',
      JUST_NOW: 'RECIPE_MAIN_COMMENTS_JUST_NOW',
      THREAD_TITLE: 'RECIPE_MAIN_COMMENTS_THREAD_TITLE',
      RESOLVE: 'RECIPE_MAIN_COMMENTS_RESOLVE',
      REOPEN: 'RECIPE_MAIN_COMMENTS_REOPEN',
      CLOSE_THREAD: 'RECIPE_MAIN_COMMENTS_CLOSE_THREAD',
      REPLY_PLACEHOLDER: 'RECIPE_MAIN_COMMENTS_REPLY_PLACEHOLDER',
      POST_REPLY_ARIA: 'RECIPE_MAIN_COMMENTS_POST_REPLY_ARIA',
      EDITED: 'RECIPE_MAIN_COMMENTS_EDITED',
      MORE_ARIA: 'RECIPE_MAIN_COMMENTS_MORE_ARIA',
      EDIT: 'RECIPE_MAIN_COMMENTS_EDIT',
      DELETE: 'RECIPE_MAIN_COMMENTS_DELETE',
      EDIT_ARIA: 'RECIPE_MAIN_COMMENTS_EDIT_ARIA',
      SAVE_ARIA: 'RECIPE_MAIN_COMMENTS_SAVE_ARIA',
      DELETE_THREAD_TITLE: 'RECIPE_MAIN_COMMENTS_DELETE_THREAD_TITLE',
      DELETE_THREAD_MESSAGE: 'RECIPE_MAIN_COMMENTS_DELETE_THREAD_MESSAGE',
      DELETE_REPLY_TITLE: 'RECIPE_MAIN_COMMENTS_DELETE_REPLY_TITLE',
      DELETE_REPLY_MESSAGE: 'RECIPE_MAIN_COMMENTS_DELETE_REPLY_MESSAGE',
      PANEL_TITLE: 'RECIPE_MAIN_COMMENTS_PANEL_TITLE',
      PANEL_EMPTY: 'RECIPE_MAIN_COMMENTS_PANEL_EMPTY',
      FILTER_ARIA: 'RECIPE_MAIN_COMMENTS_FILTER_ARIA',
      SHOW_RESOLVED: 'RECIPE_MAIN_COMMENTS_SHOW_RESOLVED',
      REPLIES: 'RECIPE_MAIN_COMMENTS_REPLIES',
      MENTION_LIST_ARIA: 'RECIPE_MAIN_COMMENTS_MENTION_LIST_ARIA',
      MENTION_NO_RESULTS: 'RECIPE_MAIN_COMMENTS_MENTION_NO_RESULTS',
      SHARE_ON_MENTION_TITLE: 'RECIPE_MAIN_COMMENTS_SHARE_ON_MENTION_TITLE',
      SHARE_ON_MENTION_MESSAGE: 'RECIPE_MAIN_COMMENTS_SHARE_ON_MENTION_MESSAGE',
      SHARE_ON_MENTION_CONFIRM: 'RECIPE_MAIN_COMMENTS_SHARE_ON_MENTION_CONFIRM',
    },
    DOWNLOAD_PREPARING: 'RECIPE_MAIN_DOWNLOAD_PREPARING',
    NODE_EXPORT_DOWNLOADING: 'RECIPE_MAIN_NODE_EXPORT_DOWNLOADING',
    FLOW: {
      LEFT_TOOLS_PANEL: {
        TOOLBAR_ARIA: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_TOOLBAR_ARIA',
        MAIN_MENU: {
          BACK_TO_DASHBOARD: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_BACK_TO_DASHBOARD',
          CREATE_NEW_FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_CREATE_NEW_FILE',
          OPEN_RECENT: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_OPEN_RECENT',
          DUPLICATE_FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_DUPLICATE_FILE',
          USE_WHEEL_TO_ZOOM: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_USE_WHEEL_TO_ZOOM',
          RIGHT_CLICK_TO_OPEN_MENU: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_RIGHT_CLICK_TO_OPEN_MENU',
          REQUIRE_ALT_KEY_FOR_SUGGESTIONS:
            'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_REQUIRE_ALT_KEY_FOR_SUGGESTIONS',
          SHARE_WORKFLOW: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_SHARE_WORKFLOW',
          VERSION_HISTORY: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_VERSION_HISTORY',
          VERSION_HISTORY_RUN_IN_PROGRESS:
            'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_VERSION_HISTORY_RUN_IN_PROGRESS',
          RENAME_WORKFLOW: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_RENAME_WORKFLOW',
          EXPORT_LINEAGE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EXPORT_LINEAGE',
          KEYBOARD_SHORTCUTS: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_KEYBOARD_SHORTCUTS',
          PREFERENCES: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_PREFERENCES',
          SNAP_TO_GRID: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_SNAP_TO_GRID',
          SNAP_TO_NODES: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_SNAP_TO_NODES',
          LIGHT_MODE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_LIGHT_MODE',
          THEME: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_THEME',
          THEME_DARK: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_THEME_DARK',
          THEME_LIGHT: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_THEME_LIGHT',
          THEME_SYSTEM: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_THEME_SYSTEM',
          EDGE_STYLE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE',
          EDGE_STYLE_BEZIER: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE_BEZIER',
          EDGE_STYLE_STEP: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE_STEP',
          EDGE_STYLE_LINE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_EDGE_STYLE_LINE',
          FIGMA_EMBED_FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_FILE',
          FIGMA_EMBED_NEW_WEAVE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_NEW_WEAVE',
          FIGMA_EMBED_MAKE_A_COPY: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_MAKE_A_COPY',
          FIGMA_EMBED_AI_BALANCE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_AI_BALANCE',
          FIGMA_EMBED_AI_BALANCE_LOADING_ARIA:
            'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_AI_BALANCE_LOADING_ARIA',
          FIGMA_EMBED_HELP_AND_ACCOUNT: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_HELP_AND_ACCOUNT',
          FIGMA_EMBED_LEGAL_SUMMARY: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_LEGAL_SUMMARY',
          FIGMA_EMBED_ACCOUNT_SETTINGS: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_ACCOUNT_SETTINGS',
          FIGMA_EMBED_LOG_OUT: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_LOG_OUT',
          FIGMA_EMBED_GO_TO_PROJECT: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_GO_TO_PROJECT',
          FIGMA_EMBED_MOVE_FILE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_MOVE_FILE',
          FIGMA_EMBED_MOVE_TO_TRASH: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_MOVE_TO_TRASH',
          FIGMA_EMBED_PIN_TO_WORKSPACE: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_PIN_TO_WORKSPACE',
          FIGMA_EMBED_RENAME: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_RENAME',
          FIGMA_EMBED_ADD_TO_SIDEBAR: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_ADD_TO_SIDEBAR',
          FIGMA_EMBED_SIDEBAR_PREFIX: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_SIDEBAR_PREFIX',
          FIGMA_EMBED_REMOVE_FROM_SIDEBAR:
            'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_REMOVE_FROM_SIDEBAR',
          FIGMA_EMBED_STARRED: 'RECIPE_MAIN_FLOW_LEFT_TOOLS_PANEL_MAIN_MENU_FIGMA_EMBED_STARRED',
        },
        RAIL: {
          ARIA_LABEL: 'LEFT_RAIL_ARIA_LABEL',
          RECENTS: 'LEFT_RAIL_RECENTS',
          SAVED: 'LEFT_RAIL_SAVED',
          TOOLS: 'LEFT_RAIL_TOOLS',
          IMAGE: 'LEFT_RAIL_IMAGE',
          VIDEO: 'LEFT_RAIL_VIDEO',
          THREE_D: 'LEFT_RAIL_THREE_D',
          AUDIO: 'LEFT_RAIL_AUDIO',
          MODELS: 'LEFT_RAIL_MODELS',
          IMAGES: 'LEFT_RAIL_IMAGES',
          ASSETS: 'LEFT_RAIL_ASSETS',
        },
        TITLE: {
          RECENT: 'RECENT',
          TOOLBOX: 'TOOLBOX',
          IMAGE: 'IMAGE',
          VIDEO: 'VIDEO',
          THREEDEE: 'THREEDEE',
          AUDIO: 'AUDIO',
          MY_MODELS: 'MY_MODELS',
          COMMUNITY_MODELS: 'COMMUNITY_MODELS',
          MEDIA: 'MEDIA',
          AI_CHAT: 'AI_WEAVER',
        },
      },
      ACTIONS: {
        ZOOM_IN: 'ZOOM_IN',
        ZOOM_OUT: 'ZOOM_OUT',
        ZOOM_TO_HUNDRED: 'ZOOM_TO_HUNDRED',
        ZOOM_TO_FIT: 'ZOOM_TO_FIT',
        RUN_SELECTED: 'RUN_SELECTED',
      },
      WORKFLOW: 'WORKFLOW',
      EDITOR_MODE_ARIA: 'RECIPE_MAIN_FLOW_EDITOR_MODE_ARIA',
      DESIGN_APP: 'DESIGN_APP',
      CREDITS_INFO_CREDITS: 'CREDITS_INFO_CREDITS',
      SHARE: 'SHARE',
      CANNOT_DELETE_GROUP_WITH_LOCKED_NODES: 'RECIPE_MAIN_FLOW_CANNOT_DELETE_GROUP_WITH_LOCKED_NODES',
      CANNOT_ADD_NODES_IN_TOOL_TAB: 'RECIPE_MAIN_FLOW_CANNOT_ADD_NODES_IN_TOOL_TAB',
      CANNOT_EDIT_IN_TOOL_TAB: 'RECIPE_MAIN_FLOW_CANNOT_EDIT_IN_TOOL_TAB',
      APP_BUILDER_RIGHT_PANEL: {
        OUTPUTS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_OUTPUTS',
        INPUTS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_INPUTS',
        INPUTS_DESCRIPTION: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_INPUTS_DESCRIPTION',
        TOOL_DETAILS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_TOOL_DETAILS',
        FILL_IN_TOOL_DETAILS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_FILL_IN_TOOL_DETAILS',
        THUMBNAIL_LABEL: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_THUMBNAIL_LABEL',
        NAME_REQUIRED: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_NAME_REQUIRED',
        TOOL_DESCRIPTION_PLACEHOLDER: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_TOOL_DESCRIPTION_PLACEHOLDER',
        SHOW_WORKFLOW_TO_VIEWERS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_SHOW_WORKFLOW_TO_VIEWERS',
        REMOVE_THUMBNAIL_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_REMOVE_THUMBNAIL_ARIA',
        THUMBNAIL_SCOPE_IN_OUTPUTS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_THUMBNAIL_SCOPE_IN_OUTPUTS',
        THUMBNAIL_OUTPUTS_GALLERY_EMPTY: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_THUMBNAIL_OUTPUTS_GALLERY_EMPTY',
        THUMBNAIL_WORKFLOW_GALLERY_EMPTY: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_THUMBNAIL_WORKFLOW_GALLERY_EMPTY',
        TOOL_VERSION_AVAILABLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_TOOL_VERSION_AVAILABLE',
        GO_TO_TOOL: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_GO_TO_TOOL',
        EDIT_TOOL_DETAILS_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EDIT_TOOL_DETAILS_ARIA',
        ADD_OUTPUT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_ADD_OUTPUT',
        COLLAPSE_SECTION_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_COLLAPSE_SECTION_ARIA',
        EXPAND_SECTION_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EXPAND_SECTION_ARIA',
        PREVIEW_AND_FINALIZE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_PREVIEW_AND_FINALIZE',
        TOOL_NAME_MISSING: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_TOOL_NAME_MISSING',
        SHOW_WORKFLOW_TO_VIEWERS_HELPER: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_SHOW_WORKFLOW_TO_VIEWERS_HELPER',
        THUMBNAIL_TYPE_INVALID: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_THUMBNAIL_TYPE_INVALID',
        SELECT_OUTPUT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_SELECT_OUTPUT',
        NO_ELIGIBLE_OUTPUTS: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_NO_ELIGIBLE_OUTPUTS',
        EMPTY_NO_OUTPUTS_LINE_1: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EMPTY_NO_OUTPUTS_LINE_1',
        EMPTY_NO_OUTPUTS_LINE_2: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EMPTY_NO_OUTPUTS_LINE_2',
        EDIT_DATA_TITLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EDIT_DATA_TITLE',
        DESCRIPTION: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_DESCRIPTION',
        DESCRIPTION_PLACEHOLDER: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_DESCRIPTION_PLACEHOLDER',
        DEFAULT_CONTENT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_DEFAULT_CONTENT',
        DEFAULT_VALUE_PLACEHOLDER: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_DEFAULT_VALUE_PLACEHOLDER',
        USE_NODE_VALUE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_USE_NODE_VALUE',
        ADD_NEW_CONTENT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_ADD_NEW_CONTENT',
        ADD_NEW_CONTENT_UNSUPPORTED: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_ADD_NEW_CONTENT_UNSUPPORTED',
        IMAGE_DEFAULT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_IMAGE_DEFAULT',
        UPLOADING: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_UPLOADING',
        REMOVE_IMAGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_REMOVE_IMAGE',
        MANDATORY: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_MANDATORY',
        MANDATORY_FORCED_TOOLTIP: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_MANDATORY_FORCED_TOOLTIP',
        EXAMPLE_CONTENT: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EXAMPLE_CONTENT',
        EXAMPLE_CONTENT_DESCRIPTION: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EXAMPLE_CONTENT_DESCRIPTION',
        EXAMPLE_EMPTY_DESCRIPTION: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EXAMPLE_EMPTY_DESCRIPTION',
        EXAMPLE_TILE_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EXAMPLE_TILE_ARIA',
        UPLOADED_EXAMPLE_TILE_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_UPLOADED_EXAMPLE_TILE_ARIA',
        UPLOAD_EXAMPLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_UPLOAD_EXAMPLE',
        UPLOADED_EXAMPLES: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_UPLOADED_EXAMPLES',
        EXAMPLES_LIMIT_REACHED: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EXAMPLES_LIMIT_REACHED',
        UPLOADS_LIMIT_REACHED: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_UPLOADS_LIMIT_REACHED',
        REMOVE_EXAMPLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_REMOVE_EXAMPLE',
        UPLOADING_EXAMPLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_UPLOADING_EXAMPLE',
        EDIT_EXAMPLE_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_RIGHT_PANEL_EDIT_EXAMPLE_ARIA',
      },
      APP_BUILDER_CANVAS: {
        SET_AS_OUTPUT: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_SET_AS_OUTPUT',
        CANNOT_SET_AS_OUTPUT: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_CANNOT_SET_AS_OUTPUT',
        OUTPUT_BADGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_OUTPUT_BADGE',
        INPUT_BADGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_INPUT_BADGE',
        HIDDEN_INPUT_BADGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_HIDDEN_INPUT_BADGE',
        REMOVE_OUTPUT_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_REMOVE_OUTPUT_ARIA',
        EXPOSE_INPUT_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_EXPOSE_INPUT_ARIA',
        HIDE_INPUT_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_HIDE_INPUT_ARIA',
        REORDER_INPUT_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_REORDER_INPUT_ARIA',
        REORDER_OUTPUT_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_REORDER_OUTPUT_ARIA',
        PICK_OUTPUT_PROMPT: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_PICK_OUTPUT_PROMPT',
        EDIT_INPUT_DETAILS_ARIA: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_EDIT_INPUT_DETAILS_ARIA',
        DELETE_TOOL_OUTPUT_TITLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_DELETE_TOOL_OUTPUT_TITLE',
        DELETE_TOOL_OUTPUT_MESSAGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_DELETE_TOOL_OUTPUT_MESSAGE',
        DELETE_TOOL_OUTPUT_CONFIRM: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_DELETE_TOOL_OUTPUT_CONFIRM',
        DISCONNECT_TOOL_OUTPUT_TITLE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_DISCONNECT_TOOL_OUTPUT_TITLE',
        DISCONNECT_TOOL_OUTPUT_MESSAGE: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_DISCONNECT_TOOL_OUTPUT_MESSAGE',
        DISCONNECT_TOOL_OUTPUT_CONFIRM: 'RECIPE_MAIN_FLOW_APP_BUILDER_CANVAS_DISCONNECT_TOOL_OUTPUT_CONFIRM',
      },
      FLOW_NAVBAR: {
        DUPLICATE_TO_MY_FILES: 'DUPLICATE_TO_MY_FILES',
        READ_ONLY: 'READ_ONLY',
        SAVING: 'SAVING',
      },
      GALLERY: {
        DELETE_ALL_GENERATIONS: 'RECIPE_MAIN_GALLERY_DELETE_ALL_GENERATIONS',
        DELETE_ALL_OTHERS_GENERATIONS: 'RECIPE_MAIN_GALLERY_DELETE_ALL_OTHERS_GENERATIONS',
        DELETE_CURRENT_GENERATION: 'RECIPE_MAIN_GALLERY_DELETE_CURRENT_GENERATION',
        DOWNLOAD_CURRENT: 'RECIPE_MAIN_GALLERY_DOWNLOAD_CURRENT',
        DOWNLOAD_SELECTED: 'RECIPE_MAIN_GALLERY_DOWNLOAD_SELECTED',
        DOWNLOAD_ALL: 'RECIPE_MAIN_GALLERY_DOWNLOAD_ALL',
        DOWNLOAD_BATCH: 'RECIPE_MAIN_GALLERY_DOWNLOAD_BATCH',
        FULL_SCREEN: 'RECIPE_MAIN_GALLERY_FULL_SCREEN',
        PARAMS: {
          HIDE_INFO: 'HIDE_INFO',
          NO_PREVIEW: 'NO_PREVIEW',
          NEGATIVE_PROMPT: 'NEGATIVE_PROMPT',
          MODEL: 'MODEL',
          PARAMETERS: 'PARAMETERS',
          PROMPT: 'PROMPT',
          SHOW_INFO: 'SHOW_INFO',
          SHOW_MORE: 'SHOW_MORE',
          SHOW_LESS: 'SHOW_LESS',
          REFERENCE_IMAGE: 'REFERENCE_IMAGE',
        },
        SET_AS_COVER: 'RECIPE_MAIN_GALLERY_SET_AS_COVER',
      },
      GROUP: {
        DELETE_GROUP_CONFIRMATION: {
          TITLE_SINGLE: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_TITLE_SINGLE',
          TITLE_PLURAL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_TITLE_PLURAL',
          MESSAGE_SINGLE: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_MESSAGE_SINGLE',
          MESSAGE_PLURAL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_MESSAGE_PLURAL',
          CTA_CONFIRM: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_CTA_CONFIRM',
          CTA_CANCEL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_CTA_CANCEL',
          CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_GROUP_DELETE_GROUP_CONFIRMATION_CHECKBOX_LABEL',
        },
      },
      GENERAL: {
        READ_ONLY_PANEL: {
          CTA_EDITOR: 'READ_ONLY_PANEL_CTA_EDITOR',
          CTA_READER: 'READ_ONLY_PANEL_CTA_READER',
          CTA_GUEST: 'READ_ONLY_PANEL_CTA_GUEST',
          TITLE_EDITOR: 'READ_ONLY_PANEL_TITLE_EDITOR',
          TITLE_READER: 'READ_ONLY_PANEL_TITLE_READER',
          TITLE_TOOL_VERSION: 'READ_ONLY_PANEL_TITLE_TOOL_VERSION',
          CTA_LIVE_DRAFT: 'READ_ONLY_PANEL_CTA_LIVE_DRAFT',
        },
      },
      LEFT_PANEL: {
        MEDIA_LIBRARY: {
          NO_MEDIA: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_NO_MEDIA',
          EMPTY_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_EMPTY_TITLE',
          EMPTY_DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_EMPTY_DESCRIPTION',
          NO_MATCH: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_NO_MATCH',
          NO_MATCH_HINT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_NO_MATCH_HINT',
          SHOW_ALL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_SHOW_ALL',
          FILTER_GENERATIONS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_FILTER_GENERATIONS',
          FILTER_UPLOADS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_FILTER_UPLOADS',
          DOWNLOAD_SELECTED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_DOWNLOAD_SELECTED',
          GO_TO_NODE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_GO_TO_NODE',
          IN_NODES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MEDIA_LIBRARY_IN_NODES',
        },
        MODELS: {
          COMMUNITY_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MODELS_COMMUNITY_MODELS',
          MY_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_MODELS_MY_MODELS',
        },
        TOOLBOX: {
          MOST_USED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_MOST_USED',
        },
        MENU_TITLES: {
          RECENT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_RECENT',
          TOOLS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_TOOLS',
          IMAGE_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_IMAGE_MODELS',
          VIDEO_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_VIDEO_MODELS',
          THREE_D_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_THREE_D_MODELS',
          AUDIO_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_AUDIO_MODELS',
          CUSTOM_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_CUSTOM_MODELS',
          FREQUENTLY_USED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_FREQUENTLY_USED',
          DATA_TYPES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_DATATYPES',
          NON_MODEL_EDIT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_EDITING',
          ITERATORS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_ITERATORS',
          HELPERS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_HELPERS',
          TEXT_TOOLS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_TEXT_TOOLS',
          GENERATE_IMAGE_FROM_TEXT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_IMAGE_FROM_TEXT',
          MATTING: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_MATTING_TOOLS',
          LIP_SYNC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_LIP_SYNC',
          GENERATE_VECTOR_FROM_TEXT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_VECTOR_FROM_TEXT',
          EDIT_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_EDIT_IMAGE',
          GENERATE_IMAGE_FROM_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_IMAGE_FROM_IMAGE',
          ENHANCE_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_ENHANCE_IMAGE',
          GENERATE_VIDEO_FROM_TEXT_OR_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_VIDEO_FROM_TEXT_OR_IMAGE',
          GENERATE_VIDEO_FROM_VIDEO: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_VIDEO_FROM_VIDEO',
          EXTEND_VIDEO: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_EXTEND_VIDEO',
          ENHANCE_VIDEO: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_ENHANCE_VIDEO',
          GENERATE_3D_FROM_TEXT_OR_IMAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_3D_FROM_TEXT_OR_IMAGE',
          GENERATE_TEXTURES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_GENERATE_TEXTURES',
          MUSIC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_MUSIC',
          VOICEOVER: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_VOICEOVER',
          SOUND_EFFECTS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SOUND_EFFECTS',
          VOICE_CLONING: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_VOICE_CLONING',
          TRANSCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_TRANSCRIPTION',
          USER_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_USER_MODELS',
          COMMUNITY_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_COMMUNITY_MODELS',
          SAVED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED',
          SAVED_MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED_MODELS',
          SAVED_NODES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED_NODES',
          SAVED_GROUPS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_TOOLBOX_SAVED_GROUPS',
        },
        SEARCH: {
          EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_SEARCH_EMPTY',
        },
        NEW_INDICATOR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NEW_INDICATOR',
        PROMO_INDICATOR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_PROMO_INDICATOR',
        NODE_DETAILS: {
          VERIFIED_BY_FIGMA: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_VERIFIED_BY_FIGMA',
          VERIFIED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_VERIFIED',
          UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS:
            'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS',
          UNVERIFIED_DISCLAIMER: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_UNVERIFIED_DISCLAIMER',
          BASED_ON: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_BASED_ON',
          CREATED_BY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_CREATED_BY',
          CREATED_BY_ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_NODE_DETAILS_CREATED_BY_ME',
        },
        ITERATOR_MENU_ITEMS: {
          TEXT_ITERATOR: {
            DISPLAY_NAME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_TEXT_ITERATOR_DISPLAY_NAME',
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_TEXT_ITERATOR_DESCRIPTION',
          },
          IMAGE_ITERATOR: {
            DISPLAY_NAME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_IMAGE_ITERATOR_DISPLAY_NAME',
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_IMAGE_ITERATOR_DESCRIPTION',
          },
          VIDEO_ITERATOR: {
            DISPLAY_NAME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_VIDEO_ITERATOR_DISPLAY_NAME',
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_VIDEO_ITERATOR_DESCRIPTION',
          },
          BLEND: {
            DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_ITERATOR_MENU_ITEMS_BLEND_DESCRIPTION',
          },
        },
        WORKSPACE_ASSETS: {
          TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_TITLE',
          MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_MODELS',
          NODES: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NODES',
          GROUPS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_GROUPS',
          NODES_EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NODES_EMPTY',
          MODELS_EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_MODELS_EMPTY',
          GROUPS_EMPTY: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_GROUPS_EMPTY',
          EDIT_TOOLTIP: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_TOOLTIP',
          DONE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DONE',
          EDIT_DIALOG_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_DIALOG_TITLE',
          EDIT_SAVE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_SAVE',
          EDIT_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_SUCCESS',
          EDIT_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EDIT_ERROR',
          DELETE_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_TITLE',
          DELETE_MESSAGE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_MESSAGE',
          DELETE_CONFIRM: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_CONFIRM',
          DELETE_DONT_SHOW: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_DONT_SHOW',
          DELETE_MODEL_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_MODEL_SUCCESS',
          DELETE_NODE_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_NODE_SUCCESS',
          DELETE_GROUP_SUCCESS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_GROUP_SUCCESS',
          DELETE_MODEL_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_MODEL_ERROR',
          DELETE_NODE_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_NODE_ERROR',
          DELETE_GROUP_ERROR: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_DELETE_GROUP_ERROR',
          GROUP_NODE_COUNT: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_GROUP_NODE_COUNT',
          NOT_OWNER_TOOLTIP: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NOT_OWNER_TOOLTIP',
          MODELS_EMPTY_ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_MODELS_EMPTY_ME',
          NODES_EMPTY_ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_NODES_EMPTY_ME',
          GROUPS_EMPTY_ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_GROUPS_EMPTY_ME',
          EMPTY_STATE_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_TITLE',
          EMPTY_STATE_DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_DESCRIPTION',
          EMPTY_STATE_ME_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_ME_TITLE',
          EMPTY_STATE_ME_DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_ME_DESCRIPTION',
          EMPTY_STATE_EMBED_TITLE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_EMBED_TITLE',
          EMPTY_STATE_EMBED_DESCRIPTION: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_EMBED_DESCRIPTION',
          EMPTY_STATE_LEARN_MORE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_EMPTY_STATE_LEARN_MORE',
          CREATED_BY: {
            LABEL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_CREATED_BY_LABEL',
            ALL_WORKSPACE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_CREATED_BY_ALL_WORKSPACE',
            ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_CREATED_BY_ME',
            TRIGGER_ALL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_CREATED_BY_TRIGGER_ALL',
            TRIGGER_ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_WORKSPACE_ASSETS_CREATED_BY_TRIGGER_ME',
          },
        },
        FILTERS: {
          ORDERBY: {
            LABEL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_LABEL',
            FEATURED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_FEATURED',
            PRICE_ASC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_PRICE_ASC',
            PRICE_DESC: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_ORDERBY_PRICE_DESC',
          },
          MODE_TOGGLE: {
            ALL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_ALL',
            TOOLS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_TOOLS',
            MODELS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_MODELS',
            GROUPS: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_GROUPS',
            VERIFIED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_VERIFIED',
            UNVERIFIED: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_MODE_TOGGLE_UNVERIFIED',
          },
          CREATED_BY: {
            LABEL: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_CREATED_BY_LABEL',
            WEAVE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_CREATED_BY_WEAVE',
            WORKSPACE: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_CREATED_BY_WORKSPACE',
            ME: 'RECIPE_MAIN_FLOW_LEFT_PANEL_FILTERS_CREATED_BY_ME',
          },
        },
      },
      DRAWER: {
        MODEL_PROPERTIES: {
          BYOK_LABEL: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_BYOK_LABEL',
          BYOK_TOOLTIP: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_BYOK_TOOLTIP',
          NUM_OF_MODELS: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_NUM_OF_MODELS',
          SET_AS_INPUT: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_SET_AS_INPUT',
          SET_AS_PARAMETER: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_SET_AS_PARAMETER',
          SPEAKER_NAME_PLACEHOLDER: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_SPEAKER_NAME_PLACEHOLDER',
          ADD_LIST_ITEM: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_ADD_LIST_ITEM',
          LIST_ITEM_PLACEHOLDER: 'RECIPE_MAIN_FLOW_DRAWER_MODEL_PROPERTIES_LIST_ITEM_PLACEHOLDER',
        },
        RUN_MODELS_SECTION: {
          TITLE: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_TITLE',
          RUNS: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_RUNS',
          CTA: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_CTA',
          UNSUPPORTED_NODES_INFO: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_UNSUPPORTED_NODES_INFO',
          ALREADY_RUNNING_INFO: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_ALREADY_RUNNING_INFO',
          NOT_ENOUGH_CREDITS: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_NOT_ENOUGH_CREDITS',
          NOT_ENOUGH_CREDITS_INDIVIDUAL: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_NOT_ENOUGH_CREDITS_INDIVIDUAL',
          NOT_ENOUGH_CREDITS_TEAM: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_NOT_ENOUGH_CREDITS_TEAM',
          OUT_OF_CREDITS_BETA: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_OUT_OF_CREDITS_BETA',
          REQUEST_TOO_LARGE: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_REQUEST_TOO_LARGE',
          ITERATORS_INFO: {
            TITLE: 'RECIPE_MAIN_FLOW_DRAWER_RUN_MODELS_SECTION_ITERATORS_INFO_TITLE',
          },
        },
      },
      SUGGESTION_MENU: {
        DROP_INDICATION: 'RECIPE_MAIN_FLOW_SUGGESTION_MENU_DROP_INDICATION',
      },
      MULTI_CONNECT: {
        INCOMPATIBLE_TARGET: 'RECIPE_MAIN_FLOW_MULTI_CONNECT_INCOMPATIBLE_TARGET',
        PARTIAL_SUCCESS: 'RECIPE_MAIN_FLOW_MULTI_CONNECT_PARTIAL_SUCCESS',
        NO_COMPATIBLE_NODE_FOR_TYPES: 'RECIPE_MAIN_FLOW_MULTI_CONNECT_NO_COMPATIBLE_NODE_FOR_TYPES',
      },
      PRICY_MODEL_MODAL: {
        TITLE: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_TITLE',
        SUBTITLE: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_SUBTITLE',
        CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_CHECKBOX_LABEL',
        MODEL_NAME_PLACEHOLDER: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_MODEL_NAME_PLACEHOLDER',
        CTA_CONFIRM: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_CTA_CONFIRM',
        CTA_CANCEL: 'RECIPE_MAIN_FLOW_PRICY_MODEL_MODAL_CTA_CANCEL',
      },
      UNKNOWN_COST: {
        DIALOG: {
          TITLE: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_DIALOG_TITLE',
          MSG: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_DIALOG_MSG',
          CONFIRM_BTN_TEXT: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_DIALOG_CONFIRM_BTN_TEXT',
        },
        PRICE_TEXT: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_TEXT',
        TOOLTIP: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_TOOLTIP',
        PRICE_LOAD_ERROR: 'RECIPE_MAIN_FLOW_UNKNOWN_COST_PRICE_LOAD_ERROR',
      },
      ITERATORS_SECTION: {
        ITERATION_MODE_TITLE: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_TITLE',
        ITERATION_MODE_PARALLEL_SHORT: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_PARALLEL_SHORT',
        ITERATION_MODE_PARALLEL_TITLE: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_PARALLEL_TITLE',
        ITERATION_MODE_PARALLEL_DESCRIPTION: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_PARALLEL_DESCRIPTION',
        ITERATION_MODE_PARALLEL_FOOTNOTE: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_PARALLEL_FOOTNOTE',
        ITERATION_MODE_MATRIX_SHORT: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_MATRIX_SHORT',
        ITERATION_MODE_MATRIX_TITLE: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_MATRIX_TITLE',
        ITERATION_MODE_MATRIX_DESCRIPTION: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_MATRIX_DESCRIPTION',
        ITERATION_MODE_TOTAL_RUNS: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_ITERATION_MODE_TOTAL_RUNS',
        VALUES: 'RECIPE_MAIN_FLOW_ITERATORS_SECTION_VALUES',
      },
      UNVERIFIED_MODEL_RUN: {
        DIALOG: {
          TITLE: 'RECIPE_MAIN_FLOW_UNVERIFIED_MODEL_RUN_DIALOG_TITLE',
          TEXT: 'RECIPE_MAIN_FLOW_UNVERIFIED_MODEL_RUN_DIALOG_TEXT',
        },
        DIALOG_IMPORTED_MODEL: {
          TITLE: 'RECIPE_MAIN_FLOW_UNVERIFIED_MODEL_RUN_DIALOG_IMPORTED_MODEL_TITLE',
        },
      },
      CLEAR_ALL_CONTENT_CONFIRMATION: {
        TITLE: 'RECIPE_MAIN_FLOW_CLEAR_ALL_CONTENT_CONFIRMATION_TITLE',
        MESSAGE: 'RECIPE_MAIN_FLOW_CLEAR_ALL_CONTENT_CONFIRMATION_MESSAGE',
        CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_CLEAR_ALL_CONTENT_CONFIRMATION_CHECKBOX_LABEL',
      },
      CLEAR_OTHER_CONTENT_CONFIRMATION: {
        TITLE: 'RECIPE_MAIN_FLOW_CLEAR_OTHER_CONTENT_CONFIRMATION_TITLE',
        MESSAGE: 'RECIPE_MAIN_FLOW_CLEAR_OTHER_CONTENT_CONFIRMATION_MESSAGE',
        CHECKBOX_LABEL: 'RECIPE_MAIN_FLOW_CLEAR_OTHER_CONTENT_CONFIRMATION_CHECKBOX_LABEL',
      },
      EMPTY_CANVAS_OVERLAY: {
        START_FROM_TEMPLATE: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_START_FROM_TEMPLATE',
        DIVIDER: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_DIVIDER',
        BUTTON: {
          START_FROM_PROMPT: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_BUTTON_START_FROM_PROMPT',
          PROMPT: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_BUTTON_PROMPT',
        },
        TEMPLATE_PICKER: {
          TITLE: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_TEMPLATE_PICKER_TITLE',
          FIGMA_COMMUNITY: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_TEMPLATE_PICKER_FIGMA_COMMUNITY',
          USE_IN_FILE: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_TEMPLATE_PICKER_USE_IN_FILE',
          START_HERE: 'RECIPE_MAIN_FLOW_EMPTY_CANVAS_OVERLAY_TEMPLATE_PICKER_START_HERE',
        },
      },
    },
    NODES: {
      DEPRECATED: {
        GENERAL: 'GENERAL_DEPRECATION_MESSAGE',
        EDIT: 'EDIT_DEPRECATION_MESSAGE',
        COMPV2: 'COMPOSITOR_V2_DEPRECATION_MESSAGE',
        OUTPUT: 'OUTPUT_NODE_DEPRECATION_MESSAGE',
        OUTPUT_BANNER: 'OUTPUT_NODE_DEPRECATION_BANNER',
      },
      SHARED: {
        NODE_DETAILS_ACCORDION: {
          TITLE: 'RECIPE_MAIN_NODES_SHARED_NODE_DETAILS_ACCORDION_TITLE',
        },
        SHOW_MORE_CHIP: {
          SHOW_MORE: 'RECIPE_MAIN_NODES_SHARED_SHOW_MORE_CHIP_SHOW_MORE',
          SHOW_LESS: 'RECIPE_MAIN_NODES_SHARED_SHOW_MORE_CHIP_SHOW_LESS',
        },
      },
      EXPORT: {
        EXPORT_CTA: 'EXPORT',
        EXPORT_CTA_RENDERING: 'RENDERING',
        FORMAT_LABEL: 'FORMAT',
      },
      FIGMA_NODE: {
        PLACEHOLDER: 'RECIPE_MAIN_NODES_FIGMA_NODE_PLACEHOLDER',
        FRAME_FALLBACK: 'RECIPE_MAIN_NODES_FIGMA_NODE_FRAME_FALLBACK',
        ADD_INPUT: 'RECIPE_MAIN_NODES_FIGMA_NODE_ADD_INPUT',
        ADD_INPUT_OPTION_TEXT: 'RECIPE_MAIN_NODES_FIGMA_NODE_ADD_INPUT_OPTION_TEXT',
        ADD_INPUT_OPTION_IMAGE: 'RECIPE_MAIN_NODES_FIGMA_NODE_ADD_INPUT_OPTION_IMAGE',
        INITIALIZE_ERROR_NO_ACCESS: 'RECIPE_MAIN_NODES_FIGMA_NODE_INITIALIZE_ERROR_NO_ACCESS',
        INITIALIZE_ERROR_NOT_CONNECTED: 'RECIPE_MAIN_NODES_FIGMA_NODE_INITIALIZE_ERROR_NOT_CONNECTED',
        INITIALIZE_ERROR_GENERIC: 'RECIPE_MAIN_NODES_FIGMA_NODE_INITIALIZE_ERROR_GENERIC',
        PASTE_ERROR_UNSUPPORTED_SELECTION: 'RECIPE_MAIN_NODES_FIGMA_NODE_PASTE_ERROR_UNSUPPORTED_SELECTION',
        PASTE_ERROR_WRONG_ENVIRONMENT: 'RECIPE_MAIN_NODES_FIGMA_NODE_PASTE_ERROR_WRONG_ENVIRONMENT',
        PASTE_LINK_ACCOUNT_ACTION: 'RECIPE_MAIN_NODES_FIGMA_NODE_PASTE_LINK_ACCOUNT_ACTION',
        LINK_ACCOUNT: 'RECIPE_MAIN_NODES_FIGMA_NODE_LINK_ACCOUNT',
        EDIT_ERROR_NOT_CONNECTED: 'RECIPE_MAIN_NODES_FIGMA_NODE_EDIT_ERROR_NOT_CONNECTED',
        DUPLICATE_ERROR_NOT_CONNECTED: 'RECIPE_MAIN_NODES_FIGMA_NODE_DUPLICATE_ERROR_NOT_CONNECTED',
        PROPERTIES_INPUTS_TITLE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_INPUTS_TITLE',
        PROPERTIES_NO_INPUTS: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_NO_INPUTS',
        PROPERTIES_TYPE_TEXT: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_TYPE_TEXT',
        PROPERTIES_TYPE_IMAGE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_TYPE_IMAGE',
        PROPERTIES_TYPE_UNKNOWN: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_TYPE_UNKNOWN',
        PROPERTIES_LAYERS_TITLE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYERS_TITLE',
        PROPERTIES_LAYERS_LOADING: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYERS_LOADING',
        PROPERTIES_LAYERS_ERROR: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYERS_ERROR',
        PROPERTIES_LAYERS_EMPTY: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYERS_EMPTY',
        PROPERTIES_CONNECT: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_CONNECT',
        PROPERTIES_CONNECT_IMAGE_FROM_WEAVE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_CONNECT_IMAGE_FROM_WEAVE',
        PROPERTIES_CONNECT_TEXT_FROM_WEAVE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_CONNECT_TEXT_FROM_WEAVE',
        PROPERTIES_REMOVE_INPUT: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_REMOVE_INPUT',
        PROPERTIES_DISCONNECT_LAYER: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_DISCONNECT_LAYER',
        PROPERTIES_CONNECT_TO_LAYER: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_CONNECT_TO_LAYER',
        PROPERTIES_LAYER_PICKER_TITLE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYER_PICKER_TITLE',
        PROPERTIES_LAYER_PICKER_CLOSE: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYER_PICKER_CLOSE',
        PROPERTIES_IMAGE_FILL: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_IMAGE_FILL',
        PROPERTIES_NO_COMPATIBLE_LAYERS: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_NO_COMPATIBLE_LAYERS',
        PROPERTIES_LAYER_MISSING_FONT: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_LAYER_MISSING_FONT',
        PROPERTIES_BIND_LAYER_ERROR_GENERIC: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_BIND_LAYER_ERROR_GENERIC',
        PROPERTIES_DISCONNECT_LAYER_ERROR_GENERIC:
          'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_DISCONNECT_LAYER_ERROR_GENERIC',
        PROPERTIES_REMOVE_INPUT_ERROR_GENERIC: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_REMOVE_INPUT_ERROR_GENERIC',
        PROPERTIES_BIND_LAYER_ERROR_NOT_CONNECTED:
          'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_BIND_LAYER_ERROR_NOT_CONNECTED',
        EDIT: 'RECIPE_MAIN_NODES_FIGMA_NODE_EDIT',
        CONNECT: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT',
        CONNECT_TO_EDIT: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_TO_EDIT',
        UPDATE: 'RECIPE_MAIN_NODES_FIGMA_NODE_UPDATE',
        UPDATE_IN_PROGRESS: 'RECIPE_MAIN_NODES_FIGMA_NODE_UPDATE_IN_PROGRESS',
        CONNECT_LOADING_DISABLED: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_LOADING_DISABLED',
        EDIT_LOADING_DISABLED: 'RECIPE_MAIN_NODES_FIGMA_NODE_EDIT_LOADING_DISABLED',
        UPDATE_ERROR: 'RECIPE_MAIN_NODES_FIGMA_NODE_UPDATE_ERROR',
        CONNECT_DEST_ORIGINAL_SOURCE: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_DEST_ORIGINAL_SOURCE',
        CONNECT_DEST_NEW_DRAFTS: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_DEST_NEW_DRAFTS',
        CONNECT_DEST_SLIDES_UNSUPPORTED: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_DEST_SLIDES_UNSUPPORTED',
        CONNECT_ERROR: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_ERROR',
        CONNECT_ERROR_SNAPSHOT_NOT_FOUND: 'RECIPE_MAIN_NODES_FIGMA_NODE_CONNECT_ERROR_SNAPSHOT_NOT_FOUND',
        COPY_ERROR: 'RECIPE_MAIN_NODES_FIGMA_NODE_COPY_ERROR',
        COPY_RETRY: 'RECIPE_MAIN_NODES_FIGMA_NODE_COPY_RETRY',
        PROPERTIES_EDIT_IN_FIGMA: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_EDIT_IN_FIGMA',
        PROPERTIES_OPEN_IN_FIGMA: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_OPEN_IN_FIGMA',
        PROPERTIES_CONNECTED_FILE_FALLBACK: 'RECIPE_MAIN_NODES_FIGMA_NODE_PROPERTIES_CONNECTED_FILE_FALLBACK',
        OPENING_IN_FIGMA: 'RECIPE_MAIN_NODES_FIGMA_NODE_OPENING_IN_FIGMA',
        DRAFT_NAME_UNTITLED: 'RECIPE_MAIN_NODES_FIGMA_NODE_DRAFT_NAME_UNTITLED',
        DISCONNECT: 'RECIPE_MAIN_NODES_FIGMA_NODE_DISCONNECT',
        DISCONNECT_ERROR: 'RECIPE_MAIN_NODES_FIGMA_NODE_DISCONNECT_ERROR',
        FILE_DISCONNECTED_MODAL_TITLE: 'RECIPE_MAIN_NODES_FIGMA_NODE_FILE_DISCONNECTED_MODAL_TITLE',
        FILE_DISCONNECTED_MODAL_BODY: 'RECIPE_MAIN_NODES_FIGMA_NODE_FILE_DISCONNECTED_MODAL_BODY',
        FILE_DISCONNECTED_MODAL_CONNECT: 'RECIPE_MAIN_NODES_FIGMA_NODE_FILE_DISCONNECTED_MODAL_CONNECT',
        FILE_NO_EDIT_ACCESS_MODAL_TITLE: 'RECIPE_MAIN_NODES_FIGMA_NODE_FILE_NO_EDIT_ACCESS_MODAL_TITLE',
        FILE_NO_EDIT_ACCESS_MODAL_BODY: 'RECIPE_MAIN_NODES_FIGMA_NODE_FILE_NO_EDIT_ACCESS_MODAL_BODY',
        FILE_NO_EDIT_ACCESS_MODAL_CONNECT: 'RECIPE_MAIN_NODES_FIGMA_NODE_FILE_NO_EDIT_ACCESS_MODAL_CONNECT',
      },
      LOCKED: {
        CLICK_TO_UNLOCK: 'CLICK_TO_UNLOCK',
        CLICK_TO_UNLOCK_GROUP: 'CLICK_TO_UNLOCK_GROUP',
        THIS_NODE_IS_LOCKED: 'THIS_NODE_IS_LOCKED',
        THIS_NODE_IS_LOCKED_GROUP: 'THIS_NODE_IS_LOCKED_GROUP',
      },
      MULTI_LORA: {
        ADD_LORA: 'ADD_LORA',
        LORAS: 'LORAS',
        SELECT_LORA: 'SELECT_LORA',
        NO_OPTIONS: 'NO_OPTIONS',
      },
      NODE_MENU: {
        DELETE: 'DELETE',
        DELETE_ALL_UPLOADS: 'DELETE_ALL_UPLOADS',
        DELETE_ALL_OTHERS_UPLOADS: 'DELETE_ALL_OTHERS_UPLOADS',
        DELETE_CURRENT_UPLOAD: 'DELETE_CURRENT_UPLOAD',
        DOWNLOAD: 'NODE_MENU_DOWNLOAD',
        AUDIT_TRAIL: 'NODE_MENU_AUDIT_TRAIL',
        EXPORT_CURRENT: 'NODE_MENU_EXPORT_CURRENT',
        EXPORT_ALL: 'NODE_MENU_EXPORT_ALL',
        CLEAR: 'NODE_MENU_CLEAR',
        CLEAR_CURRENT: 'NODE_MENU_CLEAR_CURRENT',
        CLEAR_ALL_BUT_CURRENT: 'NODE_MENU_CLEAR_ALL_BUT_CURRENT',
        CLEAR_ALL: 'NODE_MENU_CLEAR_ALL',
        DOWNLOAD_IMAGE_PREVIEW: 'DOWNLOAD_IMAGE_PREVIEW',
        COPY_IMAGE_PREVIEW: 'COPY_IMAGE_PREVIEW',
        DUPLICATE: 'DUPLICATE',
        CUT: 'NODE_MENU_CUT',
        LOCK: 'LOCK',
        RENAME: 'RENAME',
        UNLOCK: 'UNLOCK',
        UNLOCK_GROUP_FIRST: 'UNLOCK_GROUP_FIRST',
        REMOVE_FROM_GROUP: 'REMOVE_FROM_GROUP',
        VIEW_MODE: 'VIEW_MODE',
        VIEW_MODE_SINGLE: 'VIEW_MODE_SINGLE',
        VIEW_MODE_BATCH: 'VIEW_MODE_BATCH',
        VIEW_MODE_ALL: 'VIEW_MODE_ALL',
        SAVE_NODE: 'SAVE_NODE',
        SAVE_NODE_SUCCESS: 'SAVE_NODE_SUCCESS',
        SAVE_NODE_ERROR: 'SAVE_NODE_ERROR',
        SAVE_MODEL: 'SAVE_MODEL',
        SAVE_MODEL_SUCCESS: 'SAVE_MODEL_SUCCESS',
        SAVE_MODEL_ERROR: 'SAVE_MODEL_ERROR',
        SAVE_GROUP: 'SAVE_GROUP',
        SAVE_GROUP_TITLE: 'SAVE_GROUP_TITLE',
        SAVE_GROUP_SUCCESS: 'SAVE_GROUP_SUCCESS',
        SAVE_GROUP_ERROR: 'SAVE_GROUP_ERROR',
        UNPACK: 'NODE_MENU_UNPACK',
        CREATE_ITERATOR: 'NODE_MENU_CREATE_ITERATOR',
        CREATE_IMAGE_ITERATOR: 'NODE_MENU_CREATE_IMAGE_ITERATOR',
        CREATE_VIDEO_ITERATOR: 'NODE_MENU_CREATE_VIDEO_ITERATOR',
        CREATE_TEXT_ITERATOR: 'NODE_MENU_CREATE_TEXT_ITERATOR',
        SHOW_VERSION_HISTORY: 'NODE_MENU_SHOW_VERSION_HISTORY',
        SHOW_VERSION_HISTORY_DISABLED_TOOLTIP: 'NODE_MENU_SHOW_VERSION_HISTORY_DISABLED_TOOLTIP',
        HANDLES: 'NODE_MENU_HANDLES',
        COLLAPSE_HANDLES_BY_TYPE: 'NODE_MENU_COLLAPSE_HANDLES_BY_TYPE',
        COLLAPSE_HANDLES_NO_INPUTS: 'NODE_MENU_COLLAPSE_HANDLES_NO_INPUTS',
      },
      NODE_MENU_CONFIRMATION_DIALOG: {
        CANCEL_TEXT: 'NODE_MENU_CONFIRMATION_DIALOG_CANCEL_TEXT',
        CONFIRM_TEXT: 'NODE_MENU_CONFIRMATION_DIALOG_CONFIRM_TEXT',
        TITLE: 'NODE_MENU_CONFIRMATION_DIALOG_TITLE',
        MESSAGE: 'NODE_MENU_CONFIRMATION_DIALOG_MESSAGE',
        DELETE_ALL_UPLOADS_MESSAGE: 'NODE_MENU_CONFIRMATION_DIALOG_DELETE_ALL_UPLOADS_MESSAGE',
        DELETE_ALL_UPLOADS_BODY: 'NODE_MENU_CONFIRMATION_DIALOG_DELETE_ALL_UPLOADS_BODY',
        DELETE_ALL_UPLOADS_CONFIRM_TEXT: 'NODE_MENU_CONFIRMATION_DIALOG_DELETE_ALL_UPLOADS_CONFIRM_TEXT',
      },
      PROMPT_CONCAT: {
        ADDITIONAL_TEXT_PLACEHOLDER: 'PROMPT_CONCAT_ADDITIONAL_TEXT_PLACEHOLDER',
        PLACEHOLDER: 'PROMPT_CONCAT_PLACEHOLDER',
        ADD_ANOTHER_TEXT_INPUT: 'PROMPT_CONCAT_ADD_ANOTHER_TEXT_INPUT',
        COMBINED_LABEL: 'PROMPT_CONCAT_COMBINED_LABEL',
        ADDITIONAL_TEXT_LABEL: 'PROMPT_CONCAT_ADDITIONAL_TEXT_LABEL',
      },
      STRING_NODE: {
        ARIA_LABEL: 'STRING_NODE_ARIA_LABEL',
      },
      TEXT_VIEWER: {
        ARIA_LABEL: 'TEXT_VIEWER_ARIA_LABEL',
      },
      VIDEO_CONCATENATOR: {
        ADD_VIDEO: 'VIDEO_CONCATENATOR_ADD_VIDEO',
        SCALE: 'VIDEO_CONCATENATOR_SCALE',
        SCALE_MODES: {
          STRETCH: 'VIDEO_CONCATENATOR_STRETCH',
          FIT: 'VIDEO_CONCATENATOR_FIT',
          FILL: 'VIDEO_CONCATENATOR_FILL',
        },
      },
      PROMPT_NODE_V2: {
        PROMPT_LABEL: 'PROMPT_NODE_V2_PROMPT_LABEL',
        NEGATIVE_PROMPT_LABEL: 'PROMPT_NODE_V2_NEGATIVE_PROMPT_LABEL',
        PLACEHOLDER: 'PROMPT_NODE_V2_PLACEHOLDER',
        NEGATIVE_PROMPT_PLACEHOLDER: 'PROMPT_NODE_V2_NEGATIVE_PROMPT_PLACEHOLDER',
      },
      PROMPT_NODE_V3: {
        DISPLAY_MODE: 'PROMPT_NODE_V3_DISPLAY_MODE',
        PLACEHOLDER: 'PROMPT_NODE_V3_PLACEHOLDER',
        PLACEHOLDER_IMAGE: 'PROMPT_NODE_V3_PLACEHOLDER_IMAGE',
        PLACEHOLDER_VIDEO: 'PROMPT_NODE_V3_PLACEHOLDER_VIDEO',
        PLACEHOLDER_AUDIO: 'PROMPT_NODE_V3_PLACEHOLDER_AUDIO',
        PLACEHOLDER_3D: 'PROMPT_NODE_V3_PLACEHOLDER_3D',
        PLACEHOLDER_TEXT: 'PROMPT_NODE_V3_PLACEHOLDER_TEXT',
        PLACEHOLDER_APPLY_HINT: 'PROMPT_NODE_V3_PLACEHOLDER_APPLY_HINT',
        TRUNCATED_WARNING: 'PROMPT_NODE_V3_TRUNCATED_WARNING',
        ADD_VARIABLE: 'PROMPT_NODE_V3_ADD_VARIABLE',
        CREATE_VARIABLE: 'PROMPT_NODE_V3_CREATE_VARIABLE',
        DISPLAY_SOURCE_VALUE: 'PROMPT_NODE_V3_DISPLAY_SOURCE_VALUE',
        DISPLAY_VALUE: 'PROMPT_NODE_V3_DISPLAY_VALUE',
        DISPLAY_SOURCE: 'PROMPT_NODE_V3_DISPLAY_SOURCE',
        TAG_CONTEXT_MENU: {
          DUPLICATE: 'PROMPT_NODE_V3_TAG_CONTEXT_MENU_DUPLICATE',
          DELETE: 'PROMPT_NODE_V3_TAG_CONTEXT_MENU_DELETE',
        },
        EDITOR_CONTEXT_MENU: {
          PASTE: 'PROMPT_NODE_V3_EDITOR_CONTEXT_MENU_PASTE',
        },
      },
      STICKY_NOTE: {
        PLACEHOLDER: 'STICKY_NOTE_PLACEHOLDER',
        CONTEXT_MENU: {
          FONT_SIZE: 'STICKY_NOTE_FONT_SIZE',
          FONT_SIZE_OPTIONS: {
            SMALL: 'STICKY_NOTE_FONT_SIZE_OPTIONS_SMALL',
            MEDIUM: 'STICKY_NOTE_FONT_SIZE_OPTIONS_MEDIUM',
            LARGE: 'STICKY_NOTE_FONT_SIZE_OPTIONS_LARGE',
          },
        },
      },
      WILDCARD: {
        PLACEHOLDER: 'WILDCARD_PLACEHOLDER',
        PLACEHOLDER_TEMP: 'WILDCARD_PLACEHOLDER_TEMP',
        INPUT_ERROR: 'WILDCARD_INPUT_ERROR',
        SAVE_TO_MY_LIBRARY_CTA: 'SAVE_TO_MY_LIBRARY_CTA',
        ADDED_TO_MY_LIBRARY: 'ADDED_TO_MY_LIBRARY',
        SAVE_TO_MY_LIBRARY_DIALOG: {
          TITLE: 'SAVE_TO_MY_LIBRARY_DIALOG_TITLE',
          SUBTITLE: 'SAVE_TO_MY_LIBRARY_DIALOG_SUBTITLE',
          NAME_LABEL: 'SAVE_TO_MY_LIBRARY_DIALOG_NAME_LABEL',
          NAME_PLACEHOLDER: 'SAVE_TO_MY_LIBRARY_DIALOG_NAME_PLACEHOLDER',
          DESCRIPTION_LABEL: 'SAVE_TO_MY_LIBRARY_DIALOG_DESCRIPTION_LABEL',
          DESCRIPTION_PLACEHOLDER: 'SAVE_TO_MY_LIBRARY_DIALOG_DESCRIPTION_PLACEHOLDER',
          CTA_SAVE: 'SAVE_TO_MY_LIBRARY_DIALOG_CTA_SAVE',
          CTA_CANCEL: 'SAVE_TO_MY_LIBRARY_DIALOG_CTA_CANCEL',
        },
      },
      COMPOSITOR: {
        EDIT_CTA: 'COMPOSITOR_EDIT_CTA',
        ADD_ANOTHER_LAYER_CTA: 'COMPOSITOR_ADD_ANOTHER_LAYER_CTA',
      },
      PAINTER: {
        TOOLS_ARIA: 'PAINTER_TOOLS_ARIA',
        CANVAS_ARIA: 'PAINTER_CANVAS_ARIA',
        BRUSH_ARIA: 'PAINTER_BRUSH_ARIA',
        SHAPE_ARIA: 'PAINTER_SHAPE_ARIA',
        ERASER_ARIA: 'PAINTER_ERASER_ARIA',
        BACKGROUND_COLOR_LABEL: 'PAINTER_BACKGROUND_COLOR_LABEL',
        BRUSH_SIZE_LABEL: 'PAINTER_BRUSH_SIZE_LABEL',
        HARDNESS_LABEL: 'PAINTER_HARDNESS_LABEL',
        OPACITY_LABEL: 'PAINTER_OPACITY_LABEL',
        COLOR_LABEL: 'PAINTER_COLOR_LABEL',
        RESET: 'PAINTER_RESET',
        DIMENSIONS_SET_BY_INPUT_IMAGE: 'PAINTER_DIMENSIONS_SET_BY_INPUT_IMAGE',
      },
      COLOR_PALETTE: {
        ADD_ANOTHER: 'COLOR_PALETTE_ADD_ANOTHER',
        EDIT_ARIA: 'COLOR_PALETTE_EDIT_ARIA',
        REORDER_ARIA: 'COLOR_PALETTE_REORDER_ARIA',
        REMOVE_ARIA: 'COLOR_PALETTE_REMOVE_ARIA',
        SELECT_COLOR: 'COLOR_PALETTE_SELECT_COLOR',
        PALETTE_LABEL: 'COLOR_PALETTE_PALETTE_LABEL',
        ADD_COLOR: 'COLOR_PALETTE_ADD_COLOR',
      },
      CROP: {
        DIMENSIONS: 'CROP_DIMENSIONS',
        ASPECT_RATIO: 'CROP_ASPECT_RATIO',
        LOCK_ASPECT_RATIO: 'CROP_LOCK_ASPECT_RATIO',
        CUSTOM_ASPECT_RATIO: 'CROP_CUSTOM_ASPECT_RATIO',
        WIDTH_LETTER: 'CROP_WIDTH_LETTER',
        HEIGHT_LETTER: 'CROP_HEIGHT_LETTER',
        RESET: 'CROP_RESET',
      },
      RESIZE: {
        UNSUPPORTED_FILE: 'RESIZE_UNSUPPORTED_FILE',
      },
      TRIM: {
        START_LABEL: 'TRIM_START_LABEL',
        END_LABEL: 'TRIM_END_LABEL',
        FILMSTRIP_ARIA: 'TRIM_FILMSTRIP_ARIA',
        START_HANDLE_ARIA: 'TRIM_START_HANDLE_ARIA',
        END_HANDLE_ARIA: 'TRIM_END_HANDLE_ARIA',
        PLAYHEAD_ARIA: 'TRIM_PLAYHEAD_ARIA',
      },
      NUMBER: {
        IS_FLOAT: 'NUMBER_IS_FLOAT',
        MIN: 'NUMBER_MIN',
        MAX: 'NUMBER_MAX',
      },
      POINT_CLOUD_FROM_DEPTH: {
        SCALE: 'POINT_CLOUD_FROM_DEPTH_SCALE',
        LEVELS: 'POINT_CLOUD_FROM_DEPTH_LEVELS',
        MIN_DEPTH: 'POINT_CLOUD_FROM_DEPTH_MIN_DEPTH',
        GAMMA: 'POINT_CLOUD_FROM_DEPTH_GAMMA',
        MAX_DEPTH: 'POINT_CLOUD_FROM_DEPTH_MAX_DEPTH',
      },
      ARRAY: {
        ADD_ITEM: 'ARRAY_ADD_ITEM',
        SPLIT_TEXT_BY: 'ARRAY_SPLIT_TEXT_BY',
        PLACEHOLDER: 'ARRAY_PLACEHOLDER',
        ITEMS_COUNT: 'ARRAY_ITEMS_COUNT',
      },
      TOGGLE: {
        TRUE: 'RECIPE_MAIN_NODES_TOGGLE_TRUE',
        FALSE: 'RECIPE_MAIN_NODES_TOGGLE_FALSE',
        ARIA: 'RECIPE_MAIN_NODES_TOGGLE_ARIA',
      },
      MASKS: {
        DISPLAY_ARIA: 'MASKS_DISPLAY_ARIA',
        IMAGE: 'MASKS_IMAGE',
        MASK: 'MASKS_MASK',
        ERROR: 'MASKS_ERROR',
        RECALCULATE_MASK: 'MASKS_RECALCULATE_MASK',
      },
      CHANNEL: {
        RED: 'RECIPE_MAIN_NODES_CHANNEL_RED',
        GREEN: 'RECIPE_MAIN_NODES_CHANNEL_GREEN',
        BLUE: 'RECIPE_MAIN_NODES_CHANNEL_BLUE',
        ALPHA: 'RECIPE_MAIN_NODES_CHANNEL_ALPHA',
      },
      BLUR: {
        SIZE: 'RECIPE_MAIN_NODES_BLUR_SIZE',
        TYPE: 'RECIPE_MAIN_NODES_BLUR_TYPE',
        BOX: 'RECIPE_MAIN_NODES_BLUR_BOX',
        GAUSSIAN: 'RECIPE_MAIN_NODES_BLUR_GAUSSIAN',
      },
      EXTRACT_VIDEO_FRAME: {
        TIMECODE: 'RECIPE_MAIN_NODES_EXTRACT_VIDEO_FRAME_TIMECODE',
        FRAME: 'RECIPE_MAIN_NODES_EXTRACT_VIDEO_FRAME_FRAME',
      },
      KEYFRAME: {
        MODE: 'RECIPE_MAIN_NODES_KEYFRAME_MODE',
        MODE_TIME: 'RECIPE_MAIN_NODES_KEYFRAME_MODE_TIME',
        MODE_FRAMES: 'RECIPE_MAIN_NODES_KEYFRAME_MODE_FRAMES',
        TIMESTAMP: 'RECIPE_MAIN_NODES_KEYFRAME_TIMESTAMP',
        FRAME_NUMBER: 'RECIPE_MAIN_NODES_KEYFRAME_FRAME_NUMBER',
        FPS_BASE_HINT: 'RECIPE_MAIN_NODES_KEYFRAME_FPS_BASE_HINT',
      },
      LIST_NODE: {
        SELECT_AN_OPTION: 'RECIPE_MAIN_NODES_LIST_NODE_SELECT_AN_OPTION',
        ADD_OPTIONS_VIA_PROPERTIES_PANEL: 'RECIPE_MAIN_NODES_LIST_NODE_ADD_OPTIONS_VIA_PROPERTIES_PANEL',
        ITERATOR: {
          PLACEHOLDER: 'RECIPE_MAIN_NODES_LIST_NODE_ITERATOR_PLACEHOLDER',
          ADD_ITEM: 'RECIPE_MAIN_NODES_LIST_NODE_ITERATOR_ADD_ITEM',
          ITEMS_COUNT: 'RECIPE_MAIN_NODES_LIST_NODE_ITERATOR_ITEMS_COUNT',
        },
        OPTIONS_LABEL: 'RECIPE_MAIN_NODES_LIST_NODE_OPTIONS_LABEL',
        OPTIONS_TOOLTIP: 'RECIPE_MAIN_NODES_LIST_NODE_OPTIONS_TOOLTIP',
      },
      PREVIEW_NODE: {
        SET_AS_COVER: 'RECIPE_MAIN_NODES_PREVIEW_NODE_SET_AS_COVER',
      },
      FILE_VIEWER: {
        SHOW_ORIGINAL: 'RECIPE_MAIN_NODES_FILE_VIEWER_SHOW_ORIGINAL',
        SHOW_RESULT: 'RECIPE_MAIN_NODES_FILE_VIEWER_SHOW_RESULT',
      },
      CUSTOM_GLSL: {
        PROMPT_LABEL: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PROMPT_LABEL',
        PROMPT_PANEL_LABEL: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PROMPT_PANEL_LABEL',
        PROMPT_PLACEHOLDER: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PROMPT_PLACEHOLDER',
        GENERATE: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_GENERATE',
        REGENERATE: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_REGENERATE',
        EDIT_PROMPT: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_EDIT_PROMPT',
        GENERATING: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_GENERATING',
        REGENERATING: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_REGENERATING',
        GENERATE_ERROR: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_GENERATE_ERROR',
        PAID_PLAN_GENERATE_ERROR: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PAID_PLAN_GENERATE_ERROR',
        IMAGE_REFERENCES: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_IMAGE_REFERENCES',
        IMAGE_REFERENCES_COUNT: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_IMAGE_REFERENCES_COUNT',
        UPLOAD_IMAGE: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_UPLOAD_IMAGE',
        REFERENCE_IMAGE_REJECTED: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_REFERENCE_IMAGE_REJECTED',
        PROMPT_TOO_LONG: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PROMPT_TOO_LONG',
        CANCEL: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_CANCEL',
        PAID_PLAN_DISCLAIMER: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PAID_PLAN_DISCLAIMER',
        PAID_PLAN_UPGRADE_CTA: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_PAID_PLAN_UPGRADE_CTA',
        READY_SNACKBAR: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_READY_SNACKBAR',
        READY_SNACKBAR_VIEW: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_READY_SNACKBAR_VIEW',
        DURATION_LABEL: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_DURATION_LABEL',
        BACKGROUND_COLOR: 'RECIPE_MAIN_NODES_CUSTOM_GLSL_BACKGROUND_COLOR',
      },
      LEVELS: {
        CHANNEL: 'RECIPE_MAIN_NODES_LEVELS_CHANNEL',
        RESET: 'RECIPE_MAIN_NODES_LEVELS_RESET',
        INPUTS: 'RECIPE_MAIN_NODES_LEVELS_INPUTS',
        OUTPUTS: 'RECIPE_MAIN_NODES_LEVELS_OUTPUTS',
        HISTOGRAM: 'RECIPE_MAIN_NODES_LEVELS_HISTOGRAM',
        RED: 'RECIPE_MAIN_NODES_LEVELS_RED',
        GREEN: 'RECIPE_MAIN_NODES_LEVELS_GREEN',
        BLUE: 'RECIPE_MAIN_NODES_LEVELS_BLUE',
        RGB: 'RECIPE_MAIN_NODES_LEVELS_RGB',
        NO_HISTOGRAM_DATA: 'RECIPE_MAIN_NODES_LEVELS_NO_HISTOGRAM_DATA',
      },
      DILATION_EROSION: {
        SIZE: 'RECIPE_MAIN_NODES_DILATION_EROSION_SIZE',
      },
      MODEL_BASE_NODE: {
        LEARN_MORE_ABOUT_THIS_MODEL: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_LEARN_MORE_ABOUT_THIS_MODEL',
        LLM_EDITED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_LLM_EDITED',
        SEEDANCE_ENHANCE: {
          TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_TOOLTIP',
          TOOLTIP_WITH_CREDITS: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_TOOLTIP_WITH_CREDITS',
          DRAFT_MODE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_DRAFT_MODE',
          DRAFT_MODE_TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_DRAFT_MODE_TOOLTIP',
          DRAFT_BADGE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_DRAFT_BADGE',
          GENERATE_HIGH_RES: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_GENERATE_HIGH_RES',
          GENERATING_HIGH_RES: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_GENERATING_HIGH_RES',
          DRAFTS_ONLY_TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_DRAFTS_ONLY_TOOLTIP',
          ITERATORS_TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_ITERATORS_TOOLTIP',
          UNAVAILABLE_TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_UNAVAILABLE_TOOLTIP',
          RUN_DRAFT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_RUN_DRAFT',
          MODEL_DESCRIPTION: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEEDANCE_ENHANCE_MODEL_DESCRIPTION',
        },
        IMPORT_APPROVAL: {
          DISCLAIMER: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_DISCLAIMER',
          REQUEST_APPROVAL_CTA: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_REQUEST_APPROVAL_CTA',
          REQUEST_SENT_CTA: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_REQUEST_SENT_CTA',
          REQUEST_DENIED_CTA: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_REQUEST_DENIED_CTA',
          PENDING_TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_PENDING_TOOLTIP',
          DENIED_TOOLTIP: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_DENIED_TOOLTIP',
          PANEL_CANNOT_RUN_NOT_REQUESTED:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_PANEL_CANNOT_RUN_NOT_REQUESTED',
          PANEL_CANNOT_RUN_PENDING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_PANEL_CANNOT_RUN_PENDING',
          PANEL_CANNOT_RUN_REJECTED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_IMPORT_APPROVAL_PANEL_CANNOT_RUN_REJECTED',
        },
        MODEL_NODE_FOOTER: {
          ADVANCED_OPTIONS: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADVANCED_OPTIONS',
          ADD_ANOTHER_IMAGE_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_IMAGE_INPUT',
          ADD_ANOTHER_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_INPUT',
          ADD_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT',
          ADD_INPUT_OPTION_IMAGE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_OPTION_IMAGE',
          ADD_INPUT_OPTION_REFERENCE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_OPTION_REFERENCE',
          ADD_INPUT_OPTION_ELEMENT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_OPTION_ELEMENT',
          ADD_INPUT_OPTION_KEYFRAME: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_OPTION_KEYFRAME',
          ADD_ANOTHER_VIDEO_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_VIDEO_INPUT',
          ADD_ANOTHER_IMAGE_INPUT_DISABLED:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_IMAGE_INPUT_DISABLED',
          ADD_INPUT_LIMIT_TYPE_ELEMENT:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_ELEMENT',
          ADD_INPUT_LIMIT_TYPE_KEYFRAME:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_KEYFRAME',
          ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE',
          ADD_INPUT_LIMIT_TYPE_INPUT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_INPUT_LIMIT_TYPE_INPUT',
          ADD_ANOTHER_LORA: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_LORA',
          ADD_ANOTHER_PROMPT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ANOTHER_PROMPT',
          ADD_ELEMENT: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_ELEMENT',
          ADD_KEYFRAME: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ADD_KEYFRAME',
          ERROR_REQUIRED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ERROR_REQUIRED',
          CREDITS_MESSAGE: {
            LOW_CREDITS_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE',
            LOW_CREDITS_MESSAGE_SHORT:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_SHORT',
            LOW_CREDITS_MESSAGE_PART_2_FREE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_2_FREE',
            LOW_CREDITS_MESSAGE_PART_2_GET_MORE_CREDITS_CTA:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_2_GET_MORE_CREDITS',
            LOW_CREDITS_MESSAGE_OR:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_OR',
            LOW_CREDITS_MESSAGE_PART_3_UPGRADE_CTA:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_3_UPGRADE',
            LOW_CREDITS_MESSAGE_PART_2_MEMBER:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_LOW_CREDITS_MESSAGE_PART_2_MEMBER',
            FREE_TIER_MESSAGE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_FREE_TIER_MESSAGE',
            STARTER_PRO_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_STARTER_PRO_MESSAGE',
            TEAM_ENTERPRISE_MEMBER_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_TEAM_ENTERPRISE_MEMBER_MESSAGE',
            TEAM_ENTERPRISE_ADMIN_MESSAGE:
              'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_CREDITS_MESSAGE_TEAM_ENTERPRISE_ADMIN_MESSAGE',
          },
          MODEL_NOT_SUPPORTED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_MODEL_NOT_SUPPORTED',
          ERROR_MODEL_RUN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_ERROR_MODEL_RUN',
          NANO_BANANA_PRO_INTERMITTENT_ISSUES:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_NANO_BANANA_PRO_INTERMITTENT_ISSUES',
          IMPORTED_MODEL_PAID_PLAN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_IMPORTED_MODEL_PAID_PLAN',
          IMPORTED_MODEL_PAID_PLAN_UPGRADE_CTA:
            'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_IMPORTED_MODEL_PAID_PLAN_UPGRADE_CTA',
          VIDEO_MODEL_PAID_PLAN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_VIDEO_MODEL_PAID_PLAN',
          EMPTY_ITERATOR: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_EMPTY_ITERATOR',
          BLOCKED_MODEL_PAID_PLAN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_BLOCKED_MODEL_PAID_PLAN',
          OUT_OF_CREDITS_BETA: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_MODEL_NODE_FOOTER_OUT_OF_CREDITS_BETA',
        },
        TEXT_MODEL: {
          EMPTY_STATE_PLACEHOLDER: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_TEXT_MODEL_EMPTY_STATE_PLACEHOLDER',
        },
        RUN_MODEL_BUTTON: {
          RUN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUN',
          RUNNING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNNING',
          CANCEL_RUN: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_CANCEL_RUN',
          CANCELLING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_CANCELLING',
          INITIALIZING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_INITIALIZING',
          UPLOADING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_UPLOADING',
          RUNS_TOOLTIP: {
            RUN_LABEL: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_RUN_LABEL',
            WAITING: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_WAITING',
            DONE: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_DONE',
            FAILED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_FAILED',
            FAILED_REFUNDED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_FAILED_REFUNDED',
            CANCELLED: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_CANCELLED',
            PROGRESS: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_RUN_MODEL_BUTTON_RUNS_TOOLTIP_PROGRESS',
          },
        },
        OVERLAY: {
          BATCH: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_OVERLAY_BATCH',
        },
      },
      SEED: {
        RANDOM: 'RECIPE_MAIN_NODES_MODEL_BASE_NODE_SEED_RANDOM',
        REFRESH: 'RECIPE_MAIN_NODES_SEED_REFRESH',
      },
      SLIDER_WITH_AUTO: {
        AUTO: 'RECIPE_MAIN_NODES_SLIDER_WITH_AUTO_AUTO',
        AUTO_DURATION: 'RECIPE_MAIN_NODES_SLIDER_WITH_AUTO_AUTO_DURATION',
        DURATION_DESCRIPTION: 'RECIPE_MAIN_NODES_SLIDER_WITH_AUTO_DURATION_DESCRIPTION',
      },
      NODE_HANDLES: {
        ILLEGAL_TYPE_CONNECTION: 'RECIPE_MAIN_NODES_NODE_HANDLES_ILLEGAL_TYPE_CONNECTION',
        REQUIRED_VALIDATION_ERROR: 'RECIPE_MAIN_NODES_NODE_HANDLES_REQUIRED_VALIDATION_ERROR',
        CYCLIC_CONNECTION: 'RECIPE_MAIN_NODES_NODE_HANDLES_CYCLIC_CONNECTION',
        EMPTY_REQUIRED_VALIDATION_ERROR: 'RECIPE_MAIN_NODES_NODE_HANDLES_EMPTY_REQUIRED_VALIDATION_ERROR',
        GROUP_OPEN_TOOLTIP: 'NODE_HANDLES_GROUP_OPEN_TOOLTIP',
        GROUP_CLOSE_TOOLTIP: 'NODE_HANDLES_GROUP_CLOSE_TOOLTIP',
      },
      IMPORT_NODE: {
        UPLOAD_ERROR_INVALID_FILE_TYPE: 'RECIPE_MAIN_NODES_IMPORT_NODE_UPLOAD_ERROR_INVALID_FILE_TYPE',
        UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC: 'RECIPE_MAIN_NODES_IMPORT_NODE_UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC',
        ADD_MORE_IMAGES: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_IMAGES',
        ADD_MORE_VIDEOS: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_VIDEOS',
        ADD_MORE_AUDIO: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_AUDIO',
        ADD_MORE_3D_FILES: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_3D_FILES',
        ADD_MORE_FILES: 'RECIPE_MAIN_NODES_IMPORT_NODE_ADD_MORE_FILES',
        IMAGES: 'RECIPE_MAIN_NODES_IMPORT_NODE_IMAGES',
        VIDEOS: 'RECIPE_MAIN_NODES_IMPORT_NODE_VIDEOS',
        AUDIO: 'RECIPE_MAIN_NODES_IMPORT_NODE_AUDIO',
        TEXT: 'RECIPE_MAIN_NODES_IMPORT_NODE_TEXT',
        THREE_D_FILES: 'RECIPE_MAIN_NODES_IMPORT_NODE_THREE_D_FILES',
        IMAGE: 'RECIPE_MAIN_NODES_IMPORT_NODE_IMAGE',
        SORT_ORDER_BY: 'RECIPE_MAIN_NODES_IMPORT_NODE_SORT_ORDER_BY',
        SORT_DATE_ADDED: 'RECIPE_MAIN_NODES_IMPORT_NODE_SORT_DATE_ADDED',
        SORT_NAME: 'RECIPE_MAIN_NODES_IMPORT_NODE_SORT_NAME',
        LOADING_3D_MODEL: 'RECIPE_MAIN_NODES_IMPORT_NODE_LOADING_3D_MODEL',
      },
      COMPARISON: {
        RESET: 'RECIPE_MAIN_NODES_COMPARISON_RESET',
        MODE: 'RECIPE_MAIN_NODES_COMPARISON_MODE',
        TOGGLE: 'RECIPE_MAIN_NODES_COMPARISON_TOGGLE',
        SLIDER: 'RECIPE_MAIN_NODES_COMPARISON_SLIDER',
        IMAGE: 'RECIPE_MAIN_NODES_COMPARISON_IMAGE',
        VIDEO: 'RECIPE_MAIN_NODES_COMPARISON_VIDEO',
      },
    },
    GROUP_CONTEXT_MENU: {
      NEW_NODE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_NEW_NODE',
      DOWNLOAD_ALL: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_DOWNLOAD_ALL',
      CLEAR_ALL_ASSETS: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_CLEAR_ALL_ASSETS',
      GROUP_ACTIONS: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_GROUP_ACTIONS',
      DUPLICATE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_DUPLICATE',
      LABEL_SIZE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE',
      LABEL_SIZE_OPTIONS: {
        SMALL: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE_OPTIONS_SMALL',
        MEDIUM: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE_OPTIONS_MEDIUM',
        LARGE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LABEL_SIZE_OPTIONS_LARGE',
      },
      LOCK: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_LOCK',
      UNLOCK: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_UNLOCK',
      RESIZE_TO_FIT: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_RESIZE_TO_FIT',
      UNGROUP: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_UNGROUP',
      DELETE: 'RECIPE_MAIN_GROUP_CONTEXT_MENU_DELETE',
    },
    SELECTION_CONTEXT_MENU: {
      DELETE_ALL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DELETE_ALL',
      CLEAR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CLEAR',
      CLEAR_ALL_ASSETS: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CLEAR_ALL_ASSETS',
      CLEAR_ALL_BUT_SELECTED: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CLEAR_ALL_BUT_SELECTED',
      DOWNLOAD_ALL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DOWNLOAD_ALL',
      DUPLICATE: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DUPLICATE',
      CUT: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CUT',
      GROUP_SELECTION: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_GROUP_SELECTION',
      CREATE_IMAGE_ITERATOR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CREATE_IMAGE_ITERATOR',
      CREATE_VIDEO_ITERATOR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CREATE_VIDEO_ITERATOR',
      CONCAT_VIDEOS: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CONCAT_VIDEOS',
      CREATE_TEXT_ITERATOR: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_CREATE_TEXT_ITERATOR',
      LOCK_ALL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_LOCK_ALL',
      UNLOCK_ALL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_UNLOCK_ALL',
      ALIGN: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN',
      ALIGN_AUTO: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_AUTO',
      ALIGN_LEFT: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_LEFT',
      ALIGN_CENTER_HORIZONTAL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_CENTER_HORIZONTAL',
      ALIGN_RIGHT: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_RIGHT',
      ALIGN_TOP: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_TOP',
      ALIGN_CENTER_VERTICAL: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_CENTER_VERTICAL',
      ALIGN_BOTTOM: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_ALIGN_BOTTOM',
      DISTRIBUTE_VERTICAL_SPACING: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DISTRIBUTE_VERTICAL_SPACING',
      DISTRIBUTE_HORIZONTAL_SPACING: 'RECIPE_MAIN_SELECTION_CONTEXT_MENU_DISTRIBUTE_HORIZONTAL_SPACING',
    },
    VERSION_HISTORY: {
      PANEL_TITLE: 'RECIPE_MAIN_VERSION_HISTORY_PANEL_TITLE',
      PANEL_TOOLTIP: 'RECIPE_MAIN_VERSION_HISTORY_PANEL_TOOLTIP',
      CURRENT_VERSION: 'RECIPE_MAIN_VERSION_HISTORY_CURRENT_VERSION',
      EMPTY_STATE: 'RECIPE_MAIN_VERSION_HISTORY_EMPTY_STATE',
      LOAD_ERROR: 'RECIPE_MAIN_VERSION_HISTORY_LOAD_ERROR',
      RETRY: 'RECIPE_MAIN_VERSION_HISTORY_RETRY',
      FORK_NAME_TEMPLATE: 'RECIPE_MAIN_VERSION_HISTORY_FORK_NAME_TEMPLATE',
      BANNER: {
        TITLE: 'RECIPE_MAIN_VERSION_HISTORY_BANNER_TITLE',
        TITLE_CURRENT: 'RECIPE_MAIN_VERSION_HISTORY_BANNER_TITLE_CURRENT',
        RESTORE: 'RECIPE_MAIN_VERSION_HISTORY_BANNER_RESTORE',
        SAVE_AS_NEW: 'RECIPE_MAIN_VERSION_HISTORY_BANNER_SAVE_AS_NEW',
      },
      RESTORE_DIALOG: {
        TITLE: 'RECIPE_MAIN_VERSION_HISTORY_RESTORE_DIALOG_TITLE',
        MESSAGE: 'RECIPE_MAIN_VERSION_HISTORY_RESTORE_DIALOG_MESSAGE',
        CONFIRM: 'RECIPE_MAIN_VERSION_HISTORY_RESTORE_DIALOG_CONFIRM',
        CANCEL: 'RECIPE_MAIN_VERSION_HISTORY_RESTORE_DIALOG_CANCEL',
      },
      RESTORE_SUCCESS: 'RECIPE_MAIN_VERSION_HISTORY_RESTORE_SUCCESS',
      RESTORE_ERROR: 'RECIPE_MAIN_VERSION_HISTORY_RESTORE_ERROR',
      SAVE_AS_NEW_ERROR: 'RECIPE_MAIN_VERSION_HISTORY_SAVE_AS_NEW_ERROR',
    },
  },
  TEMPLATE_GALLERY: {
    TITLE: 'TEMPLATE_GALLERY_TITLE',
    CLOSE_ARIA: 'TEMPLATE_GALLERY_CLOSE_ARIA',
    SELECT_TEMPLATE_ARIA: 'TEMPLATE_GALLERY_SELECT_TEMPLATE_ARIA',
    ONBOARDING_CREDITS_TOAST: 'TEMPLATE_GALLERY_ONBOARDING_CREDITS_TOAST',
    TEMPLATES: {
      MODEL_COMPARISON: {
        NAME: 'TEMPLATE_GALLERY_TEMPLATES_MODEL_COMPARISON_NAME',
        DESCRIPTION: 'TEMPLATE_GALLERY_TEMPLATES_MODEL_COMPARISON_DESCRIPTION',
      },
      SCALING_CONTENT: {
        NAME: 'TEMPLATE_GALLERY_TEMPLATES_SCALING_CONTENT_NAME',
        DESCRIPTION: 'TEMPLATE_GALLERY_TEMPLATES_SCALING_CONTENT_DESCRIPTION',
      },
      FRAME_TO_VIDEO: {
        NAME: 'TEMPLATE_GALLERY_TEMPLATES_FRAME_TO_VIDEO_NAME',
        DESCRIPTION: 'TEMPLATE_GALLERY_TEMPLATES_FRAME_TO_VIDEO_DESCRIPTION',
      },
    },
  },
  SETTINGS: {
    DELETE_ACCOUNT: 'SETTINGS_DELETE_ACCOUNT',
    BACK_TO_HOME_ARIA: 'SETTINGS_BACK_TO_HOME_ARIA',
    MODEL_MANAGEMENT: {
      TITLE: 'SETTINGS_MODEL_MANAGEMENT_TITLE',
      SUBTITLE: 'SETTINGS_MODEL_MANAGEMENT_SUBTITLE',
      SUBTITLE_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_SUBTITLE_VERIFIED',
      TEXT_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_TEXT_VERIFIED',
      SUBTITLE_UNVERIFIED: 'SETTINGS_MODEL_MANAGEMENT_SUBTITLE_UNVERIFIED',
      TEXT_UNVERIFIED: 'SETTINGS_MODEL_MANAGEMENT_TEXT_UNVERIFIED',
      TABLE: {
        HEADER_NAME: 'SETTINGS_MODEL_MANAGEMENT_TABLE_HEADER_NAME',
        HEADER_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_TABLE_HEADER_ALLOWED',
        HEADER_DATE_ADDED: 'SETTINGS_MODEL_MANAGEMENT_TABLE_HEADER_DATE_ADDED',
        SEARCH_PLACEHOLDER: 'SETTINGS_MODEL_MANAGEMENT_TABLE_SEARCH_PLACEHOLDER',
        NO_MODELS_FOUND: 'SETTINGS_MODEL_MANAGEMENT_TABLE_NO_MODELS_FOUND',
        TERMS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_TERMS',
        STATUS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_STATUS',
        ALLOW_MODEL_ARIA: 'SETTINGS_MODEL_MANAGEMENT_TABLE_ALLOW_MODEL_ARIA',
        LINKS: {
          TERMS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_TERMS',
          ADDITIONAL_TERMS: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_ADDITIONAL_TERMS',
          PRIVACY: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_PRIVACY',
          MODEL_ORIGIN: 'SETTINGS_MODEL_MANAGEMENT_TABLE_LINKS_MODEL_ORIGIN',
        },
        TOGGLE_TOOLTIP_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_TABLE_TOGGLE_TOOLTIP_APPROVED',
        TOGGLE_TOOLTIP_REJECTED: 'SETTINGS_MODEL_MANAGEMENT_TABLE_TOGGLE_TOOLTIP_REJECTED',
        USER_REQUESTED_TAG: 'SETTINGS_MODEL_MANAGEMENT_TABLE_USER_REQUESTED_TAG',
      },
      DESCRIPTION_SHORT: 'SETTINGS_MODEL_MANAGEMENT_DESCRIPTION_SHORT',
      READ_MORE: 'SETTINGS_MODEL_MANAGEMENT_READ_MORE',
      READ_LESS: 'SETTINGS_MODEL_MANAGEMENT_READ_LESS',
      AUTO_APPROVE_VERIFIED: {
        LABEL: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_LABEL',
        DESCRIPTION: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_DESCRIPTION',
        ERROR: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_ERROR',
        ARIA: 'SETTINGS_MODEL_MANAGEMENT_AUTO_APPROVE_VERIFIED_ARIA',
      },
      NOTIFY_VERIFIED: {
        LABEL: 'SETTINGS_MODEL_MANAGEMENT_NOTIFY_VERIFIED_LABEL',
        DESCRIPTION: 'SETTINGS_MODEL_MANAGEMENT_NOTIFY_VERIFIED_DESCRIPTION',
        ERROR: 'SETTINGS_MODEL_MANAGEMENT_NOTIFY_VERIFIED_ERROR',
        ARIA: 'SETTINGS_MODEL_MANAGEMENT_NOTIFY_VERIFIED_ARIA',
      },
      ENABLE_IMPORTING: {
        LABEL: 'SETTINGS_MODEL_MANAGEMENT_ENABLE_IMPORTING_LABEL',
        DESCRIPTION: 'SETTINGS_MODEL_MANAGEMENT_ENABLE_IMPORTING_DESCRIPTION',
        ERROR: 'SETTINGS_MODEL_MANAGEMENT_ENABLE_IMPORTING_ERROR',
        ARIA: 'SETTINGS_MODEL_MANAGEMENT_ENABLE_IMPORTING_ARIA',
      },
      SETTINGS_PANEL: {
        SETTINGS: 'SETTINGS_MODEL_MANAGEMENT_SETTINGS_PANEL_SETTINGS',
        AUTO_APPROVE_LABEL: 'SETTINGS_MODEL_MANAGEMENT_SETTINGS_PANEL_AUTO_APPROVE_LABEL',
        AUTO_APPROVE_DESCRIPTION: 'SETTINGS_MODEL_MANAGEMENT_SETTINGS_PANEL_AUTO_APPROVE_DESCRIPTION',
      },
      ERROR_UPDATING_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_ERROR_UPDATING_ALLOWED',
      FILTERS: {
        ALL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ALL',
        ADMIN_APPROVAL: {
          LABEL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ADMIN_APPROVAL_LABEL',
          APPROVED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ADMIN_APPROVAL_APPROVED',
          NOT_APPROVED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_ADMIN_APPROVAL_NOT_APPROVED',
        },
        STATUS: {
          LABEL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_STATUS_LABEL',
          VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_STATUS_VERIFIED',
          NOT_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_STATUS_NOT_VERIFIED',
        },
        APPROVAL_STATUS: {
          LABEL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_APPROVAL_STATUS_LABEL',
          VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_APPROVAL_STATUS_VERIFIED',
          NOT_VERIFIED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_APPROVAL_STATUS_NOT_VERIFIED',
        },
        TYPE: {
          LABEL: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_TYPE_LABEL',
          USER_REQUESTED: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_TYPE_USER_REQUESTED',
          SYSTEM_MODELS: 'SETTINGS_MODEL_MANAGEMENT_FILTERS_TYPE_SYSTEM_MODELS',
        },
      },
      PENDING_REQUESTS: {
        COUNT_SINGULAR: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_COUNT_SINGULAR',
        COUNT_PLURAL: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_COUNT_PLURAL',
        APPROVE: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_APPROVE',
        REJECT: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_REJECT',
        REQUESTED_BY: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_REQUESTED_BY',
        REQUESTED_AGO: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_REQUESTED_AGO',
        REVIEW_ERROR: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_REVIEW_ERROR',
        REQUEST_INTRO: 'SETTINGS_MODEL_MANAGEMENT_PENDING_REQUESTS_REQUEST_INTRO',
      },
      IMPORT_MODEL_NOTICE_MODAL: {
        TITLE: 'SETTINGS_MODEL_MANAGEMENT_IMPORT_MODEL_NOTICE_MODAL_TITLE',
        BODY_INTRO: 'SETTINGS_MODEL_MANAGEMENT_IMPORT_MODEL_NOTICE_MODAL_BODY_INTRO',
        BODY_DESCRIPTION: 'SETTINGS_MODEL_MANAGEMENT_IMPORT_MODEL_NOTICE_MODAL_BODY_DESCRIPTION',
        CANCEL: 'SETTINGS_MODEL_MANAGEMENT_IMPORT_MODEL_NOTICE_MODAL_CANCEL',
        CONFIRM: 'SETTINGS_MODEL_MANAGEMENT_IMPORT_MODEL_NOTICE_MODAL_CONFIRM',
      },
    },
    WORKSPACE_SETTINGS: {
      FORM: {
        NAME: 'SETTINGS_WORKSPACE_SETTINGS_FORM_NAME',
        GENERAL: 'SETTINGS_WORKSPACE_SETTINGS_FORM_GENERAL',
      },
      VOICE_INPUT: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_VOICE_INPUT_TITLE',
        LABEL: 'SETTINGS_WORKSPACE_SETTINGS_VOICE_INPUT_LABEL',
        DESCRIPTION: 'SETTINGS_WORKSPACE_SETTINGS_VOICE_INPUT_DESCRIPTION',
      },
      CREDITS_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_TITLE',
      CURRENT_AMOUNT: 'SETTINGS_WORKSPACE_SETTINGS_CURRENT_AMOUNT',
      DOWNLOAD_CREDITS_REPORT: 'SETTINGS_WORKSPACE_SETTINGS_DOWNLOAD_CREDITS_REPORT',
      CREDITS_REPORT_MODAL: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_TITLE',
        TIME_PERIOD_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_TIME_PERIOD_LABEL',
        DATE_RANGE_CURRENT_CYCLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_CURRENT_CYCLE',
        DATE_RANGE_LAST_30_DAYS: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_LAST_30_DAYS',
        DATE_RANGE_LAST_90_DAYS: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_LAST_90_DAYS',
        DATE_RANGE_ALL_TIME: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DATE_RANGE_ALL_TIME',
        CANCEL_BUTTON: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_CANCEL_BUTTON',
        DOWNLOAD_BUTTON: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_DOWNLOAD_BUTTON',
        ERROR_MESSAGE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_REPORT_MODAL_ERROR_MESSAGE',
      },
      REMAINING_MONTHLY_CREDITS_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_REMAINING_MONTHLY_CREDITS_TEXT',
      EXTRA_CREDITS_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_EXTRA_CREDITS_TEXT',
      ROLLOVER_CREDITS_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_ROLLOVER_CREDITS_TEXT',
      CREDIT_THRESHOLD_ALERTS_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDIT_THRESHOLD_ALERTS_TITLE',
      CREDIT_THRESHOLD_ALERTS_SUBTITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDIT_THRESHOLD_ALERTS_SUBTITLE',
      CREDIT_THRESHOLD_ALERTS_ERROR: 'SETTINGS_WORKSPACE_SETTINGS_CREDIT_THRESHOLD_ALERTS_ERROR',
      LOW_CREDITS_ALERTS_ARIA: 'SETTINGS_WORKSPACE_SETTINGS_LOW_CREDITS_ALERTS_ARIA',
      CREDITS: {
        UPGRADE_CTA: 'SETTINGS_WORKSPACE_SETTINGS_UPGRADE_CTA',
        UPGRADE_CTA_FREE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_UPGRADE_CTA_FREE_TOOLTIP',
      },
      PLAN: {
        PLAN: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_PLAN',
        SEATS: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_SEATS',
        SEATS_SUFFIX: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_SEATS_SUFFIX',
        RENEWAL_DATE: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_RENEWAL_DATE',
        EXPIRATION_DATE: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_EXPIRATION_DATE',
        DOWNGRADE_TEXT: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_DOWNGRADE_TEXT',
        MONTHLY_CREDITS: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_MONTHLY_CREDITS',
        MONTHLY_CREDITS_TOOLTIP_RESET: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_MONTHLY_CREDITS_TOOLTIP_RESET',
        MONTHLY_CREDITS_TOOLTIP_ROLLOVER: 'SETTINGS_WORKSPACE_SETTINGS_PLAN_MONTHLY_CREDITS_TOOLTIP_ROLLOVER',
      },
      UPGRADE: 'SETTINGS_WORKSPACE_SETTINGS_UPGRADE',
      MANAGE_BILLING: 'SETTINGS_WORKSPACE_SETTINGS_MANAGE_BILLING',
      CANCEL_PLAN: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN',
      CANCEL_PLAN_DIALOG: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_TITLE',
        MESSAGE: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_MESSAGE',
        CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_CONFIRM',
        CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_CANCEL_PLAN_DIALOG_CANCEL',
      },
      CONTACT_US_PART_1: 'SETTINGS_WORKSPACE_SETTINGS_CONTACT_US_PART_1',
      CONTACT_US_PART_2: 'SETTINGS_WORKSPACE_SETTINGS_CONTACT_US_PART_2',
      CHANGE_PLAN: 'SETTINGS_WORKSPACE_SETTINGS_CHANGE_PLAN',
      API_KEYS: {
        PAGE_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PAGE_TITLE',
        PAGE_DESCRIPTION: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PAGE_DESCRIPTION',
        COLUMN_PROVIDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_COLUMN_PROVIDER',
        COLUMN_CREDENTIALS: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_COLUMN_CREDENTIALS',
        COLUMN_STATUS: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_COLUMN_STATUS',
        EDIT: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_EDIT',
        DELETE_KEY_ARIA: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_KEY_ARIA',
        ADD_KEY_ARIA: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_ADD_KEY_ARIA',
        ADD_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_ADD_TOOLTIP',
        DELETE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_TOOLTIP',
        ENABLE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_ENABLE_TOOLTIP',
        DISABLE_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISABLE_TOOLTIP',
        INPUT_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_INPUT_LABEL',
        KEY_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_KEY_LABEL',
        SAVE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_SAVE',
        CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_CANCEL',
        API_KEY_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_API_KEY_LABEL',
        GOOGLE_SERVICE_EMAIL_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_SERVICE_EMAIL_LABEL',
        GOOGLE_SERVICE_EMAIL_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_SERVICE_EMAIL_PLACEHOLDER',
        GOOGLE_PROJECT_ID_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PROJECT_ID_LABEL',
        GOOGLE_PROJECT_ID_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PROJECT_ID_PLACEHOLDER',
        GOOGLE_PRIVATE_KEY_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PRIVATE_KEY_LABEL',
        GOOGLE_PRIVATE_KEY_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_GOOGLE_PRIVATE_KEY_PLACEHOLDER',
        LOAD_FAILED: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_LOAD_FAILED',
        OPERATION_FAILED: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_OPERATION_FAILED',
        DELETE_CONFIRM: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_TITLE',
          BODY: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_BODY',
          CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_CANCEL',
          CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DELETE_CONFIRM_CONFIRM',
        },
        DISCLAIMER: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_TITLE',
          HEADS_UP: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_HEADS_UP',
          BODY: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_BODY',
          CONTINUE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_DISCLAIMER_CONTINUE',
        },
        PROVIDERS: {
          GOOGLE: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PROVIDER_GOOGLE',
          FAL: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PROVIDER_FAL',
          OPENAI: 'SETTINGS_WORKSPACE_SETTINGS_API_KEYS_PROVIDER_OPENAI',
        },
      },
      WEAVE_API_KEYS: {
        PAGE_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_PAGE_TITLE',
        PAGE_DESCRIPTION: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_PAGE_DESCRIPTION',
        PAGE_DESCRIPTION_DOCS: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_PAGE_DESCRIPTION_DOCS',
        BETA: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_BETA',
        OPERATION_FAILED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_OPERATION_FAILED',
        TABLE_EMPTY: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TABLE_EMPTY',
        TABLE_NAME: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TABLE_NAME',
        TABLE_SUFFIX: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TABLE_SUFFIX',
        TABLE_OWNER: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TABLE_OWNER',
        TABLE_CREATED_AT: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TABLE_CREATED_AT',
        TABLE_LAST_USED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TABLE_LAST_USED',
        REVOKE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKE',
        SEARCH_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_SEARCH_PLACEHOLDER',
        SEARCH_NO_MATCH: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_SEARCH_NO_MATCH',
        EXPIRES_IN_DAYS: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_EXPIRES_IN_DAYS',
        EXPIRES_IN_MONTHS: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_EXPIRES_IN_MONTHS',
        EXPIRES_IN_YEAR: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_EXPIRES_IN_YEAR',
        EXPIRED_ON: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_EXPIRED_ON',
        REVOKED_ON: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKED_ON',
        STATUS_ACTIVE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_STATUS_ACTIVE',
        STATUS_EXPIRED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_STATUS_EXPIRED',
        STATUS_REVOKED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_STATUS_REVOKED',
        REVOKE_CONFIRM: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKE_CONFIRM_TITLE',
          BODY_QUESTION: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKE_CONFIRM_BODY_QUESTION',
          BODY_WARNING: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKE_CONFIRM_BODY_WARNING',
          CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKE_CONFIRM_CANCEL',
          CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_REVOKE_CONFIRM_CONFIRM',
        },
        TERMS_MODAL: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TERMS_MODAL_TITLE',
          BODY_SUBJECT: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TERMS_MODAL_BODY_SUBJECT',
          BODY_CONSENT: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TERMS_MODAL_BODY_CONSENT',
          CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TERMS_MODAL_CANCEL',
          CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TERMS_MODAL_CONFIRM',
          FAILED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_TERMS_MODAL_FAILED',
        },
        CREATE_NEW: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_NEW',
        CREATE_DISABLED_AT_LIMIT: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_DISABLED_AT_LIMIT',
        CREATE_MODAL: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_TITLE',
          NAME_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_NAME_LABEL',
          NAME_PLACEHOLDER: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_NAME_PLACEHOLDER',
          EXPIRATION_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_EXPIRATION_LABEL',
          EXPIRATION_HINT: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_EXPIRATION_HINT',
          EXPIRATION_30D: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_EXPIRATION_30D',
          EXPIRATION_90D: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_EXPIRATION_90D',
          EXPIRATION_365D: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_EXPIRATION_365D',
          CREATE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_CREATE',
          CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_CANCEL',
          SHOWN_ONCE_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_SHOWN_ONCE_TITLE',
          SHOWN_ONCE_BODY: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_SHOWN_ONCE_BODY',
          SHOWN_ONCE_WARNING_TITLE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_SHOWN_ONCE_WARNING_TITLE',
          SHOWN_ONCE_WARNING_BODY: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_SHOWN_ONCE_WARNING_BODY',
          COPIED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_COPIED',
          COPY_TOKEN_TOOLTIP: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_COPY_TOKEN_TOOLTIP',
          DONE: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_DONE',
          COPY_FAILED: 'SETTINGS_WORKSPACE_SETTINGS_WEAVE_API_KEYS_CREATE_MODAL_COPY_FAILED',
        },
      },
      CREDITS_ALLOCATION: {
        TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_TITLE',
        DEFAULT_ALLOCATION_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_DEFAULT_ALLOCATION_LABEL',
        UNLIMITED: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_UNLIMITED',
        EDIT_DEFAULT_ALLOCATION_CTA: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_EDIT_DEFAULT_ALLOCATION_CTA',
        CHANGE_DEFAULT_ALLOCATION_MODAL: {
          TITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_TITLE',
          SUBTITLE: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_SUBTITLE',
          CTA_CONFIRM: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_CTA_CONFIRM',
          CTA_CANCEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_CTA_CANCEL',
          BUTTON_UNLIMITED_TITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_UNLIMITED_TITLE',
          BUTTON_UNLIMITED_SUBTITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_UNLIMITED_SUBTITLE',
          BUTTON_LIMIT_TITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_LIMIT_TITLE',
          BUTTON_LIMIT_SUBTITLE:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_BUTTON_LIMIT_SUBTITLE',
          CREDITS_ESTIMATION_TEXT:
            'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_CREDITS_ESTIMATION_TEXT',
          AMOUNT_LABEL: 'SETTINGS_WORKSPACE_SETTINGS_CREDITS_ALLOCATION_CHANGE_DEFAULT_ALLOCATION_MODAL_AMOUNT_LABEL',
        },
      },
    },
    FONTS: {
      TITLE: 'SETTINGS_FONTS_TITLE',
      DESCRIPTION: 'SETTINGS_FONTS_DESCRIPTION',
      ADD: 'SETTINGS_FONTS_ADD',
      EMPTY: 'SETTINGS_FONTS_EMPTY',
      LOAD_FAILED: 'SETTINGS_FONTS_LOAD_FAILED',
      RETRY: 'SETTINGS_FONTS_RETRY',
      STYLE_SUMMARY: 'SETTINGS_FONTS_STYLE_SUMMARY',
      DELETE_ARIA: 'SETTINGS_FONTS_DELETE_ARIA',
      MANAGED_BY_WEAVE: 'SETTINGS_FONTS_MANAGED_BY_WEAVE',
      ADD_DIALOG: {
        TITLE: 'SETTINGS_FONTS_ADD_DIALOG_TITLE',
        OWNERSHIP_INDIVIDUAL: 'SETTINGS_FONTS_ADD_DIALOG_OWNERSHIP_INDIVIDUAL',
        OWNERSHIP_TEAM: 'SETTINGS_FONTS_ADD_DIALOG_OWNERSHIP_TEAM',
        UPLOAD: 'SETTINGS_FONTS_ADD_DIALOG_UPLOAD',
      },
      DELETE_DIALOG: {
        TITLE: 'SETTINGS_FONTS_DELETE_DIALOG_TITLE',
        MESSAGE: 'SETTINGS_FONTS_DELETE_DIALOG_MESSAGE',
        CONFIRM: 'SETTINGS_FONTS_DELETE_DIALOG_CONFIRM',
      },
      SNACKBAR: {
        ADDING: 'SETTINGS_FONTS_SNACKBAR_ADDING',
        ADDED: 'SETTINGS_FONTS_SNACKBAR_ADDED',
        UNSUPPORTED_TYPE: 'SETTINGS_FONTS_SNACKBAR_UNSUPPORTED_TYPE',
        DUPLICATE: 'SETTINGS_FONTS_SNACKBAR_DUPLICATE',
        UPLOAD_FAILED: 'SETTINGS_FONTS_SNACKBAR_UPLOAD_FAILED',
        REQUEST_FAILED: 'SETTINGS_FONTS_SNACKBAR_REQUEST_FAILED',
        DELETING: 'SETTINGS_FONTS_SNACKBAR_DELETING',
        DELETE_FAILED: 'SETTINGS_FONTS_SNACKBAR_DELETE_FAILED',
      },
    },
    MENU: {
      PROFILE: 'SETTINGS_MENU_PROFILE',
      WORKSPACE_SETTINGS: 'SETTINGS_MENU_WORKSPACE_SETTINGS',
      MEMBERS: 'SETTINGS_MENU_MEMBERS',
      API_KEYS: 'SETTINGS_MENU_API_KEYS',
      WEAVE_API_KEYS: 'SETTINGS_MENU_WEAVE_API_KEYS',
      MODEL_MANAGEMENT: 'SETTINGS_MENU_MODEL_MANAGEMENT',
      FONTS: 'SETTINGS_MENU_FONTS',
      SIGNOUT: 'SETTINGS_MENU_SIGNOUT',
    },
    SETTINGS: 'SETTINGS_SETTINGS',
    TEAM: {
      ACTIVATION_PAGE: {
        ERROR_SUBTITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_ERROR_SUBTITLE',
        ERROR_TITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_ERROR_TITLE',
        SUBTITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_SUBTITLE',
        TITLE: 'SETTINGS_TEAM_ACTIVATION_PAGE_TITLE',
      },
      EMPTY_STATE: {
        CTA: 'SETTINGS_TEAM_EMPTY_STATE_CTA',
        TITLE: 'SETTINGS_TEAM_EMPTY_STATE_TITLE',
      },
      INVITE_USER_MODAL: {
        TITLE: 'SETTINGS_TEAM_INVITE_USER_MODAL_TITLE',
        SEATS: 'SETTINGS_TEAM_INVITE_USER_MODAL_SEATS',
        SEATS_ZERO_SUBTITLE: 'SETTINGS_TEAM_INVITE_USER_MODAL_SEATS_ZERO_SUBTITLE',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_1: 'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_1',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_2_MONTHLY:
          'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_2_MONTHLY',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_2_YEARLY:
          'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_2_YEARLY',
        TEAM_SEAT_LIMIT_EXCEEDED_PART_3: 'SETTINGS_TEAM_INVITE_USER_MODAL_TEAM_SEAT_LIMIT_EXCEEDED_PART_3',
        ENTERPRISE_SEAT_LIMIT_EXCEEDED: 'SETTINGS_TEAM_INVITE_USER_MODAL_ENTERPRISE_SEAT_LIMIT_EXCEEDED',
        SUCCESS_MESSAGE: 'INVITE_USER_MODAL_SUCCESS_MESSAGE',
        INVITE_ERROR: 'SETTINGS_TEAM_INVITE_USER_MODAL_INVITE_ERROR',
        PENDING_INVITATION_ERROR: 'SETTINGS_TEAM_INVITE_USER_MODAL_PENDING_INVITATION_ERROR',
        ALREADY_MEMBER_ERROR: 'SETTINGS_TEAM_INVITE_USER_MODAL_ALREADY_MEMBER_ERROR',
        PARTIAL_SUCCESS: 'SETTINGS_TEAM_INVITE_USER_MODAL_PARTIAL_SUCCESS',
      },
      JOIN_TEAM_SUCCESS: 'SETTINGS_TEAM_JOIN_TEAM_SUCCESS',
      REMOVE_MEMBER_DIALOG: {
        CONTENT: 'SETTINGS_TEAM_REMOVE_MEMBER_DIALOG_CONTENT',
        INVITED_CONTENT: 'SETTINGS_TEAM_REMOVE_MEMBER_DIALOG_INVITED_CONTENT',
      },
      TEAM_TABLE: {
        ADD_MEMBERS_BUTTON: 'SETTINGS_TEAM_TABLE_ADD_MEMBERS_BUTTON',
        DOWNLOAD_MEMBERS_USAGE_BUTTON: 'SETTINGS_TEAM_TABLE_DOWNLOAD_MEMBERS_USAGE_BUTTON',
        SELECT_ALL_MEMBERS_ARIA: 'SETTINGS_TEAM_TABLE_SELECT_ALL_MEMBERS_ARIA',
        SEARCH_PLACEHOLDER: 'SETTINGS_TEAM_TABLE_SEARCH_PLACEHOLDER',
        TABLE_TITLE_SUFFIX: 'SETTINGS_TEAM_TABLE_TABLE_TITLE_SUFFIX',
        HEADER_NAME: 'SETTINGS_TEAM_TABLE_HEADER_NAME',
        HEADER_ROLE: 'SETTINGS_TEAM_TABLE_HEADER_ROLE',
        HEADER_CREDITS: 'SETTINGS_TEAM_TABLE_HEADER_CREDITS',
        HEADER_USAGE: 'SETTINGS_TEAM_TABLE_HEADER_USAGE',
        HEADER_STATUS: 'SETTINGS_TEAM_TABLE_HEADER_STATUS',
        HEADER_LAST_ACTIVE: 'SETTINGS_TEAM_TABLE_HEADER_LAST_ACTIVE',
        INVITATION_EXPIRED: 'SETTINGS_TEAM_TABLE_INVITATION_EXPIRED',
        LAST_ACTIVE_TOOLTIP: 'SETTINGS_TEAM_TABLE_LAST_ACTIVE_TOOLTIP',
        EDIT_LIMIT_MODAL: {
          TITLE: 'SETTINGS_TEAM_TABLE_EDIT_LIMIT_MODAL_TITLE',
          SUBTITLE: 'SETTINGS_TEAM_TABLE_EDIT_LIMIT_MODAL_SUBTITLE',
        },
        SELECTED_MEMBERS_COUNT: 'SETTINGS_TEAM_TABLE_SELECTED_MEMBERS_COUNT',
        ALLOCATED_CREDITS: 'SETTINGS_TEAM_TABLE_ALLOCATED_CREDITS',
        RESET_TO_DEFAULT: 'SETTINGS_TEAM_TABLE_RESET_TO_DEFAULT',
      },

      MEMBERS_REPORT_MODAL: {
        TITLE: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_TITLE',
        TIME_PERIOD_LABEL: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_TIME_PERIOD_LABEL',
        DATE_RANGE_CURRENT_CYCLE: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_DATE_RANGE_CURRENT_CYCLE',
        DATE_RANGE_LAST_30_DAYS: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_DATE_RANGE_LAST_30_DAYS',
        DATE_RANGE_LAST_90_DAYS: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_DATE_RANGE_LAST_90_DAYS',
        CANCEL_BUTTON: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_CANCEL_BUTTON',
        DOWNLOAD_BUTTON: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_DOWNLOAD_BUTTON',
        ERROR_MESSAGE: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_ERROR_MESSAGE',
        LAST_ACTIVE_INFO_BANNER: 'SETTINGS_TEAM_MEMBERS_REPORT_MODAL_LAST_ACTIVE_INFO_BANNER',
      },

      USER_STATUS: {
        ACTIVE: 'SETTINGS_TEAM_USER_STATUS_ACTIVE',
        INVITED: 'SETTINGS_TEAM_USER_STATUS_INVITED',
      },
      WORKSPACE_CREDITS: 'SETTINGS_TEAM_WORKSPACE_CREDITS',
      WORKSPACE_CREDITS_CTA: 'SETTINGS_TEAM_WORKSPACE_CREDITS_CTA',
      WORKSPACE_MEMBERS_CAN_SEE_CREDITS: 'SETTINGS_TEAM_WORKSPACE_MEMBERS_CAN_SEE_CREDITS',
      WORKSPACE_NAME: 'SETTINGS_TEAM_WORKSPACE_NAME',
      WORKSPACE_NAME_CHANGE: 'SETTINGS_TEAM_WORKSPACE_NAME_CHANGE',
      WORKSPACE_NAME_PLACEHOLDER: 'SETTINGS_TEAM_WORKSPACE_NAME_PLACEHOLDER',
      YOU: 'SETTINGS_TEAM_YOU',
      WORKSPACE_SUBSCRIPTION_TYPE: 'SETTINGS_TEAM_WORKSPACE_SUBSCRIPTION_TYPE',
      ACTIONS_MENU: {
        DELETE: 'SETTINGS_TEAM_ACTIONS_MENU_DELETE',
        RESEND_INVITE: 'SETTINGS_TEAM_ACTIONS_MENU_RESEND_INVITE',
        COPY_INVITE_LINK: 'SETTINGS_TEAM_ACTIONS_MENU_COPY_INVITE_LINK',
        EDIT_LIMIT: 'SETTINGS_TEAM_ACTIONS_MENU_EDIT_LIMIT',
      },
      CONFIRM_DELETE: {
        TITLE: 'SETTINGS_TEAM_CONFIRM_DELETE_TITLE',
        CONFIRM: 'SETTINGS_TEAM_CONFIRM_DELETE_CONFIRM_TEXT',
      },
      UPGRADE: {
        TITLE: 'SETTINGS_TEAM_UPGRADE_TITLE',
        TEXT: 'SETTINGS_TEAM_UPGRADE_TEXT',
      },
      ROLES: {
        ADMIN: 'SETTINGS_TEAM_ROLES_ADMIN',
        MEMBER: 'SETTINGS_TEAM_ROLES_MEMBER',
      },
    },
  },
  SHARED_DESIGN_APP: {
    OUTPUT_HISTORY: {
      JUST_NOW: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_JUST_NOW',
      GENERATING: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_GENERATING',
      FAILED_TITLE: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_FAILED_TITLE',
      FAILED_MESSAGE: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_FAILED_MESSAGE',
      DOWNLOAD: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_DOWNLOAD',
      DOWNLOAD_ALL: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_DOWNLOAD_ALL',
      EXPAND: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_EXPAND',
      MORE: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_MORE',
      REMOVE: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_REMOVE',
      MORE_BATCH: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_MORE_BATCH',
      REMOVE_ALL: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_REMOVE_ALL',
      REMOVE_UNAVAILABLE: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_REMOVE_UNAVAILABLE',
      REMOVE_FAILED: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_REMOVE_FAILED',
      IMAGE: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_IMAGE',
      VIDEO: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_VIDEO',
      AUDIO: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_AUDIO',
      THREE_D: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_THREE_D',
      TEXT: 'SHARED_DESIGN_APP_OUTPUT_HISTORY_TEXT',
    },
    NUMBER_OF_RUNS: 'SHARED_DESIGN_APP_NUMBER_OF_RUNS',
    ACTIVATION_PAGE: {
      DEFAULT_ERROR: 'SHARED_DESIGN_APP_ACTIVATION_PAGE_DEFAULT_ERROR',
      TITLE: 'SHARED_DESIGN_APP_ACTIVATION_PAGE_TITLE',
    },
    EDIT_DESIGN_APP_BUTTON: 'SHARED_DESIGN_APP_EDIT_DESIGN_APP_BUTTON',
    INPUTS: {
      DEFAULTS_COMMENT: 'SHARED_DESIGN_APP_INPUTS_DEFAULTS_COMMENT',
      ARRAY_HELPER: 'SHARED_DESIGN_APP_INPUTS_ARRAY_HELPER',
      HEADER: {
        ADD_DESCRIPTION: 'SHARED_DESIGN_APP_INPUTS_HEADER_ADD_DESCRIPTION',
        ADD_DESCRIPTION_PLAIN: 'SHARED_DESIGN_APP_INPUTS_HEADER_ADD_DESCRIPTION_PLAIN',
        DESCRIPTION_PLACEHOLDER: 'SHARED_DESIGN_APP_INPUTS_DESCRIPTION_PLACEHOLDER',
        DISABLED: 'SHARED_DESIGN_APP_INPUTS_HEADER_DISABLED',
        ENABLED: 'SHARED_DESIGN_APP_INPUTS_HEADER_ENABLED',
      },
      MULTI_LORA: {
        NONE: 'SHARED_DESIGN_APP_INPUTS_MULTI_LORA_NONE',
        WEIGHT: 'SHARED_DESIGN_APP_INPUTS_MULTI_LORA_WEIGHT',
      },
      PARAMS_DRAWER: {
        SET_AS_INPUT: 'SHARED_DESIGN_APP_INPUTS_PARAMS_DRAWER_SET_AS_INPUT',
      },
      PROMPT: {
        PLACEHOLDER: 'SHARED_DESIGN_APP_INPUTS_PROMPT_PLACEHOLDER',
      },
      REQUIRED_ERROR: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR',
      REQUIRED_ERROR_FILE: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_FILE',
      REQUIRED_ERROR_LORA: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_LORA',
      REQUIRED_ERROR_TEXT_ITERATOR: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_TEXT_ITERATOR',
      REQUIRED_ERROR_MEDIA_ITERATOR: 'SHARED_DESIGN_APP_INPUTS_REQUIRED_ERROR_MEDIA_ITERATOR',
      SET_AS_PARAMETER: 'SHARED_DESIGN_APP_INPUTS_SET_AS_PARAMETER',
    },
    MODAL: {
      BUTTON_CTA: 'SHARED_DESIGN_APP_MODAL_BUTTON_CTA',
      DEFAULT_ERROR: 'SHARED_DESIGN_APP_MODAL_DEFAULT_ERROR',
      LINK_COPIED: 'SHARED_DESIGN_APP_MODAL_LINK_COPIED',
      TITLE: 'SHARED_DESIGN_APP_MODAL_TITLE',
    },
    NO_INPUTS: {
      TIP: 'SHARED_DESIGN_APP_TOOLBAR_NO_INPUTS_TIP',
      TITLE: 'SHARED_DESIGN_APP_TOOLBAR_NO_INPUTS_TITLE',
    },
    CREATE_TOOL_MODAL: {
      TITLE: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_TITLE',
      THUMBNAIL: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_THUMBNAIL',
      NAME: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_NAME',
      DESCRIPTION: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_DESCRIPTION',
      DESCRIPTION_PLACEHOLDER: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_DESCRIPTION_PLACEHOLDER',
      SUBMIT: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_SUBMIT',
      REQUIRED_ERROR: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_REQUIRED_ERROR',
      THUMBNAIL_UPLOAD_FAILED: 'SHARED_DESIGN_APP_CREATE_TOOL_MODAL_THUMBNAIL_UPLOAD_FAILED',
    },
    PREVIEW_DESIGN_APP_BUTTON: 'SHARED_DESIGN_APP_PREVIEW_DESIGN_APP_BUTTON',
    PUBLISH_DESIGN_APP_BUTTON: 'SHARED_DESIGN_APP_PUBLISH_DESIGN_APP_BUTTON',
    UPDATE_TOOL_BUTTON: 'SHARED_DESIGN_APP_UPDATE_TOOL_BUTTON',
    PUBLISH_DESIGN_APP_FAILED: 'SHARED_DESIGN_APP_PUBLISH_DESIGN_APP_FAILED',
    PUBLISH_DESIGN_APP_SUCCESS: 'SHARED_DESIGN_APP_PUBLISH_DESIGN_APP_SUCCESS',
    UPDATE_TOOL_SUCCESS: 'SHARED_DESIGN_APP_UPDATE_TOOL_SUCCESS',
    UPDATE_TOOL_FAILED: 'SHARED_DESIGN_APP_UPDATE_TOOL_FAILED',
    TOOLBAR: {
      CURRENT_VERSION: 'SHARED_DESIGN_APP_TOOLBAR_CURRENT_VERSION',
      LAST_PUBLISHED_AT: 'SHARED_DESIGN_APP_TOOLBAR_LAST_PUBLISHED_AT',
      LATEST_VERSION: 'SHARED_DESIGN_APP_TOOLBAR_LATEST_VERSION',
      NO_VERSIONS: 'SHARED_DESIGN_APP_TOOLBAR_NO_VERSIONS',
      VIEW_VERSION: 'SHARED_DESIGN_APP_TOOLBAR_VIEW_VERSION',
    },
  },
  SHARED_ASSET_VIEW: {
    GO_TO_WORKFLOW: 'SHARED_ASSET_VIEW_GO_TO_WORKFLOW',
    SHARED: 'SHARED_ASSET_VIEW_SHARED',
    DASHBOARD_ARIA: 'SHARED_ASSET_VIEW_DASHBOARD_ARIA',
    LOADING: 'SHARED_ASSET_VIEW_LOADING',
    UNAVAILABLE: 'SHARED_ASSET_VIEW_UNAVAILABLE',
  },
  SHARE_WORKFLOW_MODAL: {
    EMAIL_PLACEHOLDER: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_EMAIL_PLACEHOLDER',
    INPUTS: {
      PROMPT_PLACEHOLDER: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_INPUTS_PROMPT_PLACEHOLDER',
    },
    LINK: {
      ANYONE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_ANYONE',
      ORGANIZATION: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_ORGANIZATION',
      RESTRICTED: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_RESTRICTED',
      TEAM: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_LINK_TEAM',
    },
    PUBLISH_TO_FIGMA_COMMUNITY: {
      ROW_LABEL: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_LABEL',
      ROW_LABEL_PUBLISHED: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_LABEL_PUBLISHED',
      ROW_UNPUBLISH_BUTTON: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_UNPUBLISH_BUTTON',
      ROW_TOOLTIP_CUSTOM_FONTS:
        'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_TOOLTIP_CUSTOM_FONTS',
      ROW_TOOLTIP_FIGMA_NODE:
        'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_TOOLTIP_FIGMA_NODE',
      ROW_TOOLTIP_UNVERIFIED_MODELS:
        'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_TOOLTIP_UNVERIFIED_MODELS',
      ROW_TOOLTIP_ENTERPRISE:
        'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_TOOLTIP_ENTERPRISE',
      ROW_TOOLTIP_BANNED: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ROW_TOOLTIP_BANNED',
      ROW_TOOLTIP_ORG_MEMBER: 'PUBLISH_TO_COMMUNITY_ROW_TOOLTIP_ORG_MEMBER',
      UPGRADE_UPSELL: {
        MESSAGE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_UPGRADE_UPSELL_MESSAGE',
        CTA: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_UPGRADE_UPSELL_CTA',
      },
      ORG_DESTINATION: {
        ROW_LABEL_PUBLISHED:
          'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_PUBLISH_TO_FIGMA_COMMUNITY_ORG_DESTINATION_ROW_LABEL_PUBLISHED',
        ROW_LABEL: 'PUBLISH_TO_ORG_ROW_LABEL',
        ROW_LABEL_ORG_UNKNOWN: 'PUBLISH_TO_ORG_ROW_LABEL_ORG_UNKNOWN',
        ROW_LABEL_UNLINKED: 'PUBLISH_TO_ORG_ROW_LABEL_UNLINKED',
        ACCESS_MODAL_BODY: 'PUBLISH_TO_ORG_ACCESS_MODAL_BODY',
        PICKER_LABEL: 'PUBLISH_TO_ORG_PICKER_LABEL',
        FOOTER_INFO: 'PUBLISH_TO_ORG_FOOTER_INFO',
        SUCCESS_SUBHEADER: 'PUBLISH_TO_ORG_SUCCESS_SUBHEADER',
        PUBLISHING_STATUS: 'PUBLISH_TO_ORG_PUBLISHING_STATUS',
        OPEN_IN_FIGMA: 'PUBLISH_TO_ORG_OPEN_IN_FIGMA',
        LOOKUP_FAILED_TOOLTIP: 'PUBLISH_TO_ORG_LOOKUP_FAILED_TOOLTIP',
        ROW_TOOLTIP_FIGMA_NODE: 'PUBLISH_TO_ORG_ROW_TOOLTIP_FIGMA_NODE',
        ROW_TOOLTIP_FIGMA_NODE_ORG_UNKNOWN: 'PUBLISH_TO_ORG_ROW_TOOLTIP_FIGMA_NODE_ORG_UNKNOWN',
        DESCRIPTION_PLACEHOLDER: 'PUBLISH_TO_ORG_DESCRIPTION_PLACEHOLDER',
        ACCESS_LOCKED_TOOLTIP: 'PUBLISH_TO_ORG_ACCESS_LOCKED_TOOLTIP',
      },
      ACCESS_LOCKED_TOOLTIP: 'PUBLISH_TO_COMMUNITY_ACCESS_LOCKED_TOOLTIP',
      ACCESS_MODAL: {
        TITLE: 'PUBLISH_TO_COMMUNITY_ACCESS_MODAL_TITLE',
        BODY: 'PUBLISH_TO_COMMUNITY_ACCESS_MODAL_BODY',
        BODY_WORKSPACE: 'PUBLISH_TO_COMMUNITY_ACCESS_MODAL_BODY_WORKSPACE',
        CONFIRM: 'PUBLISH_TO_COMMUNITY_ACCESS_MODAL_CONFIRM',
      },
      MODAL: {
        TITLE_PUBLISH: 'PUBLISH_TO_COMMUNITY_MODAL_TITLE_PUBLISH',
        TITLE_PUBLISH_TOOL: 'PUBLISH_TO_COMMUNITY_MODAL_TITLE_PUBLISH_TOOL',
        STEPS: {
          DESCRIPTION: 'PUBLISH_TO_COMMUNITY_MODAL_STEPS_DESCRIPTION',
          IMAGES: 'PUBLISH_TO_COMMUNITY_MODAL_STEPS_IMAGES',
          DETAILS: 'PUBLISH_TO_COMMUNITY_MODAL_STEPS_DETAILS',
        },
        DESCRIPTION_STEP: {
          NAME_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_NAME_LABEL',
          DESCRIPTION_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_DESCRIPTION_LABEL',
          DESCRIPTION_PLACEHOLDER: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_DESCRIPTION_PLACEHOLDER',
          DESCRIPTION_PLACEHOLDER_TOOL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_DESCRIPTION_PLACEHOLDER_TOOL',
          CATEGORY_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_CATEGORY_LABEL',
          CATEGORY_PLACEHOLDER: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_CATEGORY_PLACEHOLDER',
          TAGS_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DESCRIPTION_STEP_TAGS_LABEL',
        },
        IMAGES_STEP: {
          THUMBNAIL_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_THUMBNAIL_LABEL',
          THUMBNAIL_LABEL_TOOL: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_THUMBNAIL_LABEL_TOOL',
          ICON_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_ICON_LABEL',
          ICON_RECOMMENDED_SIZE: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_ICON_RECOMMENDED_SIZE',
          GALLERY_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_GALLERY_LABEL',
          RECOMMENDED_SIZE: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_RECOMMENDED_SIZE',
          UPLOAD: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_UPLOAD',
          UPLOAD_IMAGE: 'PUBLISH_TO_COMMUNITY_MODAL_IMAGES_STEP_UPLOAD_IMAGE',
        },
        DETAILS_STEP: {
          EMAIL_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_EMAIL_LABEL',
          PROFILE_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_PROFILE_LABEL',
          HANDLE_SECTION_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_SECTION_LABEL',
          HANDLE_SECTION_DESCRIPTION_PREFIX:
            'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_SECTION_DESCRIPTION_PREFIX',
          HANDLE_SECTION_GUIDELINES_LINK: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_SECTION_GUIDELINES_LINK',
          HANDLE_SECTION_DESCRIPTION_SUFFIX:
            'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_SECTION_DESCRIPTION_SUFFIX',
          HANDLE_AVAILABLE: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_AVAILABLE',
          HANDLE_TAKEN: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_TAKEN',
          HANDLE_INVALID_FORMAT: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_INVALID_FORMAT',
          HANDLE_CHECK_FAILED: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_HANDLE_CHECK_FAILED',
          TERMS_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_LABEL',
          TERMS_AGREE_PREFIX: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_AGREE_PREFIX',
          TERMS_LINK: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_LINK',
          TERMS_REMINDER: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_TERMS_REMINDER',
          COMMENTS_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMMENTS_LABEL',
          COMMENTS_TOGGLE: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMMENTS_TOGGLE',
          COMPATIBILITY_LABEL: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMPATIBILITY_LABEL',
          COMPATIBILITY_FIGMA_WEAVE: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMPATIBILITY_FIGMA_WEAVE',
          COMPATIBILITY_FIGMA_DESIGN: 'PUBLISH_TO_COMMUNITY_MODAL_DETAILS_STEP_COMPATIBILITY_FIGMA_DESIGN',
        },
        FOOTER: {
          INFO: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_INFO',
          INFO_TOOL: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_INFO_TOOL',
          BACK: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_BACK',
          NEXT: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_NEXT',
          PUBLISH: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_PUBLISH',
          COPY_LINK: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_COPY_LINK',
          GO_TO_COMMUNITY: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_GO_TO_COMMUNITY',
          GO_BACK: 'PUBLISH_TO_COMMUNITY_MODAL_FOOTER_GO_BACK',
        },
        ERRORS: {
          NAME_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_NAME_REQUIRED',
          DESCRIPTION_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_DESCRIPTION_REQUIRED',
          CATEGORY_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_CATEGORY_REQUIRED',
          IMAGE_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_IMAGE_REQUIRED',
          ICON_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_ICON_REQUIRED',
          HANDLE_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_HANDLE_REQUIRED',
          HANDLE_CREATE_FAILED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_HANDLE_CREATE_FAILED',
          TERMS_REQUIRED: 'PUBLISH_TO_COMMUNITY_MODAL_ERRORS_TERMS_REQUIRED',
        },
        TERMINAL: {
          PUBLISHING_STATUSES: {
            PREPARING: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_PUBLISHING_STATUS_PREPARING',
            PREPARING_TOOL: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_PUBLISHING_STATUS_PREPARING_TOOL',
            UPLOADING: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_PUBLISHING_STATUS_UPLOADING',
            PUBLISHING: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_PUBLISHING_STATUS_PUBLISHING',
          },
          SUCCESS_HEADER: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_SUCCESS_HEADER',
          SUCCESS_SUBHEADER: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_SUCCESS_SUBHEADER',
          FAILURE_HEADER: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_FAILURE_HEADER',
          FAILURE_SUBHEADER: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_FAILURE_SUBHEADER',
          BY_AUTHOR: 'PUBLISH_TO_COMMUNITY_MODAL_TERMINAL_BY_AUTHOR',
        },
      },
      SNACKBAR: {
        ACCESS_UPDATE_FAILURE: 'PUBLISH_TO_COMMUNITY_SNACKBAR_ACCESS_UPDATE_FAILURE',
        ACCESS_LOCKED_WHILE_PUBLISHED: 'PUBLISH_TO_COMMUNITY_SNACKBAR_ACCESS_LOCKED_WHILE_PUBLISHED',
        LINK_SUCCESS: 'PUBLISH_TO_COMMUNITY_SNACKBAR_LINK_SUCCESS',
        LINK_FAILURE: 'PUBLISH_TO_COMMUNITY_SNACKBAR_LINK_FAILURE',
        LINK_COPIED: 'PUBLISH_TO_COMMUNITY_SNACKBAR_LINK_COPIED',
        MANAGE_IN_SETTINGS: 'PUBLISH_TO_COMMUNITY_SNACKBAR_MANAGE_IN_SETTINGS',
      },
      UNPUBLISH: {
        CONFIRM_TITLE: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_CONFIRM_TITLE',
        CONFIRM_BODY: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_CONFIRM_BODY',
        CONFIRM_TITLE_TOOL: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_CONFIRM_TITLE_TOOL',
        CONFIRM_BODY_TOOL: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_CONFIRM_BODY_TOOL',
        CONFIRM_BODY_TOOL_ORG: 'PUBLISH_TO_ORG_UNPUBLISH_CONFIRM_BODY_TOOL',
        CONFIRM_ACTION: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_CONFIRM_ACTION',
        SUCCESS_SNACKBAR: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_SUCCESS_SNACKBAR',
        SUCCESS_SNACKBAR_TOOL: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_SUCCESS_SNACKBAR_TOOL',
        SUCCESS_SNACKBAR_TOOL_ORG: 'PUBLISH_TO_ORG_UNPUBLISH_SUCCESS_SNACKBAR_TOOL',
        FAILURE_SNACKBAR: 'PUBLISH_TO_COMMUNITY_UNPUBLISH_FAILURE_SNACKBAR',
      },
      BANNER: {
        COPY_LINK: 'PUBLISH_TO_COMMUNITY_BANNER_COPY_LINK',
        VIEW_IN_COMMUNITY: 'PUBLISH_TO_COMMUNITY_BANNER_VIEW_IN_COMMUNITY',
        UNPUBLISH_MENU_ITEM: 'PUBLISH_TO_COMMUNITY_BANNER_UNPUBLISH_MENU_ITEM',
        UNPUBLISH_MENU_ITEM_ORG: 'PUBLISH_TO_COMMUNITY_BANNER_UNPUBLISH_MENU_ITEM_ORG',
        PUBLISHED: {
          TITLE: 'PUBLISH_TO_COMMUNITY_BANNER_PUBLISHED_TITLE',
          SUBTITLE: 'PUBLISH_TO_COMMUNITY_BANNER_PUBLISHED_SUBTITLE',
          TITLE_TOOL: 'PUBLISH_TO_COMMUNITY_BANNER_PUBLISHED_TITLE_TOOL',
          SUBTITLE_TOOL: 'PUBLISH_TO_COMMUNITY_BANNER_PUBLISHED_SUBTITLE_TOOL',
          SUBTITLE_TOOL_ORG: 'PUBLISH_TO_COMMUNITY_BANNER_PUBLISHED_SUBTITLE_TOOL_ORG',
        },
        PENDING: {
          TITLE: 'PUBLISH_TO_COMMUNITY_BANNER_PENDING_TITLE',
          SUBTITLE: 'PUBLISH_TO_COMMUNITY_BANNER_PENDING_SUBTITLE',
          TITLE_TOOL: 'PUBLISH_TO_COMMUNITY_BANNER_PENDING_TITLE_TOOL',
          SUBTITLE_TOOL: 'PUBLISH_TO_COMMUNITY_BANNER_PENDING_SUBTITLE_TOOL',
        },
        UPDATES_AVAILABLE: {
          TITLE: 'PUBLISH_TO_COMMUNITY_BANNER_UPDATES_AVAILABLE_TITLE',
          SUBTITLE: 'PUBLISH_TO_COMMUNITY_BANNER_UPDATES_AVAILABLE_SUBTITLE',
          PUBLISH_CHANGES: 'PUBLISH_TO_COMMUNITY_BANNER_UPDATES_AVAILABLE_PUBLISH_CHANGES',
          RELINK_FIGMA_ACCOUNT: 'PUBLISH_TO_COMMUNITY_BANNER_UPDATES_AVAILABLE_RELINK_FIGMA_ACCOUNT',
        },
      },
    },
    SHARE_BUTTON: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_SHARE_BUTTON',
    SHARE_BUTTON_LOADING: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_SHARE_BUTTON_LOADING',
    SUCCESS_MESSAGE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_SUCCESS_MESSAGE',
    TITLE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_TITLE',
    OWNER: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_OWNER',
    ACCESS_TITLE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_ACCESS_TITLE',
    REMOVE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_REMOVE',
    FREE_PLAN_TOOLTIP: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_TOOLTIP',
    FREE_PLAN_PAYWALL: {
      TITLE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_TITLE',
      SEE_ALL_PLANS: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_SEE_ALL_PLANS',
      LOOKING_FOR_MORE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_LOOKING_FOR_MORE',
      CURRENT_PLAN: {
        FEATURES: {
          VIDEO_MODELS: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_CURRENT_PLAN_FEATURES_VIDEO_MODELS',
          EDITING_TOOLS: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_CURRENT_PLAN_FEATURES_EDITING_TOOLS',
          WORKFLOWS: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_CURRENT_PLAN_FEATURES_WORKFLOWS',
          HISTORY: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_CURRENT_PLAN_FEATURES_HISTORY',
        },
      },
      TARGET_PLAN: {
        FEATURES: {
          VIDEO_MODELS: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_TARGET_PLAN_FEATURES_VIDEO_MODELS',
          WORKFLOWS: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_TARGET_PLAN_FEATURES_WORKFLOWS',
          TOP_UP: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_FREE_PLAN_PAYWALL_TARGET_PLAN_FEATURES_TOP_UP',
        },
      },
    },
    TOOL_SCOPE_NOTE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_TOOL_SCOPE_NOTE',
    TOOL_SCOPE_NOTE_ACTION: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_TOOL_SCOPE_NOTE_ACTION',
    TOOL_EXPOSED_NOTE: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_TOOL_EXPOSED_NOTE',
    TOOL_EXPOSED_NOTE_DETAIL: 'SHARED_DESIGN_APP_SHARE_WORKFLOW_MODAL_TOOL_EXPOSED_NOTE_DETAIL',
  },
  SIGN_IN_PAGE: {
    CANT_SIGN_IN_MESSAGE: 'SIGN_IN_PAGE_CANT_SIGN_IN_MESSAGE',
    GOOGLE_SIGN_IN_BUTTON: 'SIGN_IN_PAGE_GOOGLE_SIGN_IN_BUTTON',
    MICROSOFT_SIGN_IN_BUTTON: 'SIGN_IN_PAGE_MICROSOFT_SIGN_IN_BUTTON',
    FIGMA_SIGN_IN_BUTTON: 'SIGN_IN_PAGE_FIGMA_SIGN_IN_BUTTON',
    OR: 'SIGN_IN_PAGE_OR',
    TITLE: 'SIGN_IN_PAGE_TITLE',
    SUBTITLE: 'SIGN_IN_PAGE_SUBTITLE',
    TERMS_TEXT: 'SIGN_IN_PAGE_TERMS_TEXT',
    TERMS_OF_SERVICE_LINK: 'SIGN_IN_PAGE_TERMS_OF_SERVICE_LINK',
    PRIVACY_POLICY_LINK: 'SIGN_IN_PAGE_PRIVACY_POLICY_LINK',
    TERMS_MESSAGE: 'SIGN_IN_PAGE_TERMS_MESSAGE',
    SIGN_IN_BLOCKED: 'SIGN_IN_PAGE_SIGN_IN_BLOCKED',
    EMAIL_PASSWORD_LOGIN_NOT_ALLOWED: 'SIGN_IN_EMAIL_PASSWORD_LOGIN_NOT_ALLOWED',
    TURNSTILE_RETRY: 'SIGN_IN_PAGE_TURNSTILE_RETRY',
    TURNSTILE_SLOW: 'SIGN_IN_PAGE_TURNSTILE_SLOW',
    TURNSTILE_UNAVAILABLE: 'SIGN_IN_PAGE_TURNSTILE_UNAVAILABLE',
    SIGNUP_RATE_LIMITED: 'SIGN_IN_PAGE_SIGNUP_RATE_LIMITED',
    TOS_DIALOG_TITLE: 'SIGN_IN_PAGE_TOS_DIALOG_TITLE',
    TOS_DIALOG_BODY: 'SIGN_IN_PAGE_TOS_DIALOG_BODY',
    TOS_DIALOG_ACCEPT_BUTTON: 'SIGN_IN_PAGE_TOS_DIALOG_ACCEPT_BUTTON',
  },
  UPGRADE_MODAL: {
    CTA: 'UPGRADE_MODEL_CTA',
    TITLE: 'UPGRADE_MODEL_TITLE',
  },
  UPLOAD_LORA_NODE: {
    DEFAULT_WEIGHT: 'DEFAULT_WEIGHT',
    TRIGGER: 'TRIGGER',
    UPLOADING: 'UPLOAD_LORA_NODE_UPLOADING',
    UPLOAD_ANOTHER_BUTTON_TEXT_FILE: 'UPLOAD_LORA_NODE_UPLOAD_ANOTHER_BUTTON_TEXT_FILE',
    UPLOAD_BUTTON_TEXT: 'UPLOAD_LORA_NODE_UPLOAD_BUTTON_TEXT',
    UPLOAD_TITLE: 'UPLOAD_LORA_NODE_UPLOAD_TITLE',
    EDIT_TITLE: 'UPLOAD_LORA_NODE_EDIT_TITLE',
  },
  WEAVY_MARKETING: {
    CARDS: {
      SOFT_LAUNCH_INVITE: {
        SUBTITLE: 'MARKETING_CARDS_SOFT_LAUNCH_INVITE_SUBTITLE',
        TITLE: 'MARKETING_CARDS_SOFT_LAUNCH_INVITE_TITLE',
      },
    },
    DASHBOARD_BANNER: {
      SOFT_LAUNCH_INVITE: {
        SUBTITLE: 'MARKETING_DASHBOARD_BANNER_SOFT_LAUNCH_INVITE_SUBTITLE',
        TITLE: 'MARKETING_DASHBOARD_BANNER_SOFT_LAUNCH_INVITE_TITLE',
      },
    },
    APP_BANNER: {
      HOLIDAY_PROMO: {
        TITLE: 'MARKETING_DASHBOARD_BANNER_HOLIDAY_PROMO_TITLE',
        SUBTITLE: 'MARKETING_DASHBOARD_BANNER_HOLIDAY_PROMO_SUBTITLE',
        DISCLAIMER: 'MARKETING_DASHBOARD_BANNER_HOLIDAY_PROMO_DISCLAIMER',
      },
    },
    MODALS: {
      CONSENT: {
        TITLE: 'MARKETING_MODALS_CONSENT_TITLE',
        BODY: 'MARKETING_MODALS_CONSENT_BODY',
        DECLINE: 'MARKETING_MODALS_CONSENT_DECLINE',
        ACCEPT: 'MARKETING_MODALS_CONSENT_ACCEPT',
      },
      SOFT_LAUNCH_INVITE: {
        CONTENT_BOTTOM: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_CONTENT_BOTTOM',
        CONTENT_TOP: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_CONTENT_TOP',
        ERROR_EMAIL_ALREADY_INVITED: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_ERROR_EMAIL_ALREADY_INVITED',
        INVITE_BUTTON: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_INVITE_BUTTON',
        PLACEHOLDER: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_PLACEHOLDER',
        SENT: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_SENT',
        TITLE: 'MARKETING_MODALS_SOFT_LAUNCH_INVITE_TITLE',
      },
    },
  },
  DASHBOARD: {
    SCOPE: {
      MY_WORKFLOWS: 'DASHBOARD_SCOPE_MY_WORKFLOWS',
      WORKSPACE_WORKFLOWS: 'DASHBOARD_SCOPE_WORKSPACE_WORKFLOWS',
      MY_TOOLS: 'DASHBOARD_SCOPE_MY_TOOLS',
      WORKSPACE_TOOLS: 'DASHBOARD_SCOPE_WORKSPACE_TOOLS',
      SHARED_WITH_ME: 'DASHBOARD_SCOPE_SHARED_WITH_ME',
    },
    VIEW_LAYOUT: {
      ARIA: 'DASHBOARD_VIEW_LAYOUT_ARIA',
      LIST_ARIA: 'DASHBOARD_VIEW_LAYOUT_LIST_ARIA',
      GRID_ARIA: 'DASHBOARD_VIEW_LAYOUT_GRID_ARIA',
    },
    DUPLICATE_SUCCESS: 'DASHBOARD_DUPLICATE_SUCCESS',
    DUPLICATE_SUCCESS_ACTION: 'DASHBOARD_DUPLICATE_SUCCESS_ACTION',
    DUPLICATE_SUCCESS_WORKFLOW: 'DASHBOARD_DUPLICATE_SUCCESS_WORKFLOW',
    DUPLICATE_ERROR: 'DASHBOARD_DUPLICATE_ERROR',
    PAGES: {
      FILES: {
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_FILES_EMPTY_STATE_TITLE',
          DESCRIPTION: 'DASHBOARD_PAGES_FILES_EMPTY_STATE_DESCRIPTION',
          ACTION: 'DASHBOARD_PAGES_FILES_EMPTY_STATE_ACTION',
        },
        TITLE: 'DASHBOARD_PAGES_FILES_TITLE',
        RECIPE_CARD: {
          SUBTITLE_CREATED: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_SUBTITLE_CREATED',
          SUBTITLE_LAST_EDITED: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_SUBTITLE_LAST_EDITED',
          OWNED_BY_YOU: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_OWNED_BY_YOU',
          OWNED_BY_OTHER: 'DASHBOARD_PAGES_FILES_RECIPE_CARD_OWNED_BY_OTHER',
        },
        FOLDER_CARD: {
          FILE_COUNT_SINGULAR: 'DASHBOARD_PAGES_FILES_FOLDER_CARD_FILE_COUNT_SINGULAR',
          FILE_COUNT_PLURAL: 'DASHBOARD_PAGES_FILES_FOLDER_CARD_FILE_COUNT_PLURAL',
        },
      },
      SHARED_WITH_ME: {
        TITLE: 'DASHBOARD_PAGES_SHARED_WITH_ME_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_SHARED_WITH_ME_EMPTY_STATE_TITLE',
          ACTION: 'DASHBOARD_PAGES_SHARED_WITH_ME_EMPTY_STATE_ACTION',
        },
      },
      WORKSPACE_FILES: {
        TITLE: 'DASHBOARD_PAGES_WORKSPACE_FILES_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_WORKSPACE_FILES_EMPTY_STATE_TITLE',
          ACTION: 'DASHBOARD_PAGES_WORKSPACE_FILES_EMPTY_STATE_ACTION',
        },
      },
      WORKFLOWS: {
        TITLE: 'DASHBOARD_PAGES_WORKFLOWS_TITLE',
        EMPTY_STATE: {
          SHARED: 'DASHBOARD_PAGES_WORKFLOWS_EMPTY_STATE_SHARED',
          WORKSPACE: 'DASHBOARD_PAGES_WORKFLOWS_EMPTY_STATE_WORKSPACE',
          WORKSPACE_DESCRIPTION: 'DASHBOARD_PAGES_WORKFLOWS_EMPTY_STATE_WORKSPACE_DESCRIPTION',
        },
      },
      TOOLS: {
        TITLE: 'DASHBOARD_PAGES_TOOLS_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_TOOLS_EMPTY_STATE_TITLE',
          SHARED: 'DASHBOARD_PAGES_TOOLS_EMPTY_STATE_SHARED',
          WORKSPACE: 'DASHBOARD_PAGES_TOOLS_EMPTY_STATE_WORKSPACE',
          WORKSPACE_DESCRIPTION: 'DASHBOARD_PAGES_TOOLS_EMPTY_STATE_WORKSPACE_DESCRIPTION',
        },
      },
      SHARED_APPS: {
        TITLE: 'DASHBOARD_PAGES_SHARED_APPS_TITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_SHARED_APPS_EMPTY_STATE_TITLE',
          ACTION: 'DASHBOARD_PAGES_SHARED_APPS_EMPTY_STATE_ACTION',
        },
      },
      ARCHIVE: {
        TITLE: 'DASHBOARD_PAGES_ARCHIVE_TITLE',
        SUBTITLE: 'DASHBOARD_PAGES_ARCHIVE_SUBTITLE',
        RESTORE: 'DASHBOARD_PAGES_ARCHIVE_RESTORE',
        RESTORE_ERROR: 'DASHBOARD_PAGES_ARCHIVE_RESTORE_ERROR',
        RESTORE_WORKFLOW_SUCCESS: 'DASHBOARD_PAGES_ARCHIVE_RESTORE_WORKFLOW_SUCCESS',
        RESTORE_FOLDER_SUCCESS: 'DASHBOARD_PAGES_ARCHIVE_RESTORE_FOLDER_SUCCESS',
        DELETED_AT: 'DASHBOARD_PAGES_ARCHIVE_DELETED_AT',
        DELETED_AT_HEADER: 'DASHBOARD_PAGES_ARCHIVE_DELETED_AT_HEADER',
        EMPTY_STATE: {
          DESCRIPTION: 'DASHBOARD_PAGES_ARCHIVE_EMPTY_STATE_DESCRIPTION',
        },
      },
      COMMUNITY: {
        TITLE: 'DASHBOARD_PAGES_COMMUNITY_TITLE',
        SUBTITLE: 'DASHBOARD_PAGES_COMMUNITY_SUBTITLE',
        MODEL_SAVED: 'DASHBOARD_PAGES_COMMUNITY_MODEL_SAVED',
        CONTEXT_MENU: {
          SAVE_TO_MY_MODELS: 'DASHBOARD_PAGES_COMMUNITY_CONTEXT_MENU_SAVE_TO_MY_MODELS',
        },
        MODEL_CARD: {
          CREATOR: 'DASHBOARD_PAGES_COMMUNITY_MODELS_CREATOR',
          BASED_ON: 'DASHBOARD_PAGES_COMMUNITY_MODELS_BASED_ON',
        },
      },
      MY_MODELS: {
        TITLE: 'DASHBOARD_PAGES_MY_MODELS_TITLE',
        SUBTITLE: 'DASHBOARD_PAGES_MY_MODELS_SUBTITLE',
        EMPTY_STATE: {
          TITLE: 'DASHBOARD_PAGES_MY_MODELS_EMPTY_STATE_TITLE',
          DESCRIPTION: 'DASHBOARD_PAGES_MY_MODELS_EMPTY_STATE_DESCRIPTION',
          ACTION: 'DASHBOARD_PAGES_MY_MODELS_EMPTY_STATE_ACTION',
        },
        DELETE_DIALOG_TITLE: 'DASHBOARD_PAGES_MY_MODELS_DELETE_DIALOG_TITLE',
      },
    },
  },
  VIDEO_PREVIEW: {
    CHANGE_TO_TIMECODE: 'VIDEO_PREVIEW_CHANGE_TO_TIMECODE',
    CHANGE_TO_FRAMES: 'VIDEO_PREVIEW_CHANGE_TO_FRAMES',
    FRAMES: 'VIDEO_PREVIEW_FRAMES',
  },
  TASK_MANAGER: {
    TITLE: 'TASK_MANAGER_TITLE',
    BATCH_NAME: 'TASK_MANAGER_BATCH_NAME',
    RUNNING_TEXT: 'TASK_MANAGER_RUNNING_TEXT',
    DONE: 'TASK_MANAGER_DONE',
    CANCELLED_TEXT: 'TASK_MANAGER_CANCELLED_TEXT',
    FAILED_TEXT: 'TASK_MANAGER_FAILED_TEXT',
    FAILED_TEXT_NO_REFUND: 'TASK_MANAGER_FAILED_TEXT_NO_REFUND',
    FAILED_STILL_RUNNING: 'TASK_MANAGER_FAILED_STILL_RUNNING',
    // Legacy (flag-off) copy — kept verbatim from pre-migration; remove with the flag-off branch.
    FAILED_TEXT_LEGACY: 'TASK_MANAGER_FAILED_TEXT_LEGACY',
    FAILED_TEXT_NO_REFUND_LEGACY: 'TASK_MANAGER_FAILED_TEXT_NO_REFUND_LEGACY',
    FAILED_STILL_RUNNING_LEGACY: 'TASK_MANAGER_FAILED_STILL_RUNNING_LEGACY',
    EMPTY_STATE: 'TASK_MANAGER_EMPTY_STATE',
    CLEAR_ALL: 'TASK_MANAGER_CLEAR_ALL',
    NO_ACTIVE_RUNS: 'TASK_MANAGER_NO_ACTIVE_RUNS',
    INITIALIZING: 'TASK_MANAGER_INITIALIZING',
    UPLOADING: 'TASK_MANAGER_UPLOADING',
    TASKS: 'TASK_MANAGER_TASKS',
    BATCH_COMPLETED: 'TASK_MANAGER_BATCH_COMPLETED',
    QUEUED: 'TASK_MANAGER_QUEUED',
  },
  SHORTCUTS: {
    PANEL_TITLE: 'SHORTCUTS_PANEL_TITLE',
    OR: 'SHORTCUTS_OR',
    SEARCH_PLACEHOLDER: 'SHORTCUTS_SEARCH_PLACEHOLDER',
    SEARCH_RESULTS: 'SHORTCUTS_SEARCH_RESULTS',
    SEARCH_NO_RESULTS: 'SHORTCUTS_SEARCH_NO_RESULTS',
    SCROLL_TABS_BACK: 'SHORTCUTS_SCROLL_TABS_BACK',
    SCROLL_TABS_FORWARD: 'SHORTCUTS_SCROLL_TABS_FORWARD',
    RESIZE_PANEL: 'SHORTCUTS_RESIZE_PANEL',
    CONTEXTS: {
      WITH_NODES_SELECTED: 'SHORTCUTS_CONTEXTS_WITH_NODES_SELECTED',
      WITH_GROUPS_SELECTED: 'SHORTCUTS_CONTEXTS_WITH_GROUPS_SELECTED',
      WITH_LAYERS_SELECTED: 'SHORTCUTS_CONTEXTS_WITH_LAYERS_SELECTED',
      AFTER_MARKING_SECTIONS: 'SHORTCUTS_CONTEXTS_AFTER_MARKING_SECTIONS',
      IN_APP_VIEW: 'SHORTCUTS_CONTEXTS_IN_APP_VIEW',
      IN_TIMELINE: 'SHORTCUTS_CONTEXTS_IN_TIMELINE',
      WHEN_HOVERING_A_NODE: 'SHORTCUTS_CONTEXTS_WHEN_HOVERING_A_NODE',
      IN_GALLERY: 'SHORTCUTS_CONTEXTS_IN_GALLERY',
      IN_PROMPT: 'SHORTCUTS_CONTEXTS_IN_PROMPT',
    },
    SECTIONS: {
      VIEW_AND_ZOOM: 'SHORTCUTS_SECTIONS_VIEW_AND_ZOOM',
      NAVIGATION: 'SHORTCUTS_SECTIONS_NAVIGATION',
      NODE_ACTIONS: 'SHORTCUTS_SECTIONS_NODE_ACTIONS',
      SELECTION: 'SHORTCUTS_SECTIONS_SELECTION',
      CREATION: 'SHORTCUTS_SECTIONS_CREATION',
      EDITING: 'SHORTCUTS_SECTIONS_EDITING',
      TIMELINE: 'SHORTCUTS_SECTIONS_TIMELINE',
      COMPOSITOR: 'SHORTCUTS_SECTIONS_COMPOSITOR',
    },
    ZOOM_IN: 'SHORTCUT_ZOOM_IN',
    ZOOM_OUT: 'SHORTCUT_ZOOM_OUT',
    NAVIGATION_MARK_NODES: 'SHORTCUT_NAVIGATION_MARK_NODES',
    NAVIGATION_NAVIGATE_TO_NODES: 'SHORTCUT_NAVIGATION_NAVIGATE_TO_NODES',
    ZOOM_100: 'SHORTCUT_ZOOM_100',
    ZOOM_TO_FIT: 'SHORTCUT_ZOOM_TO_FIT',
    SELECT_ALL_NODES: 'SHORTCUT_SELECT_ALL_NODES',
    CLEAR_SELECTION: 'SHORTCUT_CLEAR_SELECTION',
    RUN_MODEL: 'SHORTCUT_RUN_MODEL',
    GROUP_SELECTION: 'SHORTCUT_GROUP_SELECTION',
    RESIZE_GROUP_TO_FIT: 'SHORTCUT_RESIZE_GROUP_TO_FIT',
    MOVE: 'SHORTCUT_MOVE',
    PAN: 'SHORTCUT_PAN',
    COMMENT_MODE: 'SHORTCUT_COMMENT_MODE',
    TOGGLE_COMMENTS: 'SHORTCUT_TOGGLE_COMMENTS',
    UNDO: 'SHORTCUT_UNDO',
    REDO: 'SHORTCUT_REDO',
    SAVE_WORKFLOW: 'SHORTCUT_SAVE_WORKFLOW',
    COPY_NODES: 'SHORTCUT_COPY_NODES',
    CUT_NODES: 'SHORTCUT_CUT_NODES',
    PASTE_NODES: 'SHORTCUT_PASTE_NODES',
    OPEN_NODE: 'SHORTCUT_OPEN_NODE',
    DUPLICATE_NODES: 'SHORTCUT_DUPLICATE_NODES',
    DUPLICATE_NODES_PRESERVING_INPUTS: 'SHORTCUT_DUPLICATE_NODES_PRESERVING_INPUTS',
    DELETE_SELECTION: 'SHORTCUT_DELETE_SELECTION',
    DELETE_SELECTION_PRESERVING_CONNECTIONS: 'SHORTCUT_DELETE_SELECTION_PRESERVING_CONNECTIONS',
    NUDGE_SELECTION: 'SHORTCUT_NUDGE_SELECTION',
    NUDGE_SELECTION_FAST: 'SHORTCUT_NUDGE_SELECTION_FAST',
    OPEN_FLOAT_MENU: 'SHORTCUT_OPEN_FLOAT_MENU',
    OPEN_SHORTCUTS_PANEL: 'SHORTCUT_OPEN_SHORTCUTS_PANEL',
    CREATE_IMPORT_NODE: 'SHORTCUT_CREATE_IMPORT_NODE',
    CREATE_PROMPT_NODE: 'SHORTCUT_CREATE_PROMPT_NODE',
    RECTANGLE: 'SHORTCUT_RECTANGLE',
    ELLIPSE: 'SHORTCUT_ELLIPSE',
    TEXT: 'SHORTCUT_TEXT',
    TIMELINE_MOVE_LAYER_START_TO_PLAYHEAD: 'SHORTCUT_TIMELINE_MOVE_LAYER_START_TO_PLAYHEAD',
    TIMELINE_MOVE_LAYER_END_TO_PLAYHEAD: 'SHORTCUT_TIMELINE_MOVE_LAYER_END_TO_PLAYHEAD',
    TIMELINE_MOVE_PLAYHEAD_ONE_FRAME: 'SHORTCUT_TIMELINE_MOVE_PLAYHEAD_ONE_FRAME',
    TIMELINE_MOVE_PLAYHEAD_TEN_FRAMES: 'SHORTCUT_TIMELINE_MOVE_PLAYHEAD_TEN_FRAMES',
    TIMELINE_JUMP_TO_START_END: 'SHORTCUT_TIMELINE_JUMP_TO_START_END',
    TIMELINE_PLAY_PAUSE: 'SHORTCUT_TIMELINE_PLAY_PAUSE',
    GROUP_LAYERS: 'SHORTCUT_GROUP_LAYERS',
    UNGROUP_LAYERS: 'SHORTCUT_UNGROUP_LAYERS',
    DELETE_LAYERS: 'SHORTCUT_DELETE_LAYERS',
    EXIT_APP_MODE: 'SHORTCUT_EXIT_APP_MODE',
    PAN_WHILE_DRAGGING: 'SHORTCUT_PAN_WHILE_DRAGGING',
    ZOOM_WITH_SCROLL: 'SHORTCUT_ZOOM_WITH_SCROLL',
    ZOOM_TOOL_IN: 'SHORTCUT_ZOOM_TOOL_IN',
    ZOOM_TOOL_OUT: 'SHORTCUT_ZOOM_TOOL_OUT',
    ZOOM_TOOL_AREA: 'SHORTCUT_ZOOM_TOOL_AREA',
    GALLERY_PREVIOUS_NEXT: 'SHORTCUT_GALLERY_PREVIOUS_NEXT',
    GALLERY_CLOSE: 'SHORTCUT_GALLERY_CLOSE',
    DUPLICATE_BY_DRAGGING: 'SHORTCUT_DUPLICATE_BY_DRAGGING',
    CONNECT_BY_PROXIMITY: 'SHORTCUT_CONNECT_BY_PROXIMITY',
    DELETE_CONNECTIONS_BY_DRAGGING: 'SHORTCUT_DELETE_CONNECTIONS_BY_DRAGGING',
    REMOVE_FROM_GROUP_BY_DRAGGING: 'SHORTCUT_REMOVE_FROM_GROUP_BY_DRAGGING',
    ADD_TO_SELECTION: 'SHORTCUT_ADD_TO_SELECTION',
    PROMPT_MENTION_INPUT: 'SHORTCUT_PROMPT_MENTION_INPUT',
    PROMPT_ACCEPT_SUGGESTION: 'SHORTCUT_PROMPT_ACCEPT_SUGGESTION',
    VECTOR_TOOL: 'SHORTCUT_VECTOR_TOOL',
    TOGGLE_PAN_MODE: 'SHORTCUT_TOGGLE_PAN_MODE',
    SELECT_ALL_LAYERS: 'SHORTCUT_SELECT_ALL_LAYERS',
    PASTE_LAYERS: 'SHORTCUT_PASTE_LAYERS',
    CLOSE_COMPOSITOR: 'SHORTCUT_CLOSE_COMPOSITOR',
    COPY_LAYERS: 'SHORTCUT_COPY_LAYERS',
    DUPLICATE_LAYERS: 'SHORTCUT_DUPLICATE_LAYERS',
  },
  NODES: {
    MODELS: {
      DYNAMIC_HANDLES: {
        IMAGE_URLS: {
          KEY: 'NODES_MODELS_DYNAMIC_HANDLES_IMAGE_URLS_KEY',
          DESCRIPTION: 'NODES_MODELS_DYNAMIC_HANDLES_IMAGE_URLS_DESCRIPTION',
        },
      },
    },
  },
  CSV_COLUMN_DIALOG: {
    TITLE: 'CSV_COLUMN_DIALOG_TITLE',
    DESCRIPTION: 'CSV_COLUMN_DIALOG_DESCRIPTION',
    COLUMN_LABEL: 'CSV_COLUMN_DIALOG_COLUMN_LABEL',
    COLUMN_ARIA_LABEL: 'CSV_COLUMN_DIALOG_COLUMN_ARIA_LABEL',
    COLUMN_PLACEHOLDER: 'CSV_COLUMN_DIALOG_COLUMN_PLACEHOLDER',
    CANCEL: 'CSV_COLUMN_DIALOG_CANCEL',
    CONFIRM: 'CSV_COLUMN_DIALOG_CONFIRM',
    ERROR_EMPTY: 'CSV_COLUMN_DIALOG_ERROR_EMPTY',
    ERROR_PARSE: 'CSV_COLUMN_DIALOG_ERROR_PARSE',
    WARNING_TRUNCATED: 'CSV_COLUMN_DIALOG_WARNING_TRUNCATED',
  },
  TOOL_VIEW: {
    RECOVERY: {
      NO_ACCESS_TITLE: 'TOOL_VIEW_RECOVERY_NO_ACCESS_TITLE',
      NO_ACCESS_BODY: 'TOOL_VIEW_RECOVERY_NO_ACCESS_BODY',
      NOT_FOUND_TITLE: 'TOOL_VIEW_RECOVERY_NOT_FOUND_TITLE',
      NOT_FOUND_BODY: 'TOOL_VIEW_RECOVERY_NOT_FOUND_BODY',
      LOAD_ERROR_TITLE: 'TOOL_VIEW_RECOVERY_LOAD_ERROR_TITLE',
      LOAD_ERROR_BODY: 'TOOL_VIEW_RECOVERY_LOAD_ERROR_BODY',
      UNAVAILABLE_TITLE: 'TOOL_VIEW_RECOVERY_UNAVAILABLE_TITLE',
      UNAVAILABLE_BODY: 'TOOL_VIEW_RECOVERY_UNAVAILABLE_BODY',
      RUN_LOAD_ERROR_BODY: 'TOOL_VIEW_RECOVERY_RUN_LOAD_ERROR_BODY',
      BACK_TO_DASHBOARD: 'TOOL_VIEW_RECOVERY_BACK_TO_DASHBOARD',
      RETRY: 'TOOL_VIEW_RECOVERY_RETRY',
    },
    REQUIRED_FIELDS: 'TOOL_VIEW_REQUIRED_FIELDS',
    NOT_FOUND: 'TOOL_VIEW_NOT_FOUND',
    LOAD_ERROR: 'TOOL_VIEW_LOAD_ERROR',
    COULDNT_LOAD: 'TOOL_VIEW_COULDNT_LOAD',
    UNAVAILABLE_TITLE: 'TOOL_VIEW_UNAVAILABLE_TITLE',
    UNAVAILABLE_BODY: 'TOOL_VIEW_UNAVAILABLE_BODY',
    UNTITLED: 'TOOL_VIEW_UNTITLED',
    RUN: 'TOOL_VIEW_RUN',
    RE_RUN: 'TOOL_VIEW_RE_RUN',
    SIGN_IN_TO_RUN: 'TOOL_VIEW_SIGN_IN_TO_RUN',
    OPEN_WORKFLOW: 'TOOL_VIEW_OPEN_WORKFLOW',
    PREVIEW: 'TOOL_VIEW_PREVIEW',
    PREVIEW_NOTICE: 'TOOL_VIEW_PREVIEW_NOTICE',
    PREVIEW_OUTPUTS_NOT_SAVED: 'TOOL_VIEW_PREVIEW_OUTPUTS_NOT_SAVED',
    LAST_PUBLISHED: 'TOOL_VIEW_LAST_PUBLISHED',
    PREVIEW_PUBLISH: 'TOOL_VIEW_PREVIEW_PUBLISH',
    BACK_TO_EDITING: 'TOOL_VIEW_BACK_TO_EDITING',
    HIDE_SIDEBAR: 'TOOL_VIEW_HIDE_SIDEBAR',
    SHOW_SIDEBAR: 'TOOL_VIEW_SHOW_SIDEBAR',
    VIEW_TOOL: 'TOOL_VIEW_VIEW_TOOL',
    BY_AUTHOR: 'TOOL_VIEW_BY_AUTHOR',
    VIEW_MORE: 'TOOL_VIEW_VIEW_MORE',
    VIEW_LESS: 'TOOL_VIEW_VIEW_LESS',
    EMPTY_TITLE: 'TOOL_VIEW_EMPTY_TITLE',
    EMPTY_SUBTITLE: 'TOOL_VIEW_EMPTY_SUBTITLE',
    EXAMPLE_OUTPUTS: 'TOOL_VIEW_EXAMPLE_OUTPUTS',
    SHOW_ALL_EXAMPLES: 'TOOL_VIEW_SHOW_ALL_EXAMPLES',
    OPEN_EXAMPLE: 'TOOL_VIEW_OPEN_EXAMPLE',
  },
  TOOL_SHARE: {
    TITLE: 'TOOL_SHARE_TITLE',
    ACCESS_TITLE: 'TOOL_SHARE_ACCESS_TITLE',
    EMAIL_PLACEHOLDER: 'TOOL_SHARE_EMAIL_PLACEHOLDER',
    SUCCESS_MESSAGE: 'TOOL_SHARE_SUCCESS_MESSAGE',
    SHARE_BUTTON: 'TOOL_SHARE_SHARE_BUTTON',
    INVITE_BUTTON: 'TOOL_SHARE_INVITE_BUTTON',
    PUBLISH_FIRST: 'TOOL_SHARE_PUBLISH_FIRST',
    ERROR_MESSAGE: 'TOOL_SHARE_ERROR_MESSAGE',
    WORKFLOW_SCOPE_NOTE: 'TOOL_SHARE_WORKFLOW_SCOPE_NOTE',
    WORKFLOW_SCOPE_NOTE_ACTION: 'TOOL_SHARE_WORKFLOW_SCOPE_NOTE_ACTION',
    WORKFLOW_EXPOSED_NOTE: 'TOOL_SHARE_WORKFLOW_EXPOSED_NOTE',
    WORKFLOW_EXPOSED_NOTE_DETAIL: 'TOOL_SHARE_WORKFLOW_EXPOSED_NOTE_DETAIL',
  },
  COMMUNITY_EMBED_TOOL: {
    MISSING_TOOL_ID: 'COMMUNITY_EMBED_TOOL_MISSING_TOOL_ID',
    SIGN_IN_REQUIRED: 'COMMUNITY_EMBED_TOOL_SIGN_IN_REQUIRED',
  },
  COMMUNITY_EMBED_WORKFLOW: {
    MISSING_WORKFLOW_ID: 'COMMUNITY_EMBED_WORKFLOW_MISSING_WORKFLOW_ID',
    SIGN_IN_REQUIRED: 'COMMUNITY_EMBED_WORKFLOW_SIGN_IN_REQUIRED',
  },
  SECURITY_CHALLENGE: {
    TITLE: 'SECURITY_CHALLENGE_TITLE',
    BODY: 'SECURITY_CHALLENGE_BODY',
    SLOW_NOTICE_TITLE: 'SECURITY_CHALLENGE_SLOW_NOTICE_TITLE',
    SLOW_NOTICE_BODY: 'SECURITY_CHALLENGE_SLOW_NOTICE_BODY',
    FAILURE_ERROR_TITLE: 'SECURITY_CHALLENGE_FAILURE_ERROR_TITLE',
    FAILURE_ERROR_BODY: 'SECURITY_CHALLENGE_FAILURE_ERROR_BODY',
    FAILURE_UNAVAILABLE_TITLE: 'SECURITY_CHALLENGE_FAILURE_UNAVAILABLE_TITLE',
    FAILURE_UNAVAILABLE_BODY: 'SECURITY_CHALLENGE_FAILURE_UNAVAILABLE_BODY',
    FAILURE_EXHAUSTED_TITLE: 'SECURITY_CHALLENGE_FAILURE_EXHAUSTED_TITLE',
    FAILURE_EXHAUSTED_BODY: 'SECURITY_CHALLENGE_FAILURE_EXHAUSTED_BODY',
    FAILURE_CIRCUIT_OPEN_TITLE: 'SECURITY_CHALLENGE_FAILURE_CIRCUIT_OPEN_TITLE',
    FAILURE_CIRCUIT_OPEN_BODY: 'SECURITY_CHALLENGE_FAILURE_CIRCUIT_OPEN_BODY',
    FAILURE_BROWSER_HELP: 'SECURITY_CHALLENGE_FAILURE_BROWSER_HELP',
    RELOAD: 'SECURITY_CHALLENGE_RELOAD',
    INTERACTIVE_HELP: 'SECURITY_CHALLENGE_INTERACTIVE_HELP',
  },
  PAYWALLS: {
    FREE_PLAN_PAYWALL: {
      DESCRIPTION: 'PAYWALLS_FREE_PLAN_PAYWALL_DESCRIPTION',
    },
    VOICE_INPUT_PAYWALL: {
      TITLE: 'PAYWALLS_VOICE_INPUT_PAYWALL_TITLE',
      DESCRIPTION: 'PAYWALLS_VOICE_INPUT_PAYWALL_DESCRIPTION',
      FEATURES: {
        VOICE_DICTATION: 'PAYWALLS_VOICE_INPUT_PAYWALL_FEATURES_VOICE_DICTATION',
      },
    },
    VIDEO_MODEL_PAYWALL: {
      TITLE: 'PAYWALLS_VIDEO_MODEL_PAYWALL_TITLE',
      FULL_PRICING_DESCRIPTION: 'PAYWALLS_VIDEO_MODEL_PAYWALL_FULL_PRICING_DESCRIPTION',
    },
    CUSTOM_FONTS_PAYWALL: {
      TITLE: 'PAYWALLS_CUSTOM_FONTS_PAYWALL_TITLE',
      DESCRIPTION: 'PAYWALLS_CUSTOM_FONTS_PAYWALL_DESCRIPTION',
      FEATURES: {
        CUSTOM_FONTS: 'PAYWALLS_CUSTOM_FONTS_PAYWALL_FEATURES_CUSTOM_FONTS',
      },
    },
  },
  TOOLKIT: {
    BANNER_TITLE: 'TOOLKIT_BANNER_TITLE',
    BANNER_SUBTITLE: 'TOOLKIT_BANNER_SUBTITLE',
    SEARCH_PLACEHOLDER: 'TOOLKIT_SEARCH_PLACEHOLDER',
    USE_TOOL: 'TOOLKIT_USE_TOOL',
    SHOW_ALL: 'TOOLKIT_SHOW_ALL',
    SHOW_LESS: 'TOOLKIT_SHOW_LESS',
    PREVIOUS_IN_ROW: 'TOOLKIT_PREVIOUS_IN_ROW',
    NEXT_IN_ROW: 'TOOLKIT_NEXT_IN_ROW',
    NO_RESULTS_TITLE: 'TOOLKIT_NO_RESULTS_TITLE',
    NO_RESULTS: 'TOOLKIT_NO_RESULTS',
    EXPLORE_ALL: 'TOOLKIT_EXPLORE_ALL',
    LOAD_FAILED: 'TOOLKIT_LOAD_FAILED',
    TOOL_NOT_FOUND: 'TOOLKIT_TOOL_NOT_FOUND',
    GENERATOR_TITLE: 'TOOLKIT_GENERATOR_TITLE',
    GENERATOR_SUBTITLE: 'TOOLKIT_GENERATOR_SUBTITLE',
    GENERATOR_IMAGES_TITLE: 'TOOLKIT_GENERATOR_IMAGES_TITLE',
    GENERATOR_IMAGES_DESCRIPTION: 'TOOLKIT_GENERATOR_IMAGES_DESCRIPTION',
    GENERATOR_IMAGES_ACTION: 'TOOLKIT_GENERATOR_IMAGES_ACTION',
    GENERATOR_VIDEOS_TITLE: 'TOOLKIT_GENERATOR_VIDEOS_TITLE',
    GENERATOR_VIDEOS_DESCRIPTION: 'TOOLKIT_GENERATOR_VIDEOS_DESCRIPTION',
    GENERATOR_VIDEOS_ACTION: 'TOOLKIT_GENERATOR_VIDEOS_ACTION',
  },
  GENERATE_PAGE: {
    HOME: 'GENERATE_PAGE_HOME',
    BACK: 'GENERATE_PAGE_BACK',
    BACK_TO: 'GENERATE_PAGE_BACK_TO',
    TITLE: 'GENERATE_PAGE_TITLE',
    SUBTITLE: 'GENERATE_PAGE_SUBTITLE',
    LOADING: 'GENERATE_PAGE_LOADING',
    LOAD_ERROR: 'GENERATE_PAGE_LOAD_ERROR',
    RUN_ERROR_TITLE: 'GENERATE_PAGE_RUN_ERROR_TITLE',
    RUN_ERROR_RETRY: 'GENERATE_PAGE_RUN_ERROR_RETRY',
    RUN_ERROR_SOME: 'GENERATE_PAGE_RUN_ERROR_SOME',
    HISTORY_ERROR_TITLE: 'GENERATE_PAGE_HISTORY_ERROR_TITLE',
    CANCEL_ERROR_TITLE: 'GENERATE_PAGE_CANCEL_ERROR_TITLE',
    LOAD_MORE: 'GENERATE_PAGE_LOAD_MORE',
    PROMPT_BLOCKED_TITLE: 'GENERATE_PAGE_PROMPT_BLOCKED_TITLE',
    PROMPT_BLOCKED_MESSAGE: 'GENERATE_PAGE_PROMPT_BLOCKED_MESSAGE',
    NOT_ENOUGH_CREDITS_TITLE: 'GENERATE_PAGE_NOT_ENOUGH_CREDITS_TITLE',
    UPGRADE_LINK: 'GENERATE_PAGE_UPGRADE_LINK',
    MODEL_NOT_FOUND: 'GENERATE_PAGE_MODEL_NOT_FOUND',
    PROMPT_LABEL: 'GENERATE_PAGE_PROMPT_LABEL',
    PROMPT_PLACEHOLDER: 'GENERATE_PAGE_PROMPT_PLACEHOLDER',
    OUTPUT_TYPE: 'GENERATE_PAGE_OUTPUT_TYPE',
    IMAGE: 'GENERATE_PAGE_IMAGE',
    VIDEO: 'GENERATE_PAGE_VIDEO',
    IMAGE_OUTPUT: 'GENERATE_PAGE_IMAGE_OUTPUT',
    VIDEO_OUTPUT: 'GENERATE_PAGE_VIDEO_OUTPUT',
    MODEL: 'GENERATE_PAGE_MODEL',
    MODEL_SELECTION: 'GENERATE_PAGE_MODEL_SELECTION',
    SELECT_MODEL: 'GENERATE_PAGE_SELECT_MODEL',
    ATTACH: 'GENERATE_PAGE_ATTACH',
    REMOVE_ATTACHMENT: 'GENERATE_PAGE_REMOVE_ATTACHMENT',
    REFERENCE_SLOT: 'GENERATE_PAGE_REFERENCE_SLOT',
    REFERENCE_NAME: 'GENERATE_PAGE_REFERENCE_NAME',
    RESULT_NAME: 'GENERATE_PAGE_RESULT_NAME',
    FIRST_FRAME: 'GENERATE_PAGE_FIRST_FRAME',
    LAST_FRAME: 'GENERATE_PAGE_LAST_FRAME',
    ADD_FIRST_FRAME: 'GENERATE_PAGE_ADD_FIRST_FRAME',
    ADD_LAST_FRAME: 'GENERATE_PAGE_ADD_LAST_FRAME',
    FROM_GALLERY: 'GENERATE_PAGE_FROM_GALLERY',
    UPLOAD_FILE: 'GENERATE_PAGE_UPLOAD_FILE',
    CONFIRM: 'GENERATE_PAGE_CONFIRM',
    MAX_IMAGES_REACHED: 'GENERATE_PAGE_MAX_IMAGES_REACHED',
    MAX_REFERENCES_REACHED: 'GENERATE_PAGE_MAX_REFERENCES_REACHED',
    PANEL_MAX_IMAGES: 'GENERATE_PAGE_PANEL_MAX_IMAGES',
    PANEL_MAX_REFERENCES: 'GENERATE_PAGE_PANEL_MAX_REFERENCES',
    PANEL_MAX_VIDEOS: 'GENERATE_PAGE_PANEL_MAX_VIDEOS',
    IMAGE_MAX_REACHED: 'GENERATE_PAGE_IMAGE_MAX_REACHED',
    REFERENCE_MAX_REACHED: 'GENERATE_PAGE_REFERENCE_MAX_REACHED',
    VIDEO_MAX_REACHED: 'GENERATE_PAGE_VIDEO_MAX_REACHED',
    UP_TO_IMAGES: 'GENERATE_PAGE_UP_TO_IMAGES',
    UP_TO_REFERENCES: 'GENERATE_PAGE_UP_TO_REFERENCES',
    UP_TO_VIDEOS: 'GENERATE_PAGE_UP_TO_VIDEOS',
    MAX_UPLOAD_REACHED: 'GENERATE_PAGE_MAX_UPLOAD_REACHED',
    TRY_FEWER_IMAGES: 'GENERATE_PAGE_TRY_FEWER_IMAGES',
    TRY_FEWER_FILES: 'GENERATE_PAGE_TRY_FEWER_FILES',
    TRY_FEWER_VIDEOS: 'GENERATE_PAGE_TRY_FEWER_VIDEOS',
    WRONG_TYPE: 'GENERATE_PAGE_WRONG_TYPE',
    WRONG_IMAGE_FORMAT: 'GENERATE_PAGE_WRONG_IMAGE_FORMAT',
    FRAME_TAKES_ONE: 'GENERATE_PAGE_FRAME_TAKES_ONE',
    TYPES_IMAGES: 'GENERATE_PAGE_TYPES_IMAGES',
    TYPES_IMAGES_AND_VIDEOS: 'GENERATE_PAGE_TYPES_IMAGES_AND_VIDEOS',
    TYPES_MEDIA: 'GENERATE_PAGE_TYPES_MEDIA',
    INPUTS_REMOVED: 'GENERATE_PAGE_INPUTS_REMOVED',
    MODEL_DOESNT_TAKE: 'GENERATE_PAGE_MODEL_DOESNT_TAKE',
    FIRST_FRAME_NEEDED: 'GENERATE_PAGE_FIRST_FRAME_NEEDED',
    ADD_FIRST_FRAME_FIRST: 'GENERATE_PAGE_ADD_FIRST_FRAME_FIRST',
    PARAM_VALUE: 'GENERATE_PAGE_PARAM_VALUE',
    ON: 'GENERATE_PAGE_ON',
    OFF: 'GENERATE_PAGE_OFF',
    SECONDS_VALUE: 'GENERATE_PAGE_SECONDS_VALUE',
    SECONDS_UNIT: 'GENERATE_PAGE_SECONDS_UNIT',
    MORE_SETTINGS: 'GENERATE_PAGE_MORE_SETTINGS',
    ENABLE: 'GENERATE_PAGE_ENABLE',
    DISABLE: 'GENERATE_PAGE_DISABLE',
    RANDOM_SEED: 'GENERATE_PAGE_RANDOM_SEED',
    AUTO_DURATION: 'GENERATE_PAGE_AUTO_DURATION',
    AUTO_VALUE: 'GENERATE_PAGE_AUTO_VALUE',
    UPGRADE_TAG: 'GENERATE_PAGE_UPGRADE_TAG',
    NEW_TAG: 'GENERATE_PAGE_NEW_TAG',
    PAID_PLANS_ONLY: 'GENERATE_PAGE_PAID_PLANS_ONLY',
    COUNT: 'GENERATE_PAGE_COUNT',
    DECREASE_COUNT: 'GENERATE_PAGE_DECREASE_COUNT',
    INCREASE_COUNT: 'GENERATE_PAGE_INCREASE_COUNT',
    GENERATE: 'GENERATE_PAGE_GENERATE',
    SIGN_IN_TO_RUN: 'GENERATE_PAGE_SIGN_IN_TO_RUN',
  },
};
